webpackJsonp([10],{

/***/ "0NxX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return throttleToFrame; });

/**
 * Throttle function executions to frame rate.
 *
 * @param func Original function.
 * @returns Throttled function.
 */
// tslint:disable-next-line:ban-types
function throttleToFrame(func) {
    var running = false;
    var args;
    return function throttled() {
        var _this = this;
        var rest = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            rest[_i] = arguments[_i];
        }
        args = rest;
        if (running) {
            return;
        }
        running = true;
        requestAnimationFrame(function () {
            running = false;
            func.apply(_this, args);
        });
    };
}
/**
 * Module.
 */



/***/ }),

/***/ "2gTp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),

/***/ "8Q0Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createSubscribedComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("vCxL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__("WHr8");
/*! ****************************************************************************
Preact bindings for Small-Redux.
https://github.com/m18ru/preact-small-redux
***************************************************************************** */


function createSubscribedComponent(store) {
    var StoreSubscribedComponent = (function (_super) {
        __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](StoreSubscribedComponent, _super);
        function StoreSubscribedComponent(props) {
            var _this = _super.call(this, props) || this;
            _this.storeStateChanged(store.getState());
            _this.dispatch = store.dispatch;
            var unsubscribe;
            var originalComponentDidMount = _this.componentDidMount;
            _this.componentDidMount = function componentDidMount() {
                var _this = this;
                unsubscribe = store.subscribe(function () { return _this.storeStateChanged(store.getState()); });
                if (originalComponentDidMount) {
                    originalComponentDidMount.call(this);
                }
            };
            var originalComponentWillUnmount = _this.componentWillUnmount;
            _this.componentWillUnmount = function componentWillUnmount() {
                if (unsubscribe) {
                    unsubscribe();
                    unsubscribe = undefined;
                }
                if (originalComponentWillUnmount) {
                    originalComponentWillUnmount.call(this);
                }
            };
            return _this;
        }
        return StoreSubscribedComponent;
    }(__WEBPACK_IMPORTED_MODULE_1_preact__["a" /* Component */]));
    return StoreSubscribedComponent;
}

//# sourceMappingURL=index.js.map

/***/ }),

/***/ "DX/w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("vCxL");

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.esm.js
var preact_esm = __webpack_require__("WHr8");

// EXTERNAL MODULE: ./utils/events/throttleToFrame.ts
var throttleToFrame = __webpack_require__("0NxX");

// CONCATENATED MODULE: ./utils/nodes/OuterSizes.ts

// Функции для вычисления внешних размеров элементов.
/**
 * Посчитать внешнюю ширину элемента без округления
 *
 * Стандартный метод offsetWidth округляет, причём в меньшую сторону.
 *
 * @param element Элемент, чтью ширину нужно посчитать
 * @param includeMargin Расчёт с учётом размера margin
 * @returns Внешняя ширина элемента
 */
function calcOuterWidth(element, includeMargin) {
    if (includeMargin === void 0) { includeMargin = false; }
    var style = window.getComputedStyle(element);
    var width = parseFloat(style.width || '0');
    if (includeMargin) {
        width += parseFloat(style.marginLeft || '0')
            + parseFloat(style.marginRight || '0');
    }
    if (style.boxSizing !== 'border-box') {
        width += parseFloat(style.borderLeftWidth || '0')
            + parseFloat(style.borderRightWidth || '0')
            + parseFloat(style.paddingLeft || '0')
            + parseFloat(style.paddingRight || '0');
    }
    return width;
}
/**
 * Посчитать внешнюю высоту элемента без округления
 *
 * Стандартный метод offsetHeight округляет, причём в меньшую сторону.
 *
 * @param element Элемент, чтью высоту нужно посчитать
 * @param includeMargin Расчёт с учётом размера margin
 * @returns Внешняя высота элемента
 */
function calcOuterHeight(element, includeMargin) {
    if (includeMargin === void 0) { includeMargin = false; }
    var style = window.getComputedStyle(element);
    var height = parseFloat(style.height || '0');
    if (includeMargin) {
        height += parseFloat(style.marginTop || '0')
            + parseFloat(style.marginBottom || '0');
    }
    if (style.boxSizing !== 'border-box') {
        height += parseFloat(style.borderTopWidth || '0')
            + parseFloat(style.borderBottomWidth || '0')
            + parseFloat(style.paddingTop || '0')
            + parseFloat(style.paddingBottom || '0');
    }
    return height;
}
/**
 * Модуль
 */


// CONCATENATED MODULE: ./app/elements/SmartSticky.ts

// Класс SmartSticky позволяет автоматически закреплять элемент в рамках
// родительского блока с возможностью умной прокрутки для просмотра
// закреплённого элемента целиком, когда он не помещается на экране.
// 
// Сделан на базе плагина jQuery Sticky-kit
// http://leafo.net/sticky-kit/
// 
// Для работы нужна поддержка `Map` и `CustomEvent`. Для Map не требуется
// поддержка итераторов, т. к. используется только метод `.forEach`.


/**
 * Автоматическое закрепление элемента в рамках родительского блока
 */
var SmartSticky_SmartSticky = /** @class */ (function () {
    /**
     * Автоматическое закрепление элемента в рамках родительского блока
     *
     * @param element Элемент для закрепления
     * @param [options={}] Параметры закрепления
     */
    function SmartSticky(element, options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        if (SmartSticky.instances.has(element)) {
            return SmartSticky.instances.get(element);
        }
        SmartSticky.instances.set(element, this);
        this.options = Object.assign({}, SmartSticky.DEFAULT_OPTIONS, options);
        if (!this.options.parentElement) {
            if (element.parentElement) {
                this.options.parentElement = element.parentElement;
            }
            else {
                this.options.parentElement = document.body;
            }
        }
        if (this.options.createPlaceholder) {
            this.placeholderElement = document.createElement('div');
            this.placeholderElement.className = SmartSticky.CLASS_PLACEHOLDER;
        }
        this.element = element;
        this.disabled = false;
        this.stuck = false;
        this.bottomed = false;
        this.lastTickTime = 0;
        this.currentOffsetTop = this.options.offsetTop || 0;
        this.recalc();
        this.registerHandlers();
        setTimeout(function () { return _this.tick(); }, 0);
    }
    /**
     * Обновить и пересчитать все экземпляры класса в документе
     *
     * @returns
     */
    SmartSticky.updateAll = function () {
        if (SmartSticky.instances.size < 1) {
            return false;
        }
        SmartSticky.instances.forEach(function (instance) { return instance.update(); });
        return true;
    };
    /**
     * Удалить все связи, созданные классом и остановить его работу
     */
    SmartSticky.prototype.destroy = function () {
        this.disabled = true;
        this.unregisterHandlers();
        this.unstick();
        this.options.parentElement.style.position = '';
        SmartSticky.instances.delete(this.element);
        this.placeholderElement = null;
        this.element = null;
        this.options.parentElement = null;
        this.options = null;
    };
    /**
     * Обновить и пересчитать состояние закрепления элемента
     *
     * @returns Обновление прошло успешно?
     */
    SmartSticky.prototype.update = function () {
        return this.recalc() && this.tick();
    };
    /**
     * Приостановить работу класса
     *
     * @returns Успешно?
     */
    SmartSticky.prototype.disable = function () {
        if (this.stuck) {
            this.unstick();
        }
        this.disabled = true;
        return true;
    };
    /**
     * Возобновить работу класса
     *
     * @returns Успешно?
     */
    SmartSticky.prototype.enable = function () {
        if (!this.element) {
            return false;
        }
        this.disabled = false;
        return true;
    };
    /**
     * Зарегистрировать обработчики событий
     */
    SmartSticky.prototype.registerHandlers = function () {
        var _this = this;
        var onScroll = Object(throttleToFrame["a" /* default */])(function () { return _this.tick(); });
        var onResize = Object(throttleToFrame["a" /* default */])(function () { return _this.update(); });
        window.addEventListener('scroll', onScroll);
        window.addEventListener('touchmove', onScroll);
        window.addEventListener('resize', onResize);
        this.unregisterHandlers = function () {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('touchmove', onScroll);
            window.removeEventListener('resize', onResize);
            _this.unregisterHandlers = function () { return void 0; };
        };
    };
    /**
     * Снять зарегистрированные обработчики событий
     */
    // tslint:disable-next-line:prefer-function-over-method
    SmartSticky.prototype.unregisterHandlers = function () {
        // Создаётся в registerHandlers
    };
    /**
     * Пересчитать параметры закрепления
     *
     * @returns Пересчёт завершён?
     */
    SmartSticky.prototype.recalc = function () {
        if (this.disabled) {
            return false;
        }
        this.recalcOnTickCounter = this.options.recalcEvery;
        this.lastDocumentHeight = document.documentElement.offsetHeight;
        var parentComputedStyle = window.getComputedStyle(this.options.parentElement);
        var borderTop = parseInt(parentComputedStyle.borderTopWidth || '0', 10);
        var paddingTop = parseInt(parentComputedStyle.paddingTop || '0', 10);
        this.parentPaddingBottom = parseInt(parentComputedStyle.paddingBottom || '0', 10)
            + this.options.offsetBottom;
        this.parentTop = this.options.parentElement.getBoundingClientRect().top
            + window.scrollY + borderTop + paddingTop;
        this.parentHeight = this.options.parentElement.clientHeight
            - this.options.offsetBottom;
        var temporarilyUnpinned = false;
        if (this.stuck) {
            this.unstick();
            temporarilyUnpinned = true;
        }
        var elementComputedStyle = window.getComputedStyle(this.element);
        this.elementTop = this.element.getBoundingClientRect().top
            + window.scrollY - (parseInt(elementComputedStyle.marginTop || '0', 10) || 0)
            - this.options.offsetTop;
        this.elementHeight = Math.ceil(calcOuterHeight(this.element, true));
        this.elementCssFloat = elementComputedStyle.cssFloat;
        if (this.placeholderElement) {
            var placeholderStyle = this.placeholderElement.style;
            placeholderStyle.width = calcOuterWidth(this.element, true) + 'px';
            placeholderStyle.height = this.elementHeight + 'px';
            placeholderStyle.display = elementComputedStyle.display;
            placeholderStyle.verticalAlign = elementComputedStyle.verticalAlign;
            placeholderStyle.cssFloat = this.elementCssFloat;
        }
        if (temporarilyUnpinned) {
            this.tick();
        }
        return true;
    };
    /**
     * Проверить и выполнить пересчёт, если нужно
     *
     * @returns Выполнен пересчёт?
     */
    SmartSticky.prototype.checkRecalc = function () {
        if (this.options.recalcOnScrollStarts) {
            var lastTickTime = this.lastTickTime;
            var timestamp = Date.now();
            this.lastTickTime = timestamp;
            if (timestamp > (lastTickTime + SmartSticky.TICK_START_INTERVAL)) {
                this.recalc();
                return true;
            }
        }
        if (this.recalcOnTickCounter) {
            --this.recalcOnTickCounter;
            if (this.recalcOnTickCounter <= 0) {
                this.recalcOnTickCounter = this.options.recalcEvery;
                this.recalc();
                return true;
            }
        }
        if (document.documentElement.offsetHeight !== this.lastDocumentHeight) {
            this.recalc();
            return true;
        }
        return false;
    };
    /**
     * Шаг события прокрутки
     *
     * @returns Обработка завершена?
     */
    SmartSticky.prototype.tick = function () {
        var _this = this;
        if (this.disabled) {
            return false;
        }
        this.checkRecalc();
        if (!this.options.stickWhenEntireHeight
            && (this.elementHeight === this.parentHeight)) {
            // Не закреплять элемент, если он занимает всю высоту родительского элемента
            if (this.stuck) {
                this.unstick();
            }
            return false;
        }
        var scrollPos = window.scrollY;
        var delta = 0;
        if (this.lastScrollPos != null) {
            delta = scrollPos - this.lastScrollPos;
        }
        this.lastScrollPos = scrollPos;
        var isWillBottom = function () { return ((scrollPos + _this.elementHeight + _this.currentOffsetTop)
            > (_this.parentHeight + _this.parentTop)); };
        var willBottom = false;
        if (this.stuck) {
            // Проверка закреплённого элемента
            if (this.options.bottoming) {
                willBottom = isWillBottom();
                if (this.bottomed && !willBottom) {
                    this.unbottom();
                }
            }
            if (scrollPos <= this.elementTop) {
                this.unstick();
                this.currentOffsetTop = this.options.offsetTop;
            }
            if (this.options.innerScrolling) {
                // Обновить отступ при прокрутке закреплённого элемента
                var windowHeight = window.innerHeight;
                if (!this.bottomed
                    // Элемент больше экрана
                    && ((this.elementHeight + this.options.offsetTop
                        + this.options.innerScrollingOffsetBottom)
                        > windowHeight)) {
                    this.currentOffsetTop = (Math.min(this.options.offsetTop, Math.max(windowHeight - this.elementHeight
                        - this.options.innerScrollingOffsetBottom, this.currentOffsetTop - delta)));
                    if (this.stuck) {
                        this.element.style.top = this.currentOffsetTop + 'px';
                    }
                }
            }
        }
        else if (scrollPos > this.elementTop) {
            // Закрепление элемента
            this.stick();
        }
        if (this.stuck && this.options.bottoming) {
            // Проверка, не нужно ли закрепить снизу
            if (willBottom == null) {
                willBottom = isWillBottom();
            }
            if (!this.bottomed && willBottom) {
                this.bottom();
            }
        }
        return true;
    };
    /**
     * Закрепить элемент
     */
    SmartSticky.prototype.stick = function () {
        this.stuck = true;
        var elementComputedStyle = window.getComputedStyle(this.element);
        var elementStyle = this.element.style;
        elementStyle.width = elementComputedStyle.width;
        elementStyle.top = this.currentOffsetTop + 'px';
        elementStyle.position = 'fixed';
        if (this.placeholderElement) {
            var parent_1 = this.element.parentNode;
            if (parent_1) {
                parent_1.insertBefore(this.placeholderElement, this.element.nextSibling);
                if (this.options.moveIntoFloat
                    && ((this.elementCssFloat === 'left')
                        || (this.elementCssFloat === 'right'))) {
                    this.placeholderElement.appendChild(this.element);
                }
            }
        }
        this.element.classList.add(SmartSticky.CLASS_STUCK);
        this.element.dispatchEvent(new CustomEvent(SmartSticky.EVENT_STUCK));
    };
    /**
     * Открепить элемент
     */
    SmartSticky.prototype.unstick = function () {
        if (this.bottomed) {
            this.unbottom();
        }
        this.stuck = false;
        if (this.placeholderElement) {
            var parent_2 = this.placeholderElement.parentNode;
            if (parent_2) {
                if (this.options.moveIntoFloat
                    && ((this.elementCssFloat === 'left')
                        || (this.elementCssFloat === 'right'))) {
                    parent_2.insertBefore(this.element, this.placeholderElement.nextSibling);
                }
                parent_2.removeChild(this.placeholderElement);
            }
        }
        var elementStyle = this.element.style;
        elementStyle.position = '';
        elementStyle.top = '';
        elementStyle.width = '';
        this.element.classList.remove(SmartSticky.CLASS_STUCK);
        this.element.dispatchEvent(new CustomEvent(SmartSticky.EVENT_UNSTUCK));
    };
    /**
     * Закрепить элемент снизу
     */
    SmartSticky.prototype.bottom = function () {
        this.bottomed = true;
        var parentComputedStyle = window.getComputedStyle(this.options.parentElement);
        if (parentComputedStyle.position === 'static') {
            this.options.parentElement.style.position = 'relative';
        }
        var elementStyle = this.element.style;
        elementStyle.position = 'absolute';
        elementStyle.top = 'auto';
        elementStyle.bottom = this.parentPaddingBottom + 'px';
        this.element.classList.add(SmartSticky.CLASS_STUCK_BOTTOM);
        this.element.dispatchEvent(new CustomEvent(SmartSticky.EVENT_STUCK_BOTTOM));
    };
    /**
     * Открепить элемент снизу
     */
    SmartSticky.prototype.unbottom = function () {
        this.bottomed = false;
        var elementStyle = this.element.style;
        elementStyle.position = 'fixed';
        elementStyle.top = this.currentOffsetTop + 'px';
        elementStyle.bottom = '';
        this.element.classList.remove(SmartSticky.CLASS_STUCK_BOTTOM);
        this.element.dispatchEvent(new CustomEvent(SmartSticky.EVENT_UNSTUCK_BOTTOM));
    };
    /**
     * Класс закреплённого элемента
     * @const
     */
    SmartSticky.CLASS_STUCK = 'stuck';
    /**
     * Класс прилепленного снизу
     * @const
     */
    SmartSticky.CLASS_STUCK_BOTTOM = 'stuck-bottom';
    /**
     * Класс автоматической заглушки для закреплённого элемента
     * @const
     */
    SmartSticky.CLASS_PLACEHOLDER = 'smartsticky-placeholder';
    /**
     * Событие закрепления элемента
     * @const
     */
    SmartSticky.EVENT_STUCK = 'smartsticky:stuck';
    /**
     * Событие закрепления элемента снизу
     * @const
     */
    SmartSticky.EVENT_STUCK_BOTTOM = 'smartsticky:bottom';
    /**
     * Событие открепления элемента
     * @const
     */
    SmartSticky.EVENT_UNSTUCK = 'smartsticky:unstuck';
    /**
     * Событие открепления элемента снизу
     * @const
     */
    SmartSticky.EVENT_UNSTUCK_BOTTOM = 'smartsticky:unbottom';
    /**
     * Интервал в милисекундах, который должен пройти между событиями
     * прокрутки, чтобы считать, что началась новая прокрутка
     * @const
     */
    SmartSticky.TICK_START_INTERVAL = 1000;
    /**
     * Параметры по умолчанию
     * @const
     */
    SmartSticky.DEFAULT_OPTIONS = {
        offsetTop: 0,
        offsetBottom: 0,
        innerScrolling: true,
        innerScrollingOffsetBottom: 0,
        bottoming: true,
        createPlaceholder: true,
        recalcOnScrollStarts: true,
        stickWhenEntireHeight: false,
        moveIntoFloat: false,
    };
    /** Экземпляры класса */
    SmartSticky.instances = new Map();
    return SmartSticky;
}());
/**
 * Модуль
 */


// EXTERNAL MODULE: ./app/utils/Screen.ts
var Screen = __webpack_require__("PTul");

// CONCATENATED MODULE: ./utils/events/debounce.ts

/**
 * Выполнять функцию не более одного раза,
 * пока не превышен интервал между вызовами
 *
 * @param func Исходная функция
 * @param threshold Минимальный интервал между вызовами
 * @param atBeginning Срабатывать вначале серии вызовов, а не вконце?
 * @returns Функция с ограницением по вызовам
 */
// tslint:disable-next-line:ban-types
function debounce(func, threshold, atBeginning) {
    if (threshold === void 0) { threshold = 100; }
    if (atBeginning === void 0) { atBeginning = false; }
    var timerId;
    return function debounced() {
        var _this = this;
        var rest = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            rest[_i] = arguments[_i];
        }
        if (timerId) {
            clearTimeout(timerId);
        }
        else if (atBeginning) {
            func.apply(this, rest);
        }
        timerId = setTimeout(function () {
            if (!atBeginning) {
                func.apply(_this, rest);
            }
            timerId = 0;
        }, threshold);
    };
}
/**
 * Module
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/Store/Actions.ts

// tslint:disable:no-unnecessary-type-assertion
// tslint:disable-next-line:variable-name
var ActionsCommon = {
    COMMON$_SET_LOADING: 'COMMON$_SET_LOADING',
    COMMON$_SET_VISUAL_MODE: 'COMMON$_SET_VISUAL_MODE',
};
// tslint:disable-next-line:variable-name
var ActionsFilter = {
    FILTER$_SET_FILTER: 'FILTER$_SET_FILTER',
    FILTER$_TOGGLE_SECTION: 'FILTER$_TOGGLE_SECTION',
    FILTER$_TOGGLE_ROOM_TYPE: 'FILTER$_TOGGLE_ROOM_TYPE',
    FILTER$_SET_FLOOR_FROM: 'FILTER$_SET_FLOOR_FROM',
    FILTER$_SET_FLOOR_TO: 'FILTER$_SET_FLOOR_TO',
    FILTER$_SET_SQUARE_TOTAL_FROM: 'FILTER$_SET_SQUARE_TOTAL_FROM',
    FILTER$_SET_SQUARE_TOTAL_TO: 'FILTER$_SET_SQUARE_TOTAL_TO',
    FILTER$_SET_TOTAL_COST_FROM: 'FILTER$_SET_TOTAL_COST_FROM',
    FILTER$_SET_TOTAL_COST_TO: 'FILTER$_SET_TOTAL_COST_TO',
};
// tslint:disable-next-line:variable-name
var ActionsListData = {
    LIST_DATA$_SET_ITEMS: 'LIST_DATA$_SET_ITEMS',
    LIST_DATA$_APPEND_ITEMS: 'LIST_DATA$_APPEND_ITEMS',
    LIST_DATA$_SET_LIST_MODE: 'LIST_DATA$_SET_LIST_MODE',
};
// tslint:disable-next-line:variable-name
var ActionsVisualData = {
    VISUAL_DATA$_SET_OVERVIEW: 'VISUAL_DATA$_SET_OVERVIEW',
    VISUAL_DATA$_SET_BUILDING: 'VISUAL_DATA$_SET_BUILDING',
    VISUAL_DATA$_SET_SECTION: 'VISUAL_DATA$_SET_SECTION',
    VISUAL_DATA$_SET_FLOOR: 'VISUAL_DATA$_SET_FLOOR',
    VISUAL_DATA$_SET_STEP: 'VISUAL_DATA$_SET_STEP',
    VISUAL_DATA$_SET_TOOLTIP: 'VISUAL_DATA$_SET_TOOLTIP',
    VISUAL_DATA$_SET_FILTER_VISIBLE: 'VISUAL_DATA$_SET_FILTER_VISIBLE',
};
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/Store/creators/common.ts


function setLoading(loading) {
    return {
        type: ActionsCommon.COMMON$_SET_LOADING,
        payload: { loading: loading },
    };
}
function setVisualMode(visualMode) {
    return {
        type: ActionsCommon.COMMON$_SET_VISUAL_MODE,
        payload: { visualMode: visualMode },
    };
}
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/Store/creators/filter.ts



// type PartialStateFilter = Pick<StateFilter, keyof StateFilter>;
function setFilter(filter) {
    return {
        type: ActionsFilter.FILTER$_SET_FILTER,
        payload: tslib_es6["a" /* __assign */]({}, filter),
    };
}
function toggleSection(value) {
    return {
        type: ActionsFilter.FILTER$_TOGGLE_SECTION,
        payload: {
            name: 'section',
            value: value,
        },
    };
}
function toggleRoomType(value) {
    return {
        type: ActionsFilter.FILTER$_TOGGLE_ROOM_TYPE,
        payload: {
            name: 'roomType',
            value: value,
        },
    };
}
function setFloorFrom(from) {
    return {
        type: ActionsFilter.FILTER$_SET_FLOOR_FROM,
        payload: {
            name: 'floor',
            from: from,
        },
    };
}
function setFloorTo(to) {
    return {
        type: ActionsFilter.FILTER$_SET_FLOOR_TO,
        payload: {
            name: 'floor',
            to: to,
        },
    };
}
function setSquareTotalFrom(from) {
    return {
        type: ActionsFilter.FILTER$_SET_SQUARE_TOTAL_FROM,
        payload: {
            name: 'squareTotal',
            from: from,
        },
    };
}
function setSquareTotalTo(to) {
    return {
        type: ActionsFilter.FILTER$_SET_SQUARE_TOTAL_TO,
        payload: {
            name: 'squareTotal',
            to: to,
        },
    };
}
function setTotalCostFrom(from) {
    return {
        type: ActionsFilter.FILTER$_SET_TOTAL_COST_FROM,
        payload: {
            name: 'totalCost',
            from: from,
        },
    };
}
function setTotalCostTo(to) {
    return {
        type: ActionsFilter.FILTER$_SET_TOTAL_COST_TO,
        payload: {
            name: 'totalCost',
            to: to,
        },
    };
}
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/Store/creators/listData.ts


function setItems(items, itemsLeft, nextItemsOffset) {
    if (items === void 0) { items = []; }
    if (itemsLeft === void 0) { itemsLeft = 0; }
    if (nextItemsOffset === void 0) { nextItemsOffset = 0; }
    return {
        type: ActionsListData.LIST_DATA$_SET_ITEMS,
        payload: {
            items: items,
            itemsLeft: itemsLeft,
            nextItemsOffset: nextItemsOffset,
        },
    };
}
function appendItems(items, itemsLeft, nextItemsOffset) {
    if (items === void 0) { items = []; }
    if (itemsLeft === void 0) { itemsLeft = 0; }
    if (nextItemsOffset === void 0) { nextItemsOffset = 0; }
    return {
        type: ActionsListData.LIST_DATA$_APPEND_ITEMS,
        payload: {
            items: items,
            itemsLeft: itemsLeft,
            nextItemsOffset: nextItemsOffset,
        },
    };
}
function setListMode(listMode) {
    return {
        type: ActionsListData.LIST_DATA$_SET_LIST_MODE,
        payload: {
            listMode: listMode,
        },
    };
}
/**
 * Module.
 */


// EXTERNAL MODULE: ../node_modules/preact-small-redux/es5-esm/index.js
var es5_esm = __webpack_require__("8Q0Y");

// EXTERNAL MODULE: ../node_modules/small-redux/es5-esm/index.js + 2 modules
var small_redux_es5_esm = __webpack_require__("U8YX");

// EXTERNAL MODULE: ../node_modules/immutability-helper/index.js
var immutability_helper = __webpack_require__("z2Rp");
var immutability_helper_default = /*#__PURE__*/__webpack_require__.n(immutability_helper);

// CONCATENATED MODULE: ./app/Routes/Choose/App/utils/getIndexByValue.ts

// Найти индекс элемента в наборе по значению
/**
 * Найти индекс элемента в наборе по значению
 *
 * @param items Массив объектов с параметром `value`.
 * @param value Искомое значение.
 * @returns Индект элемента с искомым значением, или `-1`.
 */
function getIndexByValue(items, value) {
    for (var i = 0, n = items.length; i < n; i++) {
        if (items[i].value === value) {
            return i;
        }
    }
    return -1;
}
/**
 * Module
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/Store/reducer.ts






/**
 * Initial app state.
 */
var initialState = {
    common: {
        loading: false,
        visualMode: true,
    },
    filter: {
        section: [],
        floor: {
            min: 0,
            max: 1,
            from: 0,
            to: 1,
        },
        roomType: [],
        squareTotal: {
            min: 0,
            max: 1,
            from: 0,
            to: 1,
        },
        totalCost: {
            min: 0,
            max: 1,
            from: 0,
            to: 1,
        },
    },
    listData: {
        items: [],
        itemsLeft: 0,
        nextItemsOffset: 0,
        listMode: false,
    },
    visualData: {
        overview: {
            view: '',
            nextView: '',
            image: '',
            map: [],
        },
        building: {
            building: '',
            view: '',
            nextView: '',
            image: '',
            map: [],
        },
        section: {
            section: '',
            view: '',
            nextView: '',
            image: '',
            map: [],
        },
        floor: {
            floor: 0,
            image: '',
            map: [],
        },
        step: 0 /* OVERVIEW */,
        prevStep: 0 /* OVERVIEW */,
        tooltip: {
            title: '',
            content: '',
            visible: false,
        },
        filterVisible: true,
    },
};
function common(state, action) {
    if (state === void 0) { state = initialState.common; }
    switch (action.type) {
        case ActionsCommon.COMMON$_SET_LOADING:
        case ActionsCommon.COMMON$_SET_VISUAL_MODE:
            return tslib_es6["a" /* __assign */]({}, state, action.payload);
        default:
            return state;
    }
}
function reducer_filter(state, action) {
    if (state === void 0) { state = initialState.filter; }
    switch (action.type) {
        case ActionsFilter.FILTER$_SET_FILTER:
            return tslib_es6["a" /* __assign */]({}, state, action.payload);
        case ActionsFilter.FILTER$_TOGGLE_SECTION:
        case ActionsFilter.FILTER$_TOGGLE_ROOM_TYPE:
            {
                var _a = action.payload, name_1 = _a.name, value = _a.value;
                var index = getIndexByValue(state[name_1], value);
                if (index !== -1) {
                    return immutability_helper(state, (_b = {}, _b[name_1] = (_c = {}, _c[index] = { checked: { $apply: function (x) { return !x; } } }, _c), _b));
                }
            }
            return state;
        case ActionsFilter.FILTER$_SET_FLOOR_FROM:
        case ActionsFilter.FILTER$_SET_SQUARE_TOTAL_FROM:
        case ActionsFilter.FILTER$_SET_TOTAL_COST_FROM:
            return immutability_helper(state, (_d = {}, _d[action.payload.name] = { from: { $set: action.payload.from } }, _d));
        case ActionsFilter.FILTER$_SET_FLOOR_TO:
        case ActionsFilter.FILTER$_SET_SQUARE_TOTAL_TO:
        case ActionsFilter.FILTER$_SET_TOTAL_COST_TO:
            return immutability_helper(state, (_e = {}, _e[action.payload.name] = { to: { $set: action.payload.to } }, _e));
        default:
            return state;
    }
    var _b, _c, _d, _e;
}
function reducer_listData(state, action) {
    if (state === void 0) { state = initialState.listData; }
    switch (action.type) {
        case ActionsListData.LIST_DATA$_SET_ITEMS:
        case ActionsListData.LIST_DATA$_SET_LIST_MODE:
            return tslib_es6["a" /* __assign */]({}, state, action.payload);
        case ActionsListData.LIST_DATA$_APPEND_ITEMS:
            return immutability_helper(state, {
                items: { $push: action.payload.items },
                itemsLeft: { $set: action.payload.itemsLeft },
                nextItemsOffset: { $set: action.payload.nextItemsOffset },
            });
        default:
            return state;
    }
}
function visualData(state, action) {
    if (state === void 0) { state = initialState.visualData; }
    switch (action.type) {
        case ActionsVisualData.VISUAL_DATA$_SET_OVERVIEW:
        case ActionsVisualData.VISUAL_DATA$_SET_BUILDING:
        case ActionsVisualData.VISUAL_DATA$_SET_SECTION:
        case ActionsVisualData.VISUAL_DATA$_SET_FLOOR:
        case ActionsVisualData.VISUAL_DATA$_SET_FILTER_VISIBLE:
            return tslib_es6["a" /* __assign */]({}, state, action.payload);
        case ActionsVisualData.VISUAL_DATA$_SET_STEP:
            return tslib_es6["a" /* __assign */]({}, state, action.payload, { prevStep: state.step });
        case ActionsVisualData.VISUAL_DATA$_SET_TOOLTIP:
            return immutability_helper(state, {
                tooltip: {
                    $merge: action.payload,
                },
            });
        default:
            return state;
    }
}
/**
 * App reducer.
 *
 * @param state Current state.
 * @param action Required action.
 * @returns New state.
 */
var reducer = Object(small_redux_es5_esm["a" /* combineReducers */])({
    common: common,
    filter: reducer_filter,
    listData: reducer_listData,
    visualData: visualData,
});
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/Store/index.ts




/**
 * A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
var store = Object(small_redux_es5_esm["b" /* createStore */])(reducer);
/**
 * Dispatches an action. It is the only way to trigger a state change.
 *
 * @param action A plain object representing “what changed”.
 */
var dispatch = store.dispatch;
/**
 * Adds a change listener. It will be called any time an action is
 * dispatched, and some part of the state tree may potentially have changed.
 * You may then call `getState()` to read the current state tree inside the
 * callback.
 *
 * @param listener A callback to be invoked on every dispatch.
 * @returns A function to remove this change listener.
 */
var subscribe = store.subscribe;
/**
 * Reads the state tree managed by the store.
 *
 * @returns The current state tree of your application.
 */
var getState = store.getState;
/**
 * Abstract Class of Component with subscription to Store changes.
 */
// tslint:disable-next-line:variable-name
var SubscribedComponent = Object(es5_esm["a" /* default */])(store);
/**
 * Module
 */


// CONCATENATED MODULE: ./app/utils/RequestCache.ts

/**
 * Max number of items in cache.
 */
var CACHE_LENGTH = 20;
/**
 * Cache entry lifetime (ms).
 */
var CACHE_LIFETIME = 300000;
/**
 * Cache items list.
 */
var list = new Array(CACHE_LENGTH);
/**
 * Last item in cache.
 */
var tail = -1;
/**
 * Add request to cache.
 *
 * @param response Parsed server response.
 * @param method HTTP method.
 * @param path The path to request within API.
 * @param data Data to send to the server.
 * @param contentType Content type.
 */
function add(response, method, path, data, contentType) {
    if (data === void 0) { data = null; }
    tail = tail + 1;
    if (tail >= CACHE_LENGTH) {
        tail = 0;
    }
    list[tail] = {
        method: method,
        path: path,
        data: data,
        contentType: contentType,
        response: response,
        timestamp: Date.now(),
    };
}
/**
 * Get parsed server response for reqest from cache.
 *
 * @param method HTTP method.
 * @param path The path to request within API.
 * @param data Data to send to the server.
 * @param contentType Content type.
 */
function get(method, path, data, contentType) {
    if (data === void 0) { data = null; }
    if (tail === -1) {
        return null;
    }
    for (var i = 0; i < CACHE_LENGTH; i++) {
        var index = tail - i;
        if (index < 0) {
            index = CACHE_LENGTH + index;
        }
        var request = list[index];
        if (request
            && (request.method === method)
            && (request.path === path)
            && (request.data === data)
            && (request.contentType === contentType)
            && ((Date.now() - request.timestamp) < CACHE_LIFETIME)) {
            return request.response;
        }
    }
    return null;
}
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/utils/ServerApi.ts

// Server API actions.

/**
 * Send async request to server API.
 *
 * @param method HTTP method.
 * @param path The path to request within API.
 * @param data Data to send to the server.
 * @param contentType Content type.
 * @returns Parsed server response.
 */
function send(method, path, data, contentType) {
    if (data === void 0) { data = null; }
    var cachedResponse = get(method, path, data, contentType);
    if (cachedResponse) {
        return cachedResponse;
    }
    var xhr = new XMLHttpRequest();
    xhr.withCredentials = false;
    xhr.open(method, path);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    if (contentType) {
        xhr.setRequestHeader('Content-Type', contentType);
    }
    var promise = new Promise(function (resolve) {
        // TODO: Custom errors
        xhr.onerror = function () {
            throw new Error('An error occurred during the transaction.');
        };
        xhr.onabort = function () {
            throw new Error('The request was aborted.');
        };
        xhr.onload = function () {
            if (xhr.status >= 500) {
                throw new Error('Server error: ' + xhr.statusText);
            }
            if (xhr.status >= 400) {
                throw new Error('Request error: ' + xhr.statusText);
            }
            resolve(JSON.parse(xhr.responseText));
        };
    });
    add(promise, method, path, data, contentType);
    xhr.send(data);
    return promise;
}
/**
 * Send async GET request to server API.
 *
 * @param path The path to request within API (part after `/api`).
 * @returns Parsed server response.
 */
var ServerApi_get = function (path) { return send('GET', path); };
/**
 * Send async POST request to server API.
 *
 * @param path The path to request within API (part after `/api`).
 * @param data Data to send to the server.
 * @param contentType Content type.
 * @returns Parsed server response.
 */
var post = function (path, data, contentType) {
    return send('POST', path, data, contentType);
};
/**
 * Send async POST request to server API.
 *
 * @param path The path to request within API (part after `/api`).
 * @param data Data to send to the server.
 * @param contentType Content type.
 * @returns Parsed server response.
 */
var put = function (path, data, contentType) {
    return send('PUT', path, data, contentType);
};
/**
 * Module
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/utils/sendListRequest.ts

// Отправить запрос на сервер.


/**
 * Отправить запрос на сервер.
 *
 * @param query Строка запроса.
 * @returns Новый объект состояния.
 */
function sendListRequest(query) {
    if (query === void 0) { query = ''; }
    return tslib_es6["b" /* __awaiter */](this, void 0, void 0, function () {
        var response, items;
        return tslib_es6["d" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ServerApi_get('/choose/apartment/?ajax=1' + (query ? '&' + query : ''))];
                case 1:
                    response = _a.sent();
                    items = response.items.map(function (_a) {
                        var id = _a.id, section = _a.section, floor = _a.floor, room_type = _a.room_type, square_total = _a.square_total, total_cost = _a.total_cost, image = _a.image;
                        return {
                            id: id,
                            section: section,
                            floor: floor,
                            roomType: room_type,
                            squareTotal: square_total,
                            totalCost: total_cost,
                            image: image,
                        };
                    });
                    return [2 /*return*/, {
                            filter: response.filter,
                            listData: {
                                items: items,
                                itemsLeft: response.rowsLeft,
                                nextItemsOffset: response.offset + response.limit,
                            },
                        }];
            }
        });
    });
}
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/asyncActions/fetchList.ts








/**
 * Загружает элементы в список вместо текущих.
 *
 * @param query Строка параметров запроса.
 */
function fetchList(query) {
    return tslib_es6["b" /* __awaiter */](this, void 0, void 0, function () {
        var _a, filter, listData;
        return tslib_es6["d" /* __generator */](this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatch(setLoading(true));
                    return [4 /*yield*/, sendListRequest(query)];
                case 1:
                    _a = _b.sent(), filter = _a.filter, listData = _a.listData;
                    dispatch(setFilter(filter));
                    dispatch(setItems(listData.items, listData.itemsLeft, listData.nextItemsOffset));
                    dispatch(setLoading(false));
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Загружает элементы в список вместо текущих.
 * Ограничен по частоте срабатываний.
 *
 * @param query Строка параметров запроса.
 */
var debouncedFetchList = debounce(fetchList, 200);
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/Store/creators/visualData.ts


function setOverview(overview) {
    return {
        type: ActionsVisualData.VISUAL_DATA$_SET_OVERVIEW,
        payload: {
            overview: overview,
        },
    };
}
function setBuilding(building) {
    return {
        type: ActionsVisualData.VISUAL_DATA$_SET_BUILDING,
        payload: {
            building: building,
        },
    };
}
function setSection(section) {
    return {
        type: ActionsVisualData.VISUAL_DATA$_SET_SECTION,
        payload: {
            section: section,
        },
    };
}
function setFloor(floor) {
    return {
        type: ActionsVisualData.VISUAL_DATA$_SET_FLOOR,
        payload: {
            floor: floor,
        },
    };
}
function setStep(step) {
    return {
        type: ActionsVisualData.VISUAL_DATA$_SET_STEP,
        payload: {
            step: step,
        },
    };
}
/**
 * Установить состояние подсказки.
 *
 * @param title Заголовок
 * @param content Содержимое
 * @param visible Показывать?
 */
function setTooltip(title, content, visible) {
    if (visible === void 0) { visible = true; }
    return {
        type: ActionsVisualData.VISUAL_DATA$_SET_TOOLTIP,
        payload: {
            title: title,
            content: content,
            visible: visible,
        },
    };
}
/**
 * Установить видимость подсказки.
 *
 * @param visible Показывать?
 */
function setTooltipVisibility(visible) {
    return {
        type: ActionsVisualData.VISUAL_DATA$_SET_TOOLTIP,
        payload: {
            visible: visible,
        },
    };
}
/**
 * Установить видимость фильтра.
 *
 * @param filterVisible Показывать?
 */
function setFilterVisibility(filterVisible) {
    return {
        type: ActionsVisualData.VISUAL_DATA$_SET_FILTER_VISIBLE,
        payload: {
            filterVisible: filterVisible,
        },
    };
}
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/utils/visualStateToQueryString.ts

/**
 * Сформировать из текущего состояния фильтра строку запроса визуального режима.
 *
 * @param filter Описание полей фильтра.
 * @param visualData Состояние визуального режима.
 */
function visualStateToQueryString(filter, _a, parameters) {
    var overview = _a.overview, building = _a.building, section = _a.section, floor = _a.floor, step = _a.step;
    if (parameters === void 0) { parameters = {}; }
    var queryParts = [
        'overview=' + encodeURIComponent(parameters.overviewView || overview.view || 'front'),
    ];
    if (step > 0 /* OVERVIEW */) {
        queryParts.push(
        // 'view=' + ( parameters.buildingView || building.view ),
        'building=' + (parameters.building || building.building), 'view=' + (parameters.sectionView || section.view), 'section=' + (parameters.section || section.section));
    }
    if (step > 1 /* SECTION */) {
        queryParts.push('floor=' + (parameters.floor || floor.floor));
    }
    for (var _i = 0, _b = filter.roomType; _i < _b.length; _i++) {
        var checkbox = _b[_i];
        if (checkbox.checked) {
            queryParts.push('roomType[]=' + encodeURIComponent(checkbox.value));
        }
    }
    if (filter.squareTotal.from !== filter.squareTotal.min) {
        queryParts.push('squareTotalFrom=' + filter.squareTotal.from);
    }
    if (filter.squareTotal.to !== filter.squareTotal.max) {
        queryParts.push('squareTotalTo=' + filter.squareTotal.to);
    }
    if (filter.totalCost.from !== filter.totalCost.min) {
        queryParts.push('totalCostFrom=' + filter.totalCost.from);
    }
    if (filter.totalCost.to !== filter.totalCost.max) {
        queryParts.push('totalCostTo=' + filter.totalCost.to);
    }
    return queryParts.join('&');
}
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/utils/sendVisualRequest.ts

// Отправить запрос на сервер.




/**
 * Отправить запрос на сервер.
 *
 * @param parameters Параметры запроса.
 * @returns Новый объект состояния.
 */
function sendVisualRequest(parameters) {
    if (parameters === void 0) { parameters = {}; }
    return tslib_es6["b" /* __awaiter */](this, void 0, void 0, function () {
        var state, query, response, result, overview, building, section, floor;
        return tslib_es6["d" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = getState();
                    query = visualStateToQueryString(state.filter, state.visualData, parameters);
                    return [4 /*yield*/, ServerApi_get('/choose/apartment/?ajax=1' + (query ? '&' + query : ''))];
                case 1:
                    response = _a.sent();
                    result = {
                        filter: response.filter,
                    };
                    if (response.overview) {
                        overview = response.overview.map(function (
                            // {corpus, count}: ServerResponseOverview,
                            _a) {
                            var section = _a.section, count = _a.count;
                            return {
                                path: '',
                                // target: corpus,
                                target: section,
                                available: count,
                            };
                        });
                        result.overview = { map: overview };
                    }
                    if (response.building) {
                        building = response.building.map(function (_a) {
                            var section = _a.section, count = _a.count;
                            return {
                                path: '',
                                target: section,
                                available: count,
                            };
                        });
                        result.building = { map: building };
                    }
                    if (response.section) {
                        section = response.section.map(function (_a) {
                            var floor = _a.floor, count = _a.count;
                            return {
                                path: '',
                                target: floor,
                                available: count,
                            };
                        });
                        result.section = { map: section };
                    }
                    if (response.floor) {
                        floor = response.floor.map.map(function (_a) {
                            var id = _a.id, room_type = _a.room_type, square_total = _a.square_total, total_cost = _a.total_cost, path = _a.path;
                            return {
                                target: id,
                                roomType: room_type,
                                squareTotal: square_total,
                                totalCost: total_cost,
                                path: path || '',
                            };
                        });
                        result.floor = {
                            floor: response.floor.floor,
                            image: response.floor.image,
                            map: floor,
                        };
                    }
                    return [2 /*return*/, result];
            }
        });
    });
}
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/asyncActions/fetchVisualFloor.ts







// import {StateVisualFloor, StateVisualFloorMapItem} from '../Store/State';

// tslint:disable:max-line-length
/* const data = {
    floor: 2,
    image: '/images/choose-visual/floors/05/02.svg',
    map: [
        {
            path: 'M1080.1 637.9l20.3 35.1 119.7-69.1 33.7 58.4-216.5 125.6-54.2-93.5z',
            target: 462952,
            roomType: '3 комнаты (евро)',
            squareTotal: 70.79,
            totalCost: 4522281,
        },
        {
            path: 'M936.1 555.1l67.6-.1 42.4 24.3 34 58.6-98 56.9-45.9-26.4z',
            target: 462953,
            roomType: '1 комната',
            squareTotal: 43.72,
            totalCost: 3022243,
        },
        {
            path: 'M831.5 555.1h104.6l.1 113.3-104.7 1z',
            target: 462954,
            roomType: '1 комната',
            squareTotal: 37.26,
            totalCost: 2922246,
        },
        {
            path: 'M648.2 523.5l-.2 44.3-22.1.2.2 81.7 83.5.2.1 18.9 121.8.6V555.1h-11.9l.3-27.7-38.3-.4.4 44.1-36.9-.7.3-46.5z',
            target: 462955,
            roomType: '3 комнаты (евро)',
            squareTotal: 77.91,
            totalCost: 4722248,
        },
        {
            path: 'M648.1 472.1h-22.3l-.1-81.6 89.2-.2v25l172-.8V528l-105.3-1 .4 44.1-36.9-.7.3-46.5-97.2-.4z',
            target: 462956,
            roomType: '4 комнаты (евро)',
            squareTotal: 99.99,
            totalCost: 5222249,
        },
        {
            path: 'M886.9 414.5V528h118.2l42-24.5 35.5-62.6-97.6-57.8-18 30.7z',
            target: 462957,
            roomType: '3 комнаты (евро)',
            squareTotal: 63.26,
            totalCost: 4122271,
        },
        {
            path: 'M985 383.1l57.7-91.9 217.2 123.1-55.7 96.6-121.6-70z',
            target: 462958,
            roomType: '3 комнаты',
            squareTotal: 89.67,
            totalCost: 4922242,
        },
    ],
}; */
function fetchVisualFloor(floor) {
    return tslib_es6["b" /* __awaiter */](this, void 0, void 0, function () {
        var serverData;
        return tslib_es6["d" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(setLoading(true));
                    return [4 /*yield*/, sendVisualRequest({ floor: floor })];
                case 1:
                    serverData = _a.sent();
                    /* const availableTargets = new Set<string | number>();
                    
                    if ( serverData.floor && serverData.floor.map )
                    {
                        for ( const item of serverData.floor.map )
                        {
                            availableTargets.add( item.target );
                        }
                    }
                    
                    const viewData: StateVisualFloor = {
                        ...data,
                        floor,
                        map: data.map.filter(
                            ( {target}: StateVisualFloorMapItem ): boolean =>
                            {
                                return availableTargets.has( target );
                            },
                        ),
                    }; */
                    if (serverData.floor) {
                        dispatch(setFloor(serverData.floor));
                    }
                    // TODO:
                    dispatch(setFilter(serverData.filter));
                    dispatch(setLoading(false));
                    return [2 /*return*/];
            }
        });
    });
}
var debouncedFetchVisualFloor = debounce(fetchVisualFloor, 200);
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/asyncActions/fetchVisualOverview.ts








// tslint:disable:max-line-length
var fetchVisualOverview_data = {
    front: {
        view: 'front',
        nextView: 'back',
        image: '/images/choose-visual/overview/01.jpg',
        map: [
            {
                path: 'M655.76 905.32a3.11 3.11 0 0 1-3.23.6l-18.85-8.48c-1-.45-2.46-.18-3.23.6l-9.06 9.16a2.97 2.97 0 0 1-3.2.54l-100.41-49a6.75 6.75 0 0 1-2.67-2.68l-48.51-100.4c-.48-.99-.99-2.69-1.14-3.78l-21.09-155.99a2.37 2.37 0 0 1 1.66-2.52l108.94-30.3a2.96 2.96 0 0 1 3.04 1.13l17.28 25.92a8.53 8.53 0 0 1 1.21 3.66l.54 10.25c.06 1.1.93 2.35 1.94 2.79l85.41 36.83a3.31 3.31 0 0 1 1.84 2.79v1.33c0 1.1.8 2.42 1.77 2.93l12.37 6.45a3.6 3.6 0 0 1 1.76 2.92l-.02 4.54a5.52 5.52 0 0 1-1.44 3.4l-2.26 2.21a4.65 4.65 0 0 0-1.22 3.39l19.83 187.77a4.75 4.75 0 0 1-1.2 3.41l-40.06 40.53z',
                target: '9',
                available: 1,
            },
            {
                path: 'M584.63 607.39c.16 1.09-.54 1.62-1.55 1.19l-4.1-1.76a3.54 3.54 0 0 1-1.95-2.79l-.6-10.5a8.93 8.93 0 0 0-1.2-3.68l-16.83-25.98a2.9 2.9 0 0 0-3.01-1.14l-109.36 30.63a2.37 2.37 0 0 0-1.66 2.52l21.09 155.99a1.69 1.69 0 0 1-1.73 1.97l-121.92-.48c-1.1 0-2.22-.88-2.49-1.95l-2.03-8.12a2.7 2.7 0 0 0-2.49-1.94h-10.33c-1.1 0-2.22-.87-2.48-1.94l-68.78-275.37c-.27-1.07-.2-2.33.14-2.82.34-.48.47-1.76.28-2.85l-1.57-9.06a7.5 7.5 0 0 1 .5-3.78l3.56-7.63c.47-1 1.25-2.62 1.75-3.6l23.45-46.56c.49-.98 1.8-1.8 2.9-1.81l32.08-.44c1.1-.02 2.17-.87 2.37-1.9a2.5 2.5 0 0 1 2.37-1.88l16.25-.04c1.1 0 2.13.89 2.28 1.98l.94 6.7a2.4 2.4 0 0 0 2.28 2l75.17.8c1.1.01 2.87-.2 3.94-.48l16.79-4.33a13.03 13.03 0 0 0 3.57-1.65l28.23-19.86c.9-.63 2.47-.82 3.49-.41l78.29 31.35a3.86 3.86 0 0 1 2.15 2.72l30.21 206.9z',
                target: '8',
                available: 1,
            },
            {
                path: 'M767.15 608.71a2.6 2.6 0 0 1-1.75 2.57l-45 13.52a2.88 2.88 0 0 0-1.92 2.58v2.33a2.9 2.9 0 0 1-1.91 2.6l-37.68 11.8a3.28 3.28 0 0 1-3.21-.92l-1.3-1.51a2.4 2.4 0 0 0-3-.45l-3.45 2.16c-.93.58-2.52.71-3.53.27l-77.64-33.5a4 4 0 0 1-2.13-2.77l-30.19-206.88a3.84 3.84 0 0 0-2.15-2.72l-45.41-18.19c-1.02-.41-1.12-1.26-.22-1.89l32.68-22.94c.9-.63 2.48-.83 3.51-.44l3.14 1.2c1.03.39 2.58.16 3.44-.52l6.1-4.78c.87-.68 2.44-1.47 3.5-1.77l127.02-35.3a3.02 3.02 0 0 1 3.06 1.11l.74 1.08c.62.91 2 1.42 3.07 1.15l15-3.87c1.07-.28 2.5.2 3.19 1.06l34.36 42.57a7.66 7.66 0 0 1 1.42 3.55l20.26 248.9z',
                target: '7',
                available: 1,
            },
            {
                path: 'M949.87 606.95a2.03 2.03 0 0 1-1.98 2.04l-19.35.4c-1.1.02-2 .91-2 1.98 0 1.07-.9 1.94-2 1.93l-61.63-.12c-1.1 0-2 .74-1.99 1.65.01.91-.89 1.64-1.99 1.63l-42.08-.57a2.22 2.22 0 0 1-2.15-2.02l-.57-7.35a2.19 2.19 0 0 0-2.15-1.99H791.4c-1.1 0-2.05-.9-2.12-2l-1.17-19.17a2.15 2.15 0 0 0-2.12-1.99l-19.03.06a2.2 2.2 0 0 1-2.16-1.99L746.89 359.8a7.66 7.66 0 0 0-1.42-3.55l-34.36-42.57a7.29 7.29 0 0 1-1.37-3.55l-2.48-44.09a2.59 2.59 0 0 1 1.82-2.52l34.97-9.46c1.06-.29 2.83-.51 3.93-.49l196 3.1c1.1.02 2.01.93 2.02 2.03l3.87 348.25z',
                target: '6',
                available: 1,
            },
            {
                path: 'M1112.73 627.5a2.36 2.36 0 0 1-2.12 2.14l-2.55.18a2.21 2.21 0 0 0-2.02 2.14l-.03 2.42a2.2 2.2 0 0 1-2.02 2.13l-.51.03a2.37 2.37 0 0 0-2.14 2.12l-.14 1.97a3.04 3.04 0 0 1-2.07 2.53l-4.23 1.18a2.96 2.96 0 0 1-3.04-1.13l-10.03-15.05c-.61-.92-2-1.51-3.08-1.32l-28.69 5.06a2.38 2.38 0 0 0-1.9 2.35l.37 11.38a2.45 2.45 0 0 1-1.9 2.39l-19.28 3.81a3.84 3.84 0 0 1-3.28-1.12l-11.53-13.16a10.56 10.56 0 0 0-3.15-2.31l-57.67-25.47a3.37 3.37 0 0 1-1.85-2.81L946 258.7a53 53 0 0 1 .14-3.99l3.68-44.72a2.39 2.39 0 0 1 2.16-2.12l15.01-.99c1.1-.07 2-.98 2-2.01s.89-2.02 1.97-2.2l82.72-13.48c1.09-.18 2.5.41 3.15 1.3l.31.43a3.27 3.27 0 0 0 3.12 1.16l14.61-3.42a5.79 5.79 0 0 1 3.68.55l57.54 33.33c.95.55 1.67 1.9 1.61 3l-24.97 401.96z',
                target: '5',
                available: 1,
            },
            {
                path: 'M1283.4 210.55c.55.95.9 2.63.78 3.73l-30.67 291.27c-.12 1.09-.53 1.15-.91.12l-6.68-17.84a1.9 1.9 0 0 0-2.54-1.09l-2.36 1.01a3.38 3.38 0 0 0-1.88 2.79l-.37 16.08a3.4 3.4 0 0 1-1.89 2.78l-9.06 3.82a3.11 3.11 0 0 0-1.76 2.78l.46 11a3.26 3.26 0 0 1-1.73 2.85l-33.34 15.67c-1 .47-2.55.34-3.46-.28l-2.53-1.74a3.5 3.5 0 0 0-3.38-.14l-41.03 23.51c-.95.55-2.37.36-3.15-.42l-2-2a3.13 3.13 0 0 0-3.24-.6l-14.58 6.51c-1 .45-1.77-.08-1.7-1.18l21.31-343.65a3.52 3.52 0 0 0-1.61-2.99l-10.9-6.27c-.95-.55-.9-1.35.11-1.78l94.68-40.01c1.01-.43 2.74-.84 3.84-.91l35.09-2.24c1.1-.07 2.44.65 2.99 1.61l21.51 37.61z',
                target: '4',
                available: 1,
            },
            {
                path: 'M1488.85 217.32c1.08.21 1.61 1.2 1.18 2.22l-3.34 7.82a21.1 21.1 0 0 0-1.13 3.81l-48.24 280.72a1.88 1.88 0 0 1-2.29 1.52l-55.1-12.84a20.97 20.97 0 0 0-3.95-.45l-27.66.07c-1.1 0-2.29.86-2.63 1.9l-.57 1.71a3.16 3.16 0 0 1-2.63 2l-36.17 1.95a3.44 3.44 0 0 1-2.94-1.66l-.79-1.47a3.25 3.25 0 0 0-2.93-1.57l-44.35 4.28c-1.09.11-1.9-.7-1.78-1.8l30.67-291.27a2.47 2.47 0 0 1 2.2-2.12l109.59-7.4c1.1-.07 2.88.02 3.96.22l9.94 1.79c1.08.2 2.38-.45 2.88-1.42l.29-.57c.5-.98 1.8-1.61 2.88-1.4l72.91 13.96z',
                target: '3',
                available: 1,
            },
            {
                path: 'M1719.02 198.2c.67.46.99 1.71.72 2.78l-51.44 205.74c-.27 1.07-.98 1.19-1.59.28l-32.28-48.46a3.78 3.78 0 0 0-3.1-1.51l-89.3 6.98a2.86 2.86 0 0 0-2.41 2.11l-38.87 181.8c-.23 1.08-.9 1.2-1.49.27l-13.69-21.54a5.64 5.64 0 0 0-3.02-2.14l-43.6-10.17a2.15 2.15 0 0 1-1.61-2.43l48.24-280.72c.19-1.08.69-2.8 1.13-3.81l4.97-11.57 1.58-3.68 7.49-17.46 1.58-3.68.47-1.1a2.63 2.63 0 0 1 2.76-1.48l37.64 6.79c1.08.2 2.87.3 3.96.24l13.51-.77c1.1-.06 2.81-.51 3.8-.98l41.98-20.26a3.7 3.7 0 0 0 1.89-2.87l.15-3.5c.05-1.1.89-2.42 1.86-2.93l9.21-4.82a4.35 4.35 0 0 1 3.55-.01l1.62.83c.98.5 2.58.52 3.57.03l14.59-7.22a4.75 4.75 0 0 1 3.61-.05l71.95 33.32c1 .46 1.61 1.72 1.36 2.79l-1.51 6.44c-.29 1.05.05 2.3.72 2.76z',
                target: '2',
                available: 1,
            },
            {
                path: 'M1669.37 410.95c.61.92.89 2.54.63 3.6l-17.28 69.37-.98 3.88-47.51 186.62a2.14 2.14 0 0 1-2.45 1.55l-14.49-2.89a2.13 2.13 0 0 0-2.45 1.55l-1.78 7.12a2.12 2.12 0 0 1-2.45 1.54l-61.16-12.37a1.89 1.89 0 0 1-1.47-2.33l2.35-9.21a2.2 2.2 0 0 0-1.4-2.58l-4.23-1.43a2.42 2.42 0 0 1-1.56-2.61l.4-2.39a2.08 2.08 0 0 0-1.63-2.36l-2.87-.56a1.96 1.96 0 0 1-1.54-2.34l11.52-53.73a6.81 6.81 0 0 0-.45-3.76l-17.36-35.96a6.81 6.81 0 0 1-.45-3.76l38.87-181.8a2.84 2.84 0 0 1 2.41-2.11l89.3-6.98c1.1-.09 2.49.59 3.1 1.51l34.93 52.43z',
                target: '1',
                available: 1,
            },
        ],
    },
    back: {
        view: 'back',
        nextView: 'front',
        image: '/images/choose-visual/overview/02.jpg',
        map: [
            {
                path: 'M603.73 373.51l-21.34 19.04 2.46-10.67-43.12-6.62-16.25 13.25-22.38-3.38-27.79-17.91-4.33-38.5 71.62-22.34 3.76 2.79 16.74-5.41 38 22.87z',
                target: '1',
                available: 1,
            },
            {
                path: 'M469.83 363.16l-88.85 28.72 27.66 254.17-17.83-8.67-16.58 2.63-9.63 2.37-36.75 3.38-25.37.87-2-6.87-19.88 2.25-1.87-15-8.75.87-55-276.8-1-20.36 10.5-38 30-.67.5 14 90.62-6.17 18-5.87 20.5-15.13 81.88 12.13 5 37.71 4.33 38.5z',
                target: '2',
                available: 1,
            },
            {
                path: 'M614.14 722.05l-17.79-4.04-5.62 3.75-126.25-27.21-55.84-48.5-27.66-254.17 88.85-28.72 5.48 4.06 27.79 17.91 22.38 3.38 16.25-13.25 43.12 6.62-2.46 10.67z',
                target: '3',
                available: 1,
            },
            {
                path: 'M846.85 708.88l-195.12 22.13-16-5.13-.13-19.19-21.46 15.36-31.75-329.5 40.59-36.04 3.25-2.88 54.12-4.25v-11.16l47.94-3.32.94 10.23 70-3.75.16 3.09 24.59-1.09 12.25 39z',
                target: '4',
                available: 1,
            },
            {
                path: 'M1018.23 357.88l-46.5 35.38-2.25 329.37-16.34-3.16-.33 1.58-87.65-6.92.03-4.45-10.46-.63-7.88-.17-10.62-326.5-12.25-39-.67-50 13.33-6.16.17-11.17 21.54-9.42 15 4.75 12.75-4.75 7-13.25 10.25.5 1.49-3.96h8.45l.56-2.54 54.98 3.24v2.79h6.57l-.17 5.22h8.45l.05 18.13 34.62 28.62z',
                target: '5',
                available: 1,
            },
            {
                path: 'M1213.73 439.63l-20.63 308.75-26.75.13-1.85 31.12h-15.02l-180-57 2.25-329.37 46.5-35.38 21.75 4 3.75-3.72 56.12 12.97 11.5-9.5 44.75 10.47v11.16l47.63 12.25z',
                target: '6',
                available: 1,
            },
            {
                path: 'M1491.34 474.29l-33.36 273.59-90.25 37.75-153.5-1.12-.04-4.42-22.09-.83 1-30.88 20.63-298.75 45.08-.25.36-15.56 50.47-.44 4.17 16h40.17l50.83-16.16 79.01 41.07z',
                target: '7',
                available: 1,
            },
            {
                path: 'M1639.64 707.72l-5.66 11.66-7-1.5-1.5 18.5-7.36 16.43-2.48 2.41-5.66-1.5-4.5 14.16-24.17-7.66-5 8.83-89.41-25.71-16.17-.33-12.75 4.87 33.36-273.59h-7.52l-79.01-41.07 4.83-36.17 21.84-5.17 1.5-13.66 5.66-2.34 4-17 99.34.17 11.66 19 14.17 8.33 92.68 19.17 1.15-6.17 5-8.5 31.34 7.17z',
                target: '8',
                available: 1,
            },
            {
                path: 'M1432.98 378.22l-1.5 13.66-21.84 5.17-4.83 36.17-50.83 16.16-13.17.34 5.33-70.17 59.34-16.67 13.5 8.25 5.75-2.5 13.91 7.25z',
                target: '9',
                available: 1,
            },
        ],
    },
};
function fetchVisualOverview(view) {
    return tslib_es6["b" /* __awaiter */](this, void 0, void 0, function () {
        var serverData, viewData, sections, _i, _a, item, _b, _c, item;
        return tslib_es6["d" /* __generator */](this, function (_d) {
            switch (_d.label) {
                case 0:
                    dispatch(setLoading(true));
                    return [4 /*yield*/, sendVisualRequest({ overviewView: view })];
                case 1:
                    serverData = _d.sent();
                    if (!(view in fetchVisualOverview_data)) {
                        view = 'front';
                    }
                    viewData = tslib_es6["a" /* __assign */]({}, fetchVisualOverview_data[view]);
                    if (serverData.overview && serverData.overview.map) {
                        sections = new Map();
                        for (_i = 0, _a = serverData.overview.map; _i < _a.length; _i++) {
                            item = _a[_i];
                            sections.set(item.target, item.available);
                        }
                        for (_b = 0, _c = viewData.map; _b < _c.length; _b++) {
                            item = _c[_b];
                            if (sections.has(item.target)) {
                                // tslint:disable-next-line:no-non-null-assertion
                                item.available = sections.get(item.target);
                            }
                            else {
                                item.available = 0;
                            }
                        }
                    }
                    // TODO:
                    dispatch(setFilter(serverData.filter));
                    dispatch(setOverview(viewData));
                    dispatch(setLoading(false));
                    return [2 /*return*/];
            }
        });
    });
}
var debouncedFetchVisualOverview = debounce(fetchVisualOverview, 200);
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/asyncActions/fetchVisualSection.ts








// tslint:disable:max-line-length
var fetchVisualSection_paths = [
    // sec1
    [
        '',
        'M1625.34 901.3c1.27-.2 2.31.69 2.31 1.98l-.1 38.71a2.92 2.92 0 0 1-2.31 2.76l-12.05 2.17-4.61.85-157.89 29.66a7.4 7.4 0 0 1-4.34-.73l-38.36-22.01a6.07 6.07 0 0 0-4.27-.45l-11.1 3.55a5.94 5.94 0 0 1-4.24-.49l-152.98-92.08a19.9 19.9 0 0 0-4.28-1.8l-144.63-37.49a3.2 3.2 0 0 1-2.28-2.93l-.21-35.65c-.01-1.29 1.02-2.12 2.28-1.85l144.33 31.34c1.26.27 3.2 1.03 4.32 1.67l153.44 88.92a8.1 8.1 0 0 0 4.35.88l10.92-1.39c1.28-.16 3.26.2 4.4.8l38.29 20.34c1.14.6 3.11.94 4.39.74l174.62-27.5z',
        'M1625.41 847.68a1.97 1.97 0 0 1 2.32 2l-.06 48.91a2.85 2.85 0 0 1-2.32 2.71l-174.64 27.5a8.2 8.2 0 0 1-4.39-.74l-38.29-20.34a8.67 8.67 0 0 0-4.4-.8l-10.92 1.39a8.09 8.09 0 0 1-4.35-.88l-153.44-88.92a17.73 17.73 0 0 0-4.32-1.67l-144.33-31.34a3.02 3.02 0 0 1-2.28-2.84l.14-35.75a1.93 1.93 0 0 1 2.32-1.95l139.71 23.52c1.27.21 3.24.89 4.37 1.51l158.4 85.87a9.4 9.4 0 0 0 4.4.93l12.08-.97c1.29-.1 3.28.28 4.44.84l34.37 16.81c1.16.57 3.15.87 4.42.68l176.77-26.47z',
        'M1625.46 798.96a2.03 2.03 0 0 1 2.32 2.06l-.05 43.97c0 1.29-1.05 2.5-2.32 2.69l-176.78 26.47a8.9 8.9 0 0 1-4.42-.68l-34.37-16.81a9.99 9.99 0 0 0-4.44-.84l-12.08.97a9.43 9.43 0 0 1-4.4-.93l-158.4-85.87a17.28 17.28 0 0 0-4.37-1.51l-139.71-23.52a2.85 2.85 0 0 1-2.3-2.73l.13-33.37a1.92 1.92 0 0 1 2.32-1.94l138.96 24.03c1.27.22 3.27.83 4.45 1.35l159.42 70.93c1.18.52 3.19.83 4.47.69l11.5-1.3a10 10 0 0 1 4.46.7l35.5 16.07c1.17.53 3.18.84 4.46.69l175.65-21.12z',
        'M1625.51 745.38a2.05 2.05 0 0 1 2.33 2.08l-.05 48.86v2.35l-2.33.29-175.64 21.09a9.99 9.99 0 0 1-4.46-.69l-35.5-16.07a10 10 0 0 0-4.46-.7l-11.5 1.3c-1.28.15-3.29-.16-4.47-.69L1230 732.29a23.07 23.07 0 0 0-4.45-1.35l-138.96-24.03a2.87 2.87 0 0 1-2.3-2.74l.15-35.98a1.98 1.98 0 0 1 2.33-2l139.96 20.65c1.28.19 3.3.74 4.49 1.22l157.58 63.61c1.2.48 3.22.75 4.5.6l10.75-1.3c1.28-.15 3.32.08 4.53.51l37.26 13.41c1.21.44 3.25.67 4.53.53l175.14-20.04z',
        'M1625.57 695.2a2.1 2.1 0 0 1 2.33 2.13l-.05 45.44a2.7 2.7 0 0 1-2.33 2.61l-175.14 20.02c-1.28.15-3.32-.09-4.53-.53l-37.26-13.41a11.58 11.58 0 0 0-4.53-.51l-10.75 1.3c-1.28.15-3.31-.11-4.5-.6l-157.58-63.61a24.25 24.25 0 0 0-4.49-1.22l-139.96-20.65a2.8 2.8 0 0 1-2.31-2.69l.15-35.65a2.02 2.02 0 0 1 2.33-2.04l138.6 18.14c1.28.17 3.32.64 4.54 1.06l159.26 54.24c1.22.42 3.27.69 4.56.61l11.09-.7a15.7 15.7 0 0 1 4.58.53l36.06 10.97c1.23.38 3.29.59 4.58.47l175.35-15.91z',
        'M1625.64 643.45a2.12 2.12 0 0 1 2.33 2.15l-.06 47.04a2.63 2.63 0 0 1-2.34 2.56l-175.35 15.92c-1.28.12-3.34-.09-4.58-.47l-36.06-10.97c-1.23-.38-3.3-.62-4.58-.53l-11.09.7c-1.29.08-3.34-.19-4.56-.61L1230.09 645a28.23 28.23 0 0 0-4.54-1.06l-138.6-18.14a2.73 2.73 0 0 1-2.31-2.65l.13-32.98a2.09 2.09 0 0 1 2.34-2.1l141.39 14.84c1.28.13 3.35.53 4.59.89l155.05 44.22c1.24.35 3.3.52 4.58.38l11.5-1.31c1.28-.15 3.35.01 4.59.35l36.87 9.95c1.24.34 3.31.52 4.6.42l175.36-14.36z',
        'M1625.69 591.38c1.29-.09 2.34.9 2.34 2.19l-.05 47.34a2.6 2.6 0 0 1-2.34 2.54l-175.36 14.36c-1.28.11-3.35-.08-4.6-.42l-36.87-9.95a14.76 14.76 0 0 0-4.59-.35l-11.5 1.31c-1.28.15-3.34-.02-4.58-.38l-155.05-44.22c-1.24-.35-3.3-.75-4.59-.89l-141.39-14.84a2.65 2.65 0 0 1-2.32-2.59l.15-36.9a2.15 2.15 0 0 1 2.35-2.16l139.44 11.13c1.29.1 3.36.43 4.62.72l157.95 36.69c1.26.29 3.34.48 4.63.43l10.29-.46c1.29-.06 3.38.1 4.64.36l36.95 7.41c1.26.25 3.35.39 4.64.31l175.24-11.63z',
        'M1625.75 540.16a2.22 2.22 0 0 1 2.34 2.24l-.05 46.47a2.56 2.56 0 0 1-2.34 2.5L1450.43 603c-1.29.09-3.37-.05-4.64-.31l-36.95-7.41a24 24 0 0 0-4.64-.36l-10.29.46c-1.29.06-3.37-.13-4.63-.43l-157.95-36.69a39.97 39.97 0 0 0-4.62-.72l-139.44-11.13a2.58 2.58 0 0 1-2.33-2.53l.14-34.56a2.2 2.2 0 0 1 2.35-2.21l139.87 7.98c1.29.07 3.38.32 4.65.55l156.13 28.15c1.27.23 3.36.32 4.64.21l12.68-1.15c1.28-.12 3.38-.08 4.66.09l36.3 4.66c1.28.16 3.38.25 4.67.2l174.72-7.64z',
        'M1625.81 490.25a2.27 2.27 0 0 1 2.34 2.28l-.05 45.19a2.49 2.49 0 0 1-2.34 2.45l-174.73 7.66c-1.29.06-3.39-.03-4.67-.2l-36.3-4.66c-1.28-.16-3.38-.2-4.66-.09l-12.68 1.15a20.6 20.6 0 0 1-4.64-.21l-156.13-28.15a45.36 45.36 0 0 0-4.65-.55l-139.87-7.98a2.5 2.5 0 0 1-2.33-2.48l.13-33.06a2.32 2.32 0 0 1 2.35-2.31l139.12 2.18c1.29.02 3.39.18 4.67.35l156.69 21.05c1.28.17 3.36.12 4.63-.1l11.69-2.11a18.4 18.4 0 0 1 4.63-.13l36.75 4.61c1.28.16 3.38.26 4.67.22l175.38-5.11z',
        'M1625.88 437.28c1.29-.03 2.34 1 2.34 2.29l-.06 48.27a2.44 2.44 0 0 1-2.35 2.41l-175.38 5.1c-1.29.04-3.39-.06-4.67-.22l-36.75-4.61a18.4 18.4 0 0 0-4.63.13l-11.69 2.11a17.5 17.5 0 0 1-4.63.1l-156.69-21.05a48.66 48.66 0 0 0-4.67-.35l-139.12-2.18a2.38 2.38 0 0 1-2.33-2.38l.15-38.56a2.29 2.29 0 0 1 2.35-2.28l138.36 3.87c1.29.04 3.4.14 4.68.24l159.03 11.82c1.29.1 3.38 0 4.65-.21l11.54-1.9c1.27-.21 3.37-.34 4.65-.28l34.49 1.47c1.29.05 3.4.08 4.69.05l176.04-3.84z',
        'M1626.53 384.51a2.3 2.3 0 0 1 2.31 2.34l-.6 48.04a2.46 2.46 0 0 1-2.37 2.4l-176.04 3.84c-1.29.03-3.4.01-4.69-.05l-34.49-1.47a27.8 27.8 0 0 0-4.65.28l-11.54 1.9c-1.27.21-3.36.3-4.65.21l-159.03-11.82c-1.29-.1-3.39-.2-4.68-.24l-138.36-3.87a2.42 2.42 0 0 1-2.33-2.41l.15-34.81a2.4 2.4 0 0 1 2.35-2.37l138.2-1.56c1.29-.01 3.4 0 4.69.03l34.12.83c1.29.03 3.4.06 4.69.06l136.11.31c1.29 0 3.4-.04 4.69-.09l18.1-.75c1.29-.05 3.4-.1 4.69-.11l193.33-.69z',
        'M1625.99 337.62a2.43 2.43 0 0 1 2.37 2.39l.49 42.15a2.33 2.33 0 0 1-2.32 2.35l-193.35.69c-1.29 0-3.4.05-4.69.11l-18.1.75c-1.29.05-3.4.1-4.69.09l-136.11-.31c-1.29 0-3.4-.03-4.69-.06l-34.12-.83c-1.29-.03-3.4-.05-4.69-.03l-138.2 1.56a2.3 2.3 0 0 1-2.33-2.32l.14-34.81a2.43 2.43 0 0 1 2.35-2.4l139.23-3.55 4.69-.13 155.56-4.98c1.29-.04 3.38-.27 4.65-.51l10.87-2.07c1.27-.24 3.36-.46 4.65-.49l38.5-.8c1.29-.03 3.4-.03 4.69-.01l175.1 3.21z',
    ],
    // sec2
    [
        '',
        'M1082.73 784.16l-.14 40.13-73.21-17.54-35.5-5.75-87.5 13-.08-37.77 87.08-9.73 36 3.5z',
        'M1082.86 744.56l-.13 39.6-73.35-14.16-36-3.5-87.08 9.73-.07-39.52 87.65-7.71 35 1.75z',
        'M1082.99 706l-.13 38.56-73.98-13.81-35-1.75-87.65 7.71-.08-38.71 43.23-3.5 45.16-3.83 35.34 1.33z',
        'M1083.13 665.15l-.14 40.85-73.11-14-35.34-1.33-45.16 3.83-43.23 3.5-.08-39.58 88.97-5.92 33.84 2.75z',
        'M1083.27 625.2l-.14 39.95-74.25-9.9-33.84-2.75-88.97 5.92-.07-39.67 89.88-4.5 32.75 2.75z',
        'M1083.4 585.25l-.13 39.95-74.64-8.2-32.75-2.75-89.88 4.5-.07-37 89.95-6.25 33.75 2.25z',
        'M1083.54 546.07l-.14 39.18-73.77-7.5-33.75-2.25-89.95 6.25-.08-39.37 90.03-4.63 33.75 1.75z',
        'M1083.67 506l-.13 40.07-73.91-6.57-33.75-1.75-90.03 4.63-.08-38.1 89.86-3.78z',
        'M1083.8 465.25l-.13 40.75-108.04-5.5-89.86 3.78-.07-39.03 90.43-3.75z',
        'M1083.94 425.33l-.14 39.92-107.67-3.75-90.43 3.75-.08-39.18 90.26-2.82z',
        'M1084.08 386.3l-.14 39.03-108.06-2.08-90.26 2.82-.08-40.2 89.84-.12z',
        'M1084.21 347l-.13 39.3-108.7-.55-89.84.12-.07-37.62 90.41-.25z',
        'M1131.88 309.83v14.5l-47.6 2-.07 20.67-108.33 1-90.41.25-.07-37.5 201.81-4.75z',
        'M1195.54 280.37v9.96l-63.66 3.79v15.71l-44.67-3.83-201.81 4.75-.08-39.36 89.31-.14 112.75-6z',
        'M1195.54 244.56v35.81l-108.16-15.12-112.75 6-89.31.14-.08-38.23 89.39 1.09 112.75-5.25z',
        'M1195.54 207.68v36.88L1087.38 229l-112.75 5.25-89.39-1.09-.07-40.8 89.96 2.39 112.25-9z',
        'M1195.54 171.52v36.16l-108.16-21.93-112.25 9-89.96-2.39-.04-18.08-43.04-5.35 35.12-18.23 98.17 4.55 111.25-9.75z',
        'M1195.54 133.53v37.99l-108.91-26.02-111.25 9.75-98.17-4.55-35.12 18.23-16.05.07v-26.94l51.5-31.58 98.34 8.27 112-13.75z',
    ],
    // sec3
    [
        '',
        'M1227.88 860.33v36.34l-131.58-10.36-85.09 2.37v5.21L920 897.21l-4.34-3.54-116.12 3.83V860l116.12-2 4.22 1.31 91.5-3.48v-2.5l79.5-2z',
        'M1227.88 823.06v37.27l-137-9-79.5 2v2.5l-91.5 3.48-4.22-1.31-116.12 2v-39l116.12-2 3.97 2.65 91.75-2.48v-2.84l80-1.5z',
        'M1227.88 785.17v37.89l-136.5-8.23-80 1.5v2.84l-91.75 2.48-3.97-2.65-116.12 2v-38l116.12-1.2 4.22 2.53 91.33-3v-2.66l80.5-.67z',
        'M1227.88 743.5v41.67L1091.71 778l-80.5.67v2.66l-91.33 3-4.22-2.53-116.12 1.2v-37.17l116.67-2.24 3.79 2.54 90.88-1.75v-4.13l80.16-.75z',
        'M1227.88 707.83v35.67l-136.84-4-80.16.75v4.13L920 746.13l-3.79-2.54-116.67 2.24V709.5l116-2.37 4.46 1.15 91.04-1.49v-1.71l79.84-.91z',
        'M1227.88 671.67v36.16l-137-3.66-79.84.91v1.71L920 708.28l-4.46-1.15-116 2.37V671l116.34-1.75 3.87 2.07 91.25-1.2v-1.87l79.88.13z',
        'M1227.88 633.5v38.17l-137-3.29-79.88-.13v1.87l-91.25 1.2-3.87-2.07L799.54 671v-37.75l116.5-.5 4.09 1.33 91-.5v-1.05l80.25-.36z',
        'M1227.88 596.17v37.33l-136.5-1.33-80.25.36v1.05l-91 .5-4.09-1.33-116.5.5v-35.87l116.67-.14 3.83-2.24 90.75-.33v1.3l80.34-.22z',
        'M1227.88 560.25v35.92l-136.75-.42-80.34.22v-1.3l-90.75.33-3.83 2.24-116.67.14v-36.54l115.84-.27 5-2.57 90.66-.08v1.51l80.46.82z',
        'M1227.88 522.33v37.92H1091.5l-80.46-.82v-1.51l-90.66.08-5 2.57-115.84.27v-38.09l115.84-.37 4.5-1.88 90 .25v1.17l81.5.71z',
        'M1227.88 484.25v38.08l-136.5.3-81.5-.71v-1.17l-90-.25-4.5 1.88-115.84.37v-38l116.17.06 4.58-1.64 170.84 2.08z',
        'M1227.88 448.35v35.9l-136.75 1-170.84-2.08-4.58 1.64-116.17-.06v-35.48l116-.37 4.59-3.23 90.74 1.81-.01 2.42 80.02.1z',
        'M1227.88 409.5v38.85l-137 1.65-80.02-.1.01-2.42-90.74-1.81-4.59 3.23-116 .37V408.5l119.59-.33 91.83 1.58.04 3.75 80.88 1z',
        'M1227.88 374.12v35.38l-136 5-80.88-1-.04-3.75-91.83-1.58-119.59.33v-36.31l116.5 1.42 4.34-3.28 90.66 2.45v2.51l80.84.63z',
        'M1227.88 335.75v38.37l-136 1.8-80.84-.63v-2.51l-90.66-2.45-4.34 3.28-116.5-1.42v-36.86l117.69 1.42 3.31-1.01 90.5.76-.04 4 80.54.83z',
        'M1227.88 298.5v37.25l-136.34 5.58-80.54-.83.04-4-90.5-.76-3.31 1.01-117.69-1.42v-36.81l117.69 2.3 2.98-1.01 90.33 2.07v3.45l81.09 2.17z',
    ],
    // sec4
    [
        '',
        'M1176.64 883.5l-.03 3.15-56.01 34.38-57.56.27v4.56L959.65 928l-3.61-3.48-151.69 2.14v-3.75l-53.47.49v-38.55l52.12-.53v3.75L950.88 887l11.83 1.34 100.67-1.08v-2.43z',
        'M1176.76 843.17l-.12 40.33-113.26 1.33v2.43l-100.67 1.08-11.83-1.34L803 888.07v-3.75l-52.12.53v-40.11l52.12-.54v2.68l148.38-1.07 11 2.41 100.5-2.14v-2.15z',
        'M1176.89 803.13l-.13 40.04-113.88.76v2.15l-100.5 2.14-11-2.41L803 846.88v-2.68l-52.12.54v-40.49l52.25-.12v3.12l146.91-.47 12.46.05 100.54-1.16v-2.11z',
        'M1177.02 763.38l-.13 39.75-113.85.43v2.11l-100.54 1.16-12.46-.05-146.91.47v-3.12l-52.25.12v-39.38l53.47-.12v1.18l146.9-1.07 11.29 1.34 100.71-1.07v-1.34z',
        'M1177.15 723.82l-.13 39.56-113.77.41v1.34l-100.71 1.07-11.29-1.34-146.9 1.07v-1.18l-53.47.12v-40.12l53.47-.19v.54h146.78l11.58-.72 100.29-.35z',
        'M1177.28 683.48l-.13 40.34-114.15.21-100.29.35-11.58.72H804.35v-.54l-53.47.19v-40.48l53.47-.54v1.61h146.86l11.5-2.01 100.67-.66v1.6z',
        'M1177.4 644.17l-.12 39.31-113.9.79v-1.6l-100.67.66-11.5 2.01H804.35v-1.61l-53.47.54V644.5l53.47-.53V645l147.78-.5 10.75-1.5 100.5-.69v2.19z',
        'M1177.54 602.5l-.14 41.67-114.02.33v-2.19l-100.5.69-10.75 1.5-147.78.5v-1.03l-53.47.53v-40.83l53.47-.55v.54l258.69-1.78v.71z',
        'M1177.66 564.19l-.12 38.31-114.5.09v-.71l-258.69 1.78v-.54l-53.47.55v-39.79l53.47-.29v.54l149.53-1.35 8.75-1.9 100.52.25.06 2.81z',
        'M1177.8 523.39l-.14 40.8-114.45-.25-.06-2.81-100.52-.25-8.75 1.9-149.53 1.35v-.54l-53.47.29V524.3l53.47-.09 149.28-.64 9.5-3.07 99.93.13.07 2.51z',
        'M1177.93 483.66l-.13 39.73-114.67-.25-.07-2.51-99.93-.13-9.5 3.07-149.28.64-53.47.09v-40.8l53.47-.08 148.78.42 9.37-4.21 101.38-.13-.17 3.92z',
        'M1178.05 443.94l-.12 39.72-114.22-.24.17-3.92-101.38.13-9.37 4.21-148.78-.42-53.47.08v-39.73l52.16-.08-.04-2.31 149.54.62 10.96-2.75 99.5-.25-.12 4.69z',
        'M1178.18 404.21l-.13 39.73-115.17-.25.12-4.69-99.5.25-10.96 2.75-149.54-.62.04 2.31-52.16.08v-39.72l51.87-.09.13-1.58 148.09 1.12 9.49-5.71 102.48.38.27 5.79z',
        'M1178.31 363.41l-.13 40.8-114.97-.25-.27-5.79-102.48-.38-9.49 5.71-148.09-1.12-.13 1.58-51.87.09v-40.8l52-.08-.13-1.96 149.65.29 9.64-4.33h101.35l-.01 6z',
        'M1178.44 322.96l-.13 40.45-114.93-.24.01-6H962.04l-9.64 4.33-149.65-.29.13 1.96-52 .08v-39.69l52.16.17.09-3.97 150.16.41 5.59-4 104.2.09.13 5.74z',
        'M1178.56 283.5l-.12 39.46-115.23-.96-.13-5.74-104.2-.09-5.59 4-150.16-.41-.09 3.97-52.16-.17v-39.9l52.33.17.09-2.43 149.99.43 5.59-6.5 104.2 1.17.13 6.67z',
        'M1208.21 260.67l-29.57 3.03-.08 19.8-115.35-.33-.13-6.67-104.2-1.17-5.59 6.5-149.99-.43-.09 2.43-52.33-.17v-40.51l52 .17.08-2.43 150.33.11 5.59-5.67 104.04.84.12 7.16 115.61 1.04z',
        'M1234.88 244v13.75l-26.67 2.92-29.56-16.3-115.61-1.04-.12-7.16-104.04-.84-5.59 5.67-150.33-.11-.08 2.43-52-.17v-39.56l52 .17.08-5.51 150.33.29 5.59-4.79 104.2 1.25.13 7 115.44 1.33z',
        'M1234.88 206v38l-56.23-40.67-115.44-1.33-.13-7-104.2-1.25-5.59 4.79-150.33-.29-.08 5.51-52-.17v-44.87l52.33.17.09-2.43 149.99 1.48 5.59-6.94 104.2 1.17.13 6.73 115.44 1.95z',
    ],
    // sec5
    [
        '',
        'M975.38 858L961 859.38 942.88 862l.06 24.81-124.56-14.3v-32.37l143.74 15.28 13.26 2.58z',
        'M1156.88 812.98v37.69l-47-14.17-8.67.33-.83 8.5-125 12.67-13.26-2.58-143.74-15.28V805.5l143.74 11 29.53 11.14 19.04-.36 10.96 3.31 16.32-1.59 7.86.25 101.21-9.75v-4.87z',
        'M1156.88 777.95v35.03l-9.84 1.65v4.87l-101.21 9.75-7.86-.25-16.32 1.59-10.96-3.31-19.04.36-29.53-11.14-143.74-11v-35.94l143.74 10.65 29.53 11.41 19.04-.37 10.9 4.79 16.38-.91 7.16-3.38 101.91-9v-3.15z',
        'M1156.88 740.04v37.91l-9.84 1.65v3.15l-101.91 9-7.16 3.38-16.38.91-10.9-4.79-19.04.37-29.53-11.41-143.74-10.65v-34.19l143.74 7.88 29.53 8.49 19.04-1.07 10.96 1.66 16.32-.33 7.86-1.22 101.21-5.28v-3.8z',
        'M1156.88 702.05v37.99l-9.84 1.66v3.8l-101.21 5.28-7.86 1.22-16.32.33-10.96-1.66-19.04 1.07-29.53-8.49-143.74-7.88v-35.22l143.74 4.18 29.53 8.43 19.04-.37 10.96 1.71 16.32-.6 7.86 4.05 101.21-5.3v-8.55z',
        'M1156.88 669.43v32.62l-9.84 1.65v8.55l-101.21 5.3-7.86-4.05-16.32.6-10.96-1.71-19.04.37-29.53-8.43-143.74-4.18v-35.17l143.74 1.4 29.53 7.45 19.04-.38 10.96 3.5 16.32-.6 7.86-2.68 101.21-3.5z',
        'M1156.88 635.25v34.18l-9.84.74-101.21 3.5-7.86 2.68-16.32.6-10.96-3.5-19.04.38-29.53-7.45-143.74-1.4v-33.77l143.74 1.12 29.53 3.96 19.04-.38 10.96 2.52 16.32-.61 7.86.51 101.21-2.93z',
        'M1156.88 598.63v36.62l-9.84.15-101.21 2.93-7.86-.51-16.32.61-10.96-2.52-19.04.38-29.53-3.96-143.74-1.12V597l143.74-1 29.53 2.5 19.04-1.98 10.98 1.8 16.31.01 7.85.92h101.21z',
        'M1156.88 556.69v41.94l-9.84.62h-101.21l-7.85-.92-16.31-.01-10.98-1.8-19.04 1.98-29.53-2.5-143.74 1v-35.75l143.74-1.75 29.53-.02 19.04-.37 10.98.8 16.31.02 7.85.96 101.21-3.28v-.25z',
        'M1156.88 523.33v33.36l-9.84.67v.25l-101.21 3.28-7.85-.96-16.31-.02-10.98-.8-19.04.37-29.53.02-143.74 1.75v-34l143.74-3 29.53-2.99 19.04-.37 10.98.11 16.31.01 7.85-.03 101.21 2.77v-.25z',
        'M1156.88 485v38.33l-9.84.17v.25l-101.21-2.77-7.85.03-16.31-.01-10.98-.11-19.04.37-29.53 2.99-143.74 3v-35.92l143.74-5 83.71-6.08 101.21 4.75z',
        'M1156.88 447.5V485h-9.84l-101.21-4.75-83.71 6.08-143.74 5v-35.58l143.78-6.58 29.53-3.17 17.85-3.83 36.33-1.17 101.2 4v2.01z',
        'M1156.88 410.75v36.75l-9.81-.49V445l-101.2-4-36.33 1.17-17.85 3.83-29.53 3.17-143.78 6.58v-34l143.78-10.3 29.53-5.31 19.04.36 35.14-1 101.2 4.54z',
        'M1156.88 373.17v37.58l-9.81-.71-101.2-4.54-35.14 1-19.04-.36-29.53 5.31-143.78 10.3V387l143.78-11.5 29.53-5.17 19.04-5.16 10.97-1.45 16.31.45 7.86 3.3 101.2 4.53v.99z',
        'M1156.88 335.5v37.67l-9.81-.18V372l-101.2-4.53-7.86-3.3-16.31-.45-10.97 1.45-19.04 5.16-29.53 5.17L818.38 387v-35l143.78-14.12 29.53-5.38 19.04-4.49 10.97-1.98 15.74.41 8.43-2.12 101.2 6.51v3.69z',
        'M1156.88 299.33v36.17l-9.81-.98v-3.69l-101.2-6.51-8.43 2.12-15.74-.41-10.97 1.98-19.04 4.49-29.53 5.38L818.38 352v-33.5l143.78-15.83 29.53-7.92 19.04-6.02 10.97-2.97 16.31.99 7.86 2.28 101.2 7.52v1.97z',
        'M1156.88 262.5v36.83l-9.81-.81v-1.97l-101.2-7.52-7.86-2.28-16.31-.99-10.97 2.97-19.04 6.02-29.53 7.92-143.78 15.83v-35l143.78-18.25 29.53-10.16 19.04-3.47 10.97-3.96 16.31.99 7.86.99 101.2 9.48v2.97z',
        'M1156.88 223.33v39.17l-9.81-.41v-2.97l-101.2-9.48-7.86-.99-16.31-.99-10.97 3.96-19.04 3.47-29.53 10.16-143.78 18.25v-33.75l143.78-22 29.53-11.25 18.4-3.48 10.97-3.95 16.31.99 7.86-2.97 101.2 12.44v2.97z',
        'M1156.88 189v34.33l-10.45-.83v-2.97l-101.2-12.44-7.86 2.97-16.31-.99-10.97 3.95-18.4 3.48-29.53 11.25-143.78 22V214.5l143.78-23.3 29.53-10.89 19.04-4.03 10.97-4.95 16.31.99 7.86-.24 100.22 12.45v2.97z',
        'M1156.88 151.75V189l-10.79-1.5v-2.97l-100.22-12.45-7.86.24-16.31-.99-10.97 4.95-19.04 4.03-29.53 10.89-143.78 23.3v-34.33l143.78-25.55 29.53-15.87 19.04.67 10.97-6.93 16.31 1.98 7.86-2.97 100.22 14.79v3.96z',
        'M1156.88 112.5v39.25l-10.79-1.5v-3.96l-100.22-14.79-7.86 2.97-16.31-1.98-10.97 6.93-19.04-.67-29.53 15.87-143.78 25.55V145l143.78-27.75 29.53-16.53 19.04-1.14 10.97-6.93 16.31 1.98 7.86-3.96 100.22 15.43v4.95z',
        'M1156.88 75.62v36.88l-10.79-1.45v-4.95l-100.22-15.43-7.86 3.96-16.31-1.98-10.97 6.93-19.04 1.14-29.53 16.53L818.38 145v-35.75L962.16 79.5l29.53-21.4 19.04 2.97 10.97-8.57 16.31 2.88 7.86-3.22 100.22 15.43v4.95z',
    ],
    // sec6
    [
        '',
        'M774.59 900.14l.02 1.97 55.51 35.66 60.92.28v4.73l108.46.58.71-3.61 155.86-1.67v-3.89l41.06-.94.41-38.37-41.54-.38v3.89L1001.21 901l-6.33 1-103.84.38v-1.55z',
        'M774.46 858.5l.13 41.64 116.45.69v1.55l103.84-.38 6.33-1 154.79-2.61v-3.89l41.54.38v-41.05h-41.66v6.2l-154.12-.29-7.38.26-103.5.02v-2.35z',
        'M774.33 816.8l.13 41.7 116.42-.83v2.35l103.5-.02 7.38-.26 154.12.29v-6.2h41.66V812l-41.16.47v2.78l-155.62.63-6.88 2.12-103 .25v-1.92z',
        'M774.21 774.83l.12 41.97 116.55-.47v1.92l103-.25 6.88-2.12 155.62-.63v-2.78l41.16-.47v-40.67l-41.16.13v1.67l-154.87.48-7.47 1.89-102.91.55v-1.39z',
        'M774.08 732.6l.13 42.23 116.92-.17v1.39l102.91-.55 7.47-1.89 154.87-.48v-1.67l41.16-.13V731.5l-41.66.61v.56h-154.54l-7.3.83-102.91.67v-1.39z',
        'M773.95 691.36l.13 41.24 117.05.18v1.39l102.91-.67 7.3-.83h154.54v-.56l41.66-.61v-42h-41.5v.83l-155.33.73-6.5.27-103.17.84v-1.39z',
        'M773.83 650.1l.12 41.26 117.09-.58v1.39l103.17-.84 6.5-.27 155.33-.73v-.83h41.5V648l-41.33.17v1.16h-156.5l-6 .28-103.92.64v-.28z',
        'M773.7 607.83l.13 42.27 115.96-.13v.28l103.92-.64 6-.28h156.5v-1.16l41.33-.17v-39.67l-41.66-.01v.56l-265.09-.8z',
        'M773.58 566.67l.12 41.16 117.09.25 265.09.8v-.56l41.66.01v-41.37l-41.83-.18v.55l-156.33-.5-5.34-2.58-103.54.63.04 2.12z',
        'M773.94 524.26l-.36 42.41 116.96.33-.04-2.12 103.54-.63 5.34 2.58 156.33.5v-.55l41.83.18V527l-42.83.33-155.73-.1-4.77-3.4-102.83.17z',
        'M773.31 483.99l.63 40.27 117.44-.26 102.83-.17 4.77 3.4 155.73.1 42.83-.33v-40.5l-41.5.13v-.75L999 484.63l-4.46-2.95-103.58.15-.08 1.92z',
        'M773.18 442.87l.13 41.12 117.57-.24.08-1.92 103.58-.15 4.46 2.95 157.04 1.25v.75l41.5-.13v-41.08l-41.5-.09-.08-1.45-156.58.5-5.13-4.55-103.56.05-.06 2.74z',
        'M773.06 401.66l.12 41.21 117.45-.25.06-2.74 103.56-.05 5.13 4.55 156.58-.5.08 1.45 41.5.09v-40.54l-41.54.25-.12-3-155.88-.3-5.79-4.83-103.17.39-.26 4.02z',
        'M772.93 360.17l.13 41.49 117.72-.25.26-4.02 103.17-.39 5.79 4.83 155.88.3.12 3 41.54-.25V364.5l-41.66-.17v-3.5L999 361l-4.75-5.5H891.13l.01 4.42z',
        'M772.8 318l.13 42.17 118.21-.25-.01-4.42h103.12L999 361l156.88-.17v3.5l41.66.17v-41.34l-42.33.17-.08-4-155.46-.16-5.54-5.92-103.12.1-.13 4.84z',
        'M772.68 277.5l.12 40.5 118.08.19.13-4.84 103.12-.1 5.54 5.92 155.46.16.08 4 42.33-.17v-40.83l-41.5.18-.08-4.18-156.29-1-5.54-6.04-103.37.21-.13 6.41z',
        'M735.88 252.75l36.73 3.16.07 21.59 117.95.41.13-6.41 103.37-.21 5.54 6.04 156.29 1 .08 4.18 41.5-.18v-40.51l-41.5.18-.08-5.33-156.21.16-5.54-8.02-103.2 1.21-.13 4.76-118.28 1.08z',
        'M694.88 238.25v10l41 4.5 36.72-16.89 118.28-1.08.13-4.76 103.2-1.21 5.54 8.02 156.21-.16.08 5.33 41.5-.18v-41.07l-41.66.18-.09-5.43-156.02-.36-6.14-7.37-102.87.1-.13 5.88-118.03-1z',
        'M694.88 198.5v39.75l77.72-45.5 118.03 1 .13-5.88 102.87-.1 6.14 7.37 156.02.36.09 5.43 41.66-.18v-43.67l-41.91-.25-.09-5.6-155.62-.04-5.54-7.19-103-.5-.13 6.98-118.65-1.26z',
    ],
    // sec7
    [
        '',
        'M727.78 840.5v38l143.94-7.25 90.34 2.56v5.69l104.83 5.33 2.93-4.83 128.06 8v-39.83l-126.17-3.34-4.82-3.7-104.83-4.6v1.8L871.72 835z',
        'M727.78 799v41.5l143.94-5.5 90.34 3.33v-1.8l104.83 4.6 4.82 3.7 126.17 3.34V805.5l-127-4.17-3.99-3L962.06 795v3l-90.34-3.67z',
        'M727.78 757.5V799l143.94-4.67 90.34 3.67v-3l104.83 3.33 3.99 3 127 4.17v-43l-127-2.5-3.99-3.24-104.83-2.77v1.18l-89.54-1.5z',
        'M727.78 715.75v41.75l144.74-3.83 89.54 1.5v-1.18l104.83 2.77 3.99 3.24 127 2.5V714l-128.06-.67-2.93.1-104.83-2.11v3.85l-90.9-2.17z',
        'M727.78 674.17v41.58L871.16 713l90.9 2.17v-3.85l104.83 2.11 2.93-.1 128.06.67v-38l-126.84-.17-4.15-4.4-104.83-1.76v3.16l-90.34-.66z',
        'M727.78 633.5v40.67l143.94-2 90.34.66v-3.16l104.83 1.76 4.15 4.4 126.84.17v-43.67l-127.17.17-3.82-3.77-104.83-.06v2.83l-90.34 1.17z',
        'M727.78 591.67v41.83l143.94-.83 90.34-1.17v-2.83l104.83.06 3.82 3.77 127.17-.17v-41.58l-127.34.42-3.65-4.67-104.83.3v5.78l-90.34-1.08z',
        'M727.78 550.33v41.34l143.94-.17 90.34 1.08v-5.78l104.83-.3 3.65 4.67 127.34-.42v-42.42l-127 .17-3.99-4.17-104.83.72v5.45l-90.34.83z',
        'M727.78 508.5v41.83l143.94 1 90.34-.83v-5.45l104.83-.72 3.99 4.17 127-.17v-43.66l-126.84 1.16-4.15-4.08-104.83 1.42v5l-90.34 2z',
        'M727.78 467.5v41l143.94 1.67 90.34-2v-5l104.83-1.42 4.15 4.08 126.84-1.16V462l-126.84.92-4-3.75-104.98 1.41v7.25l-90.34 1.84z',
        'M727.78 425.67v41.83l143.94 2.17 90.34-1.84v-7.25l104.98-1.41 4 3.75 126.84-.92v-43.17L1071.04 422l-3.66-5.33-106.84 2.83v7.5l-88.82 2.5z',
        'M727.78 383.07v42.6l143.94 3.83 88.82-2.5v-7.5l106.84-2.83 3.66 5.33 126.84-3.17v-43.16l-127 5-3.34-6-106.5 3.16.01 8.34-89.33 2.5z',
        'M727.78 342.5v40.57l143.94 5.6 89.33-2.5-.01-8.34 106.5-3.16 3.34 6 127-5v-43l-126.84 6.46-3.98-7.13-105.52 4 .08 9-89.9 3.83z',
        'M727.78 302.05v40.45l143.94 6.33 89.9-3.83-.08-9 105.52-4 3.98 7.13 126.84-6.46V289.5l-127 8.09-3.82-8.84-106.02 5.42v9.5L875 307.5z',
        'M727.78 258.93v43.12L875 307.5l86.04-3.83v-9.5l106.02-5.42 3.82 8.84 127-8.09v-43.62l-127.84 7.35-2.98-5.84-106.02 6.28v7.58l-86.04 5z',
        'M727.78 217.87v41.06L875 266.25l86.04-5v-7.58l106.02-6.28 2.98 5.84 127.84-7.35V204l-127.5 7-3.32-1.11-106.02 6.44v3.77L875 226.63z',
    ],
    // sec8
    [
        '',
        'M997.24 792.96l.17 42.04 84.22-17 31.25-2 103.23 21 .1-37.67-58.17-13.5-39.91-8.58-36.75.25z',
        'M997.09 751.46l.15 41.5 84.14-15.46 36.75-.25 39.91 8.58 58.17 13.5.08-44.08-97.91-17.92-38 1.17z',
        'M996.93 709.11l.16 42.35 83.29-12.96 38-1.17 97.91 17.92.1-42.08-97.76-15.67-37.59 1.67z',
        'M996.76 667.14l.17 41.97 84.11-9.94 37.59-1.67 97.76 15.67.1-44.17-97.86-13.5-37.75 2z',
        'M996.59 625.42l.17 41.72 84.12-9.64 37.75-2 97.86 13.5.08-42.83-98.69-10.17-36.67.5z',
        'M996.43 584.44l.16 40.98 84.62-8.92 36.67-.5 98.69 10.17.09-40.67-98.53-9.25h-37.25z',
        'M996.26 542.8l.17 41.64 84.45-8.19h37.25l98.53 9.25.09-41.75-98.54-9.25-35.83.5z',
        'M996.1 500.5l.16 42.3 86.12-7.8 35.83-.5 98.54 9.25.1-43.42-97.97-6.33-38 1z',
        'M995.94 459.02l.16 41.48 84.78-5.5 38-1 97.97 6.33.09-42.06-98.23-4.77-37.58 1z',
        'M995.77 416.72l.17 42.3 85.19-4.52 37.58-1 98.23 4.77.09-42.46-136.15-2.06z',
        'M995.6 375.08l.17 41.64 85.11-2.97 136.15 2.06.1-41.06-135.59-1.58z',
        'M995.45 333.86l.15 41.22 85.94-1.91 135.59 1.58.08-40.48-136.96-1.14z',
        'M945.88 298.5V313l49.48 1.74.09 19.12 84.8-.73 136.96 1.14.09-43.02-222.83-.35z',
        'M899.38 261v17.88l46.5 1.07v18.55l48.59-7.6 222.83.35.1-40.25-136.52.25-86.66-1.65z',
        'M899.38 227.5V261l94.84-11.4 86.66 1.65 136.52-.25.09-42-136.36 3.25-87.05-.95z',
        'M899.38 188.25v39.25l94.7-16.2 87.05.95 136.36-3.25.09-41-136.7 2.75-85.81-4.5z',
        'M899.38 151.59v36.66l95.69-22 85.81 4.5 136.7-2.75.05-22.5 64.67-6.39-64.31-11.86-136.61 3.25-86.31-6z',
        'M899.38 111.78v39.81l95.69-27.09 86.31 6 136.61-3.25 64.31 11.86 15.24-.55V109.5l-79.95-30.25-98.05 9.58-38.41-.58-86.06-5.85z',
    ],
    // sec9
    [
        '',
        'M457.42 866.57c-1.22-.4-2.22.32-2.22 1.6l.05 44.49c0 1.29 1 2.68 2.22 3.1l126.86 43.48c1.22.42 3.25.96 4.51 1.21l15.74 3.1a8.7 8.7 0 0 0 4.43-.5l39.1-17.47a7.56 7.56 0 0 1 4.39-.32l9.37 2.62c1.24.35 3.2.17 4.35-.4l175.71-86.11c1.16-.57 3.14-1.2 4.41-1.41l148.22-24.35a2.85 2.85 0 0 0 2.3-2.72l-.15-37.39a1.93 1.93 0 0 0-2.32-1.95l-147.97 24.7c-1.27.21-3.27.82-4.44 1.36l-175.66 80.18c-1.17.53-3.11.6-4.32.15l-10.29-3.86a6.79 6.79 0 0 0-4.34.09l-39.03 16.59c-1.18.5-3.18.68-4.43.39l-16.44-3.78a63.87 63.87 0 0 1-4.5-1.26l-125.55-41.54z',
        'M457.37 818.33c-1.23-.36-2.24.39-2.24 1.68l.06 43.49c0 1.29 1 2.67 2.22 3.07l125.57 41.53c1.22.4 3.25.97 4.5 1.26l16.44 3.78c1.25.29 3.25.11 4.43-.39l39.03-16.59a6.72 6.72 0 0 1 4.34-.09l10.29 3.86c1.2.45 3.15.38 4.32-.15L842 819.6a22.13 22.13 0 0 1 4.44-1.36l147.97-24.7a2.86 2.86 0 0 0 2.3-2.72l-.14-36.84a1.97 1.97 0 0 0-2.32-2l-148.3 21.45a22.5 22.5 0 0 0-4.48 1.22l-175.79 72.22c-1.19.49-3.2.72-4.47.52l-10.35-1.67a10.6 10.6 0 0 0-4.51.43l-36.93 13.4c-1.21.44-3.23.6-4.5.37l-16.73-3.14a58.77 58.77 0 0 1-4.54-1.09l-126.28-37.36z',
        'M457.34 772.2c-1.25-.3-2.28.52-2.27 1.8l.05 41.32a3.31 3.31 0 0 0 2.25 3l126.27 37.34c1.23.36 3.28.86 4.54 1.09l16.73 3.14c1.26.24 3.29.07 4.5-.37l36.93-13.4c1.21-.44 3.24-.63 4.51-.43l10.35 1.67a9.71 9.71 0 0 0 4.47-.52l175.79-72.22a22.5 22.5 0 0 1 4.48-1.22l148.3-21.45a2.79 2.79 0 0 0 2.31-2.67l-.14-37.7a1.98 1.98 0 0 0-2.33-2.01l-148.06 20.85c-1.27.18-3.31.69-4.51 1.13l-175.44 63.9a9.9 9.9 0 0 1-4.49.35l-9.41-1.85a11 11 0 0 0-4.53.24l-37.87 11.78c-1.23.38-3.27.51-4.54.29l-12.39-2.19a100.4 100.4 0 0 1-4.58-.94L457.34 772.2z',
        'M457.28 720.79c-1.25-.3-2.28.51-2.27 1.8l.05 46.73v2.35l2.28.54 130.93 30.92c1.25.3 3.31.72 4.58.94l12.39 2.19c1.27.22 3.31.09 4.54-.29l37.87-11.78a11 11 0 0 1 4.53-.24l9.41 1.85a9.9 9.9 0 0 0 4.49-.35l175.44-63.9c1.21-.44 3.24-.95 4.51-1.13l148.06-20.85a2.78 2.78 0 0 0 2.31-2.67l-.15-37.32a2.01 2.01 0 0 0-2.33-2.04l-149.14 19.07a30.8 30.8 0 0 0-4.55 1.01l-173.88 55.9a12 12 0 0 1-4.54.36l-9.88-1.53c-1.27-.2-3.32-.06-4.56.3l-37.01 10.93c-1.23.36-3.29.53-4.56.36l-16.61-2.15a55.46 55.46 0 0 1-4.6-.84l-127.31-30.16z',
        'M457.25 672.77a1.87 1.87 0 0 0-2.3 1.91l.05 43.24a3.12 3.12 0 0 0 2.28 2.88l127.32 30.17c1.25.3 3.32.67 4.6.84l16.61 2.15c1.28.17 3.33 0 4.56-.36l37.01-10.93c1.23-.36 3.28-.5 4.56-.3l9.88 1.53c1.27.2 3.31.04 4.54-.36l173.88-55.9c1.22-.39 3.27-.85 4.55-1.01l149.14-19.07a2.71 2.71 0 0 0 2.31-2.64l-.15-37.07a2.09 2.09 0 0 0-2.34-2.1l-148.21 15.03c-1.28.13-3.34.52-4.58.87l-175.31 48.99a20.4 20.4 0 0 1-4.59.64l-8.84.05c-1.29.01-3.36.26-4.62.56l-38.78 9.25c-1.25.3-3.3.3-4.55.01l-14.11-3.28c-1.25-.29-3.31-.72-4.58-.96l-128.33-24.14z',
        'M457.18 624.06a1.9 1.9 0 0 0-2.3 1.94l.06 43.99a2.94 2.94 0 0 0 2.3 2.77l128.33 24.14c1.26.24 3.32.67 4.58.96l14.11 3.28a12 12 0 0 0 4.55-.01l38.78-9.25c1.25-.3 3.33-.55 4.62-.56l8.84-.05c1.29-.01 3.35-.3 4.59-.64l175.31-48.99c1.24-.35 3.3-.74 4.58-.87l148.21-15.03a2.65 2.65 0 0 0 2.32-2.58l-.14-36.32a2.12 2.12 0 0 0-2.34-2.14L846.2 597.46a35.9 35.9 0 0 0-4.6.77l-175.73 44.19c-1.25.31-3.31.39-4.57.17l-8.79-1.53c-1.27-.22-3.34-.2-4.6.04l-38.41 7.44c-1.26.24-3.34.31-4.62.15l-14.02-1.75c-1.28-.16-3.36-.47-4.63-.69l-129.05-22.19z',
        'M457.14 575.99a1.98 1.98 0 0 0-2.31 2.02l.05 43.32a2.89 2.89 0 0 0 2.31 2.74l129.06 22.21c1.27.22 3.35.53 4.63.69l14.02 1.75c1.28.16 3.36.09 4.62-.15l38.41-7.44c1.26-.24 3.33-.26 4.6-.04l8.79 1.53c1.27.22 3.33.14 4.57-.17l175.73-44.19a35.9 35.9 0 0 1 4.6-.77l147.38-12.76a2.58 2.58 0 0 0 2.32-2.54l-.15-36.99a2.17 2.17 0 0 0-2.34-2.18l-147.88 10.1c-1.28.09-3.37.37-4.63.63l-175.04 36.06c-1.26.26-3.34.43-4.63.37l-9.37-.39c-1.29-.05-3.38.06-4.65.26L608.85 596c-1.27.2-3.36.23-4.63.07l-14.36-1.76c-1.28-.16-3.36-.43-4.64-.61l-128.08-17.71z',
        'M457.09 529.22a2.07 2.07 0 0 0-2.32 2.11l.05 42a2.78 2.78 0 0 0 2.32 2.66l128.09 17.69c1.27.18 3.36.45 4.64.61l14.36 1.76c1.28.16 3.36.12 4.63-.07l38.38-5.95c1.27-.2 3.36-.31 4.65-.26l9.37.39c1.29.05 3.37-.12 4.63-.37l175.04-36.06c1.26-.26 3.34-.54 4.63-.63L993.44 543a2.55 2.55 0 0 0 2.33-2.5l-.14-37.65a2.21 2.21 0 0 0-2.34-2.22l-148.05 7.76c-1.29.07-3.37.31-4.64.53l-174.66 30.93c-1.27.22-3.36.41-4.64.42l-8.39.05c-1.29.01-3.39.1-4.67.21l-39.34 3.28c-1.28.11-3.38.1-4.66-.01l-14.01-1.25c-1.28-.11-3.38-.31-4.66-.44l-128.48-12.89z',
        'M457.03 479.28a2.15 2.15 0 0 0-2.33 2.17l.05 45.2a2.65 2.65 0 0 0 2.33 2.57l128.46 12.88c1.28.13 3.38.33 4.66.44l14.01 1.25c1.28.11 3.38.12 4.66.01l39.34-3.28a72.6 72.6 0 0 1 4.67-.21l8.39-.05a34.2 34.2 0 0 0 4.64-.42l174.66-30.93c1.27-.22 3.36-.46 4.64-.53l148.05-7.76a2.5 2.5 0 0 0 2.33-2.46l-.14-36.82c0-1.29-1.06-2.3-2.35-2.24l-147.56 6.14c-1.29.05-3.38.23-4.66.39l-175.36 22.41c-1.28.16-3.37.19-4.65.06l-8.68-.87a32.95 32.95 0 0 0-4.66-.07l-37.67 2.67c-1.28.09-3.39.11-4.67.04l-14.33-.75c-1.28-.07-3.39-.2-4.67-.3l-129.16-9.54z',
        'M456.96 426.36a2.1 2.1 0 0 0-2.33 2.12l.06 48.29a2.56 2.56 0 0 0 2.34 2.51l129.18 9.54c1.28.09 3.38.23 4.67.3l14.33.75c1.28.07 3.39.05 4.67-.04l37.67-2.67c1.28-.09 3.38-.06 4.66.07l8.68.87c1.28.13 3.37.1 4.65-.06l175.36-22.41c1.28-.16 3.37-.34 4.66-.39l147.56-6.14a2.46 2.46 0 0 0 2.33-2.44l-.15-37.65a2.27 2.27 0 0 0-2.35-2.27l-147.73 4.57c-1.29.04-3.39.16-4.67.26l-188.34 14.91-4.67.36-39.33 2.98c-1.28.1-3.38.1-4.67.01l-13.67-.99c-1.28-.09-3.38-.27-4.66-.39l-128.25-12.09z',
        'M456.91 380.76a2.22 2.22 0 0 0-2.33 2.24l.05 40.8a2.63 2.63 0 0 0 2.33 2.56l128.26 12.08c1.28.12 3.38.3 4.66.39l13.67.99c1.28.09 3.38.09 4.67-.01l39.33-2.98 4.67-.36 188.34-14.91c1.28-.1 3.38-.22 4.67-.26l147.73-4.57a2.43 2.43 0 0 0 2.33-2.41l-.15-36.99a2.33 2.33 0 0 0-2.35-2.32l-147.9 1.09c-1.29.01-3.39.07-4.68.13l-187.33 8.98-4.67.22-31.99 1.45c-1.29.06-3.39.08-4.68.04l-19.66-.54-4.68-.16-130.29-5.46z',
        'M456.85 334.12a2.37 2.37 0 0 0-2.34 2.36l.05 41.84a2.47 2.47 0 0 0 2.34 2.44l130.3 5.47c1.29.05 3.39.13 4.68.16l19.66.54c1.29.04 3.39.02 4.68-.04l31.99-1.45 4.67-.22 187.33-8.98c1.29-.06 3.39-.12 4.68-.13l147.9-1.09a2.35 2.35 0 0 0 2.33-2.36l-.14-36.57a2.4 2.4 0 0 0-2.35-2.37l-138.66-1.67c-1.29-.02-3.39-.02-4.68-.02l-139.76.62-4.68.01h-9.47c-1.29 0-3.39-.02-4.68-.04l-33.64-.59c-1.29-.02-3.39-.03-4.68-.02l-195.53 2.11z',
    ],
];
var backPaths = [
    // sec1b
    [
        '',
        'M1373.5 829.5v32l-52.5 55.83-213.33 47-17.67-5.16-38.67 7.83-117.08-41.26-.02-40.35 116.44 38.11 39.5-7.17 17.66 5.5 213-42.5z',
        'M1373.5 794.67v34.83l-52.67 49.83-213 42.5-17.66-5.5-39.5 7.17-116.44-38.11-.02-41.48 116.46 34.26 39.83-7 16.67 4.83 213.66-37.83z',
        'M1373.5 759v35.67l-52.67 43.5L1107.17 876l-16.67-4.83-39.83 7-116.46-34.26-.02-41.91L1051 832.33l39-5.16 17.5 3.83 212.67-32.67z',
        'M1373.5 725.17V759l-53.33 39.33L1107.5 831l-17.5-3.83-39 5.16L934.19 802l-.02-40.06 116.5 25.06 40-5 16.66 3.17 213.17-28.34z',
        'M1373.5 691.5v33.67l-53 31.66-213.17 28.34-16.66-3.17-40 5-116.5-25.06-.02-41.47L1050.67 741l39.66-3.67 17.17 1.67 213-22z',
        'M1373.5 653.17v38.33l-53 25.5-213 22-17.17-1.67-39.66 3.67-116.52-20.53-.02-42.97 116.54 18 39.66-2.5 17.17 1.5 216.6-19.1z',
        'M1373.5 619.67v33.5l-49.4 22.23-216.6 19.1-17.17-1.5-39.66 2.5-116.54-18-.02-38.98 116.72 11.65 39.5-2 17.34 1.5 217.5-14.34z',
        'M1373.5 584.33v35.34l-48.33 15.66-217.5 14.34-17.34-1.5-39.5 2-116.72-11.65-.03-41.43L1051 605l40-1.33 16.67.83 217.16-9.5z',
        'M1373.5 550.67v33.66L1324.83 595l-217.16 9.5-16.67-.83-40 1.33-116.92-7.91-.02-42.92 116.94 4.5 39.33-1.17 17.5 1.33 217.06-5.5z',
        'M1373.5 514.67v36l-48.61 2.66-217.06 5.5-17.5-1.33-39.33 1.17-116.94-4.5-.02-40.31 116.79-.62 40-.33 234.06-.74z',
        'M1373.5 481v33.67l-48.61-2.5-234.06.74-40 .33-116.79.62-.02-41.25 116.48-4.28h40.33l16.5-.33 217.56 4.84z',
        'M1373.5 444v37l-48.61-8.16-217.56-4.84-16.5.33h-40.33l-116.48 4.28-.02-42.77 109.13-8.44 43.65 1.64 15.38-.98 222.73 7.85z',
    ],
    // sec2b
    [
        '',
        'M1338.25 923.48l-14.25 5.69-9.87 3.2-17.96-2.04L1282 938l.25 11.83-26.42 13.17-81.83-8.17v-4.16L981.25 931l-146.89 10 .02-46.33 147.37-8.92L1173.17 905v4.67l82 5 27.08-10.34V890.5l13.18-3.74 18.7.8 24.07-7.58z',
        'M1338.2 879.98l-24.07 7.58-18.7-.8-13.18 3.74v13.83l-27.08 10.34-82-5V905l-191.42-19.25-147.37 8.92.03-45 147.34-7.42 192.25 16v3.08l81.17 3.84 27.08-8.67v-10.83l14.17-3.67 17.71 1 24.01-7.83z',
        'M1338.14 835.17l-24.01 7.83-17.71-1-14.17 3.67v10.83l-27.08 8.67-81.17-3.84v-3.08l-192.25-16-147.34 7.42.02-46L982 797.5l191.33 12.71v3.29l81.84 3.5 27.08-8v-6.83l14.17-4.34 17.71.67 23.96-5.17z',
        'M1338.09 793.33l-23.96 5.17-17.71-.67-14.17 4.34V809l-27.08 8-81.84-3.5v-3.29L982 797.5l-147.57 6.17.03-45L981 753.5l192.67 8.54v3.29l82 3.17 26.58-6.5v-5.83l14.17-2.67 17.71.83 23.91-5z',
        'M1338.04 749.33l-23.91 5-17.71-.83-14.17 2.67V762l-26.58 6.5-82-3.17v-3.29L981 753.5l-146.54 5.17.02-47.67 147.77-2.75 191.58 6.69v2.23l82 1.33 26.42-5.51v-2.49l14.17-1.5 17.71.25 23.84-2.92z',
        'M1337.97 706.33l-23.84 2.92-17.71-.25-14.17 1.5v2.49l-26.42 5.51-82-1.33v-2.23l-191.58-6.69L834.48 711l.02-46.75 147.5.5 191 3.42v1.33l83 .5 26.25-.68v-4.82l14.17-.83 17.71.16 23.79-.83z',
        'M1337.92 663l-23.79.83-17.71-.16-14.17.83v4.82L1256 670l-83-.5v-1.33l-191-3.42-147.5-.5.03-44H981.5l192.5.99v.09l79.17.34 29.08.08v-1.42l14.17.34 17.71-.17 23.74-.67z',
        'M1337.87 619.83l-23.74.67-17.71.17-14.17-.34v1.42l-29.08-.08-79.17-.34v-.09l-192.5-.99H834.53l.02-44.9 146.95-.1 156.54-2.08v.09l116.46.07 27.75.17 4.92.33 9.25.5 17.71.42 23.68.75z',
        'M1337.81 575.5l-23.68-.75-17.71-.42-9.25-.5-4.92-.33-27.75-.17-116.46-.07v-.09l-156.54 2.08-146.95.1.02-44.6 147.68.75 190.58-2.67v-2.59.09l82.13-1.53 27.29 2.87v1.5l14.17 1 17.71.26 23.63 2.74z',
        'M1337.76 533.17l-23.63-2.74-17.71-.26-14.17-1v-1.5l-27.29-2.87-82.13 1.53v-.09 2.59l-190.58 2.67-147.68-.75.03-46.25 146.9 2.75 191.5-5.42-.06-3.18 82.02-2.93 27.18 4.28 31.88 5.92 23.69 3.58z',
        'M1337.71 489.5l-23.69-3.58-31.88-5.92-27.18-4.28-82.02 2.93.06 3.18-191.5 5.42-146.9-2.75.02-44.75L981.5 443l191.5-8.67v-4.08l81.33-3.58 27.81 5.16V439l13.91 2.72 17.97-.22 23.63 4.33z',
        'M1337.65 445.83l-23.63-4.33-17.97.22-13.91-2.72v-7.17l-27.81-5.16-81.33 3.58v4.08L981.5 443l-146.88-3.25.03-47.08L982 398.25 1172.83 387v-4.5l80.84-4.17 28.47 7.27v6.78l14.18 4.62 17.7-.67 23.57 6.67z',
        'M1337.59 403l-23.57-6.67-17.7.67-14.18-4.62v-6.78l-28.47-7.27-80.84 4.17v4.5L982 398.25l-147.35-5.58.01-22-98.58-6.5V364l99.01-16 93.74 5.67 53.42.58 190.58-14.75V334l81.84-5.33 27.47 10v10.83l14.18 2.5 17.7-.17 23.52 8.34z',
        'M1337.54 360.17l-23.52-8.34-17.7.17-14.18-2.5v-10.83l-27.47-10-81.84 5.33v5.5l-190.58 14.75-53.42-.58-93.74-5.67-99.01 16v-33.67L835.09 302l93.91 7.33 52.5.42 191.17-17.08v-5.42l82-7.25 27.47 11.47v12.66l14.18 3.54 17.7-.49 23.46 8.82z',
        'M1337.48 316l-23.46-8.82-17.7.49-14.18-3.54v-12.66L1254.67 280l-82 7.25v5.42L981.5 309.75l-52.5-.42-93.91-7.33-99.01 28.33V295l99.01-37.5 93.57 8 53.59.25 190.58-19.08v-6.34l81.34-9.5 27.97 13.5V256l14.18 7 17.7-1 23.41 11.5v.01z',
        'M1337.43 273.5l-23.41-11.5-17.7 1-14.18-7v-11.67l-27.97-13.5-81.34 9.5v6.34l-190.58 19.08-53.59-.25-93.57-8-99.01 37.5v-44.67l99.84-41.83 92.6 11.83 53.23.67 192.08-22.25v-6.5l80.84-10.08 27.47 15.25v16.33l14.18 5.38 17.7-.72 23.35 11.09z',
        'M1337.37 229.5l-23.35-11.09-17.7.72-14.18-5.38v-16.33l-27.47-15.25-80.84 10.08v6.5L981.75 221l-53.23-.67-92.6-11.83-99.84 41.83v-40.66l100.34-47.75 92.74 13.75 52.84 1.08 192-25.5v-7.5l80.5-9.58 27.64 16.5v16.58l14.18 6.75 17.7-.62 23.3 13.79z',
        'M1337.32 187.17l-23.3-13.79-17.7.62-14.18-6.75v-16.58l-27.64-16.5-80.5 9.58v7.5l-192 25.5-52.84-1.08-92.74-13.75-100.34 47.75-.08-40 99.09-52.87 93.41 13.95 53.75.75L1173.5 104v-8.43l81.5-10.82 27.14 20 .36 16.25 13 10 18.75-1.75 23.01 14.25z',
    ],
    // sec3b
    [
        '',
        'M1216.95 899.74l-.2 38.43-41.58 1.51V945l-331 19-40.17-4.5-8.75 4.25-166.71-10.5-46.53-4V907.5l46.53 2v2.24L796.25 918l7.75-3 39.67-.5 331.5-9.4v-4.04z',
        'M1217.17 855.53l-.22 44.21-41.78 1.32v4.04l-331.5 9.4-39.67.5-7.75 3-167.71-6.26v-2.24l-46.53-2v-45.19l46.53.69v.96L795.25 873l8.25-1.5 40.17 1.17L1175 859.05v-2.75z',
        'M1217.39 810l-.22 45.53-42.17.77v2.75l-331.33 13.62-40.17-1.17-8.25 1.5-166.71-9.04V863l-46.53-.69v-45.73l46.53.67v1.77l166.63 3.48 8.33-.5 40.5 2 331.01-11.57v-1.48z',
        'M1217.6 764.39l-.21 45.61-42.38.95v1.48L844 824l-40.5-2-8.33.5-166.63-3.48v-1.77l-46.53-.67.02-46.58 46.51 1 167.09 3.5 47.37 1.17 331.83-10.32v-.18z',
        'M1217.82 719.3l-.22 45.09-42.77.78v.18L843 775.67l-47.37-1.17-167.09-3.5-46.51-1v-47l46.72 1.5 166 4.25 8.5-1.25 40.08-.5 331.5-5.44v-1.46z',
        'M1218.04 674.75l-.22 44.55-42.99.8v1.46L843.33 727l-40.08.5-8.5 1.25-166-4.25-46.72-1.5v-45.5l46.51 1.33 166.71 3.92 8.25-2.25 39.83.67 331.55-4.31v-1.7z',
        'M1217.83 626.13l.21 48.62-43.16.41v1.7l-331.55 4.31-39.83-.67-8.25 2.25-166.71-3.92-46.51-1.33v-47.25l46.51 1.25 166.21 2 48.25-1 332-4.4v-1.85z',
        'M1217.83 585.83v40.3l-42.83.12v1.85l-332 4.4-48.25 1-166.21-2-46.51-1.25v-45.5l46.51.64 166.46.28 48.67-.34 331.33-1.16v2.08z',
        'M1217.83 542.5v43.33l-42.83.42v-2.08l-331.33 1.16-48.67.34-166.46-.28-46.51-.64v-45.63l46.51.11 166.21-.23 48.25.25 331.67.25v3.29z',
        'M1217.83 498.5v44l-43.16.29v-3.29L843 539.25l-48.25-.25-166.21.23-46.51-.11V492.2l46.51.11v-1.29l165.96.48 49.17.83 331.5 1.72v4.45z',
        'M1217.75 453.33l.08 45.17h-42.66v-4.45l-331.5-2.55H794.5l-165.96-.48v1.29l-46.51-.11v-45.95l45.42.23v-1.28L795 443.54l8.25 2.21 40.75-.42 331.17 3.44V453z',
        'M1217.25 409.67l.5 43.66-42.58-.33v-4.23L844 445.33l-40.75.42-8.25-2.21-167.55 1.66v1.28l-45.42-.23v-43.58l46.51-.98v-1.28l166.29-5.24 8.84 3.33 40.33-.17 331 5.44v5.4z',
        'M1217.47 365.5l-.22 44.17-42.25-.5v-5.4l-331-5.44-40.33.17-8.84-3.33-166.29 5.24v1.28l-46.51.98.01-46.79 47.21-1.13v-1.28L795 346.75l8.17 4.83 40.16-.25 331.84 5.94V365z',
        'M1216.57 320.67l.9 44.83-42.3-.5v-7.73l-331.84-5.94-40.16.25-8.17-4.83-165.75 6.72v1.28l-47.21 1.13V309l46.5-.97v-1.28l166.09-7.37 8.62 3.5 40.08.12 332.34 10.15v6.52z',
        'M1216.78 276l-.21 44.67-40.9-1v-6.52L843.33 303l-40.08-.12-8.62-3.5-166.09 7.37v1.28l-46.5.97v-43.45l46.5-1.55v-2.04l166.96-8.29 8.13 3.46 39.12-1 331.92 15.02V275z',
        'M1217 232.67l-.22 43.33-42.11-1v-3.85l-331.92-15.02-39.12 1-8.13-3.46-166.96 8.29V264l-46.5 1.55V221.5l45.96-2.38v-1.29l167-10.16 9 3 39-1.34 332.33 16.82V230z',
    ],
    // sec4b
    [
        '',
        'M1202 893.02v34.31l-447.67 12.34-31.66-1.34v-14l-50 11.67.08-42 81.92 6.33z',
        'M1202 852v41.02l-447.33 7.31-81.92-6.33.07-39.11 81.18 4.44z',
        'M1202 814.54V852l-448 7.33-81.18-4.44.08-40.13 81.77 2.57z',
        'M1202 774.16v40.38l-447.33 2.79-81.77-2.57.08-40.54 81.69 2.78z',
        'M1202 733.8v40.36L754.67 777l-81.69-2.78.08-40.34 82.27 1.79z',
        'M1202 693.46v40.34l-446.67 1.87-82.27-1.79.08-40.36 80.86 1.15z',
        'M1202 653.06v40.4l-448 1.21-80.86-1.15.08-40.54 81.11.02z',
        'M1202 615.02v38.04L754.33 653l-81.11-.02.08-38.03 80.7-.28z',
        'M1202 573.72v41.3l-448-.35-80.7.28.07-41.29 81.3-.33z',
        'M1202 533.73v39.99l-447.33-.39-81.3.33.08-39.99 81.22-.34z',
        'M1202 495v38.73l-447.33-.4-81.22.34.08-40 80.47-1.34z',
        'M1202 455.67V495l-448-2.67-80.47 1.34.08-40.17L755 451z',
        'M1202 416.33v39.34L755 451l-81.39 2.5.08-39.39L754 410z',
        'M1202 376.67v39.66L754 410l-80.31 4.11.08-40.97 80.9-4.47z',
        'M1202 336.67v40l-447.33-8-80.9 4.47.08-39.54L754 328z',
        'M1202 296.67v40L754 328l-80.15 5.6.07-40.84 80.75-5.76z',
        'M1202 258v38.67L754.67 287l-80.75 5.76.08-39.16 80.67-7.6z',
        'M1202 218.33V258l-447.33-12-80.67 7.6.08-40.6 80.59-8.33z',
        'M1202 178.67v39.66l-447.33-13.66-80.59 8.33.09-43.04 80.16-7.63z',
    ],
    // sec5b
    [
        '',
        'M1112.6 907.58v37.48l-35.85.39v5.27L898.7 964.33l-4.18-3.1-40.65 5.44v-40l40.65-2.87 4.18 1.87L1077.75 912v-4.04z',
        'M1112.6 871v36.58l-34.85.38V912L898.7 925.67l-4.18-1.87-40.65 2.87v-41.8l40.65-1.4 4.18 1.86 177.8-11v-1.95z',
        'M1112.6 832.5V871l-36.1 1.38v1.95l-177.8 11-4.18-1.86-40.65 1.4V845l40.65-1.72 4.18 1.86 177.8-10.48v-1.77z',
        'M1112.6 796v36.5l-36.1.39v1.77l-177.8 10.48-4.18-1.86-40.65 1.72v-41.64l40.65-.47 4.18 1.86 177.8-8.77v.41z',
        'M1112.6 757.33V796l-36.1.39v-.41l-177.8 8.77-4.18-1.86-40.65.47v-39.55l40.65-.47 2.69.66 178.79-5.56-.08-.73z',
        'M1112.6 719.06v38.27l-36.68.38.08.73L897.21 764l-2.69-.66-40.65.47v-39.48l40.65-1h2.69l178.89-3.71 1.15.88z',
        'M1112.6 680.23v38.83l-35.35 1.44-1.15-.88-178.89 3.71h-2.69l-40.65 1v-42.26l40.65-.63h2.69l178.64-1.24 1.15-.09z',
        'M1112.6 640.51v39.72l-35.6-.12-1.15.09-178.64 1.24h-2.69l-40.65.63v-39.72l40.65-.62h2.69l179.39-1.24 1.15-.1z',
        'M1112.6 602.09v38.42l-34.85-.12-1.15.1-179.39 1.24h-2.69l-40.65.62v-38.43l40.65-.62h2.69l179.64-1.24 1.15-.1z',
        'M1112.6 564.9v37.19l-34.6-.13-1.15.1-179.64 1.24h-2.69l-40.65.62V563l40.65.63h183.23v1.16z',
        'M1112.6 527.81v37.09l-34.85-.11v-1.16H894.52l-40.65-.63v-41l40.65.33 182.23 2.96v2.4z',
        'M1112.6 488.75v39.06l-35.85-.12v-2.4l-182.23-2.96-40.65-.33v-41.67l40.49 1.8 2.85-.46 180.29 5.67v1.16z',
        'M1112.6 450.5v38.25l-35.1-.25v-1.16l-180.29-5.67-2.85.46-40.49-1.8v-40l40.49 1.14 2.85-.47 180.04 8.09v1.16z',
        'M1112.6 412v38.5l-35.35-.25v-1.16L897.21 441l-2.85.47-40.49-1.14v-41l40.49 2.7 2.85-1.7 179.79 9.02v2.4z',
        'M1112.6 375.25V412l-35.6-.25v-2.4l-179.79-9.02-2.85 1.7-40.49-2.7v-40l40.49 2.72 2.85-1.72 180.29 10.78v3.64z',
        'M1112.6 335.4v39.85l-35.1-.5v-3.64l-180.29-10.78-2.85 1.72-40.49-2.72v-41l40.49 2.72 2.85-1.72 180.29 12.78v3.64z',
        'M1112.6 296.88v38.52l-35.1.35v-3.64l-180.29-12.78-2.85 1.72-40.49-2.72v-40.66l40.49 3.71 2.85-1.71 180.29 12.69V296z',
        'M1112.6 260.09v36.79l-35.1-.88v-3.64l-180.29-12.69-2.85 1.71-40.49-3.71V237l40.49 3.7 2.85-1.7 180.54 16.37V259z',
        'M1112.6 222.06v38.03l-34.85-1.09v-3.63L897.21 239l-2.85 1.7-40.49-3.7v-41l40.49 5.03 2.85-1.7L1078 216.37V220z',
        'M1112.6 181.78v40.28L1078 220v-3.63l-180.79-17.04-2.85 1.7-40.49-5.03v-24.25L779.5 154.5l74.66 2.67 40.2 3.21 2.85-1.71 180.29 18.44v3.64z',
        'M1112.6 144.75v37.03l-35.1-1.03v-3.64l-180.29-18.44-2.85 1.71-40.2-3.21-74.66-2.67-36.5-7v-.5l111.79-31 39.57 3.71 2.85-1.71 181.29 20.55v3.63z',
        'M1112.6 105v39.75l-34.1-2.57v-3.63L897.21 118l-2.85 1.71-39.57-3.71L743 147v-29.5l111.79-40.17 39.57 3.29 2.85-2.95L1078 100.25v4.88z',
    ],
    // sec6b
    [
        '',
        'M1596.55 944.79l-34.55-8.2v8.91l-24.75 2.5-424.65-2.94v-37.48l424.65 3.92 59.2-2.22z',
        'M1596.45 909.28l-59.2 2.22-424.65-3.92V871l424.15 2.25 59.57-3.18z',
        'M1596.32 870.07l-59.57 3.18L1112.6 871v-38.5l424.4 2.25 59.2-3.01z',
        'M1596.2 831.74l-59.2 3.01-424.4-2.25V796l423.65.5 59.83-2.35z',
        'M1596.08 794.15l-59.83 2.35-423.65-.5v-38.67l424.15.42 59.21-1.84z',
        'M1595.96 755.91l-59.21 1.84-424.15-.42v-38.27l424.15.19 59.09-1.84z',
        'M1595.84 717.41l-59.09 1.84-424.15-.19v-38.83l424.15 1.02 58.97-.76z',
        'M1595.72 680.49l-58.97.76-424.15-1.02v-39.72l424.4 1.24 58.6.04z',
        'M1595.6 641.79l-58.6-.04-424.4-1.24v-38.42l425.15 1.16 57.72.11z',
        'M1595.47 603.36l-57.72-.11-425.15-1.16V564.9l424.9.43 57.85 1.84z',
        'M1595.35 567.17l-57.85-1.84-424.9-.43v-37.09l425.07-.98 57.56 3z',
        'M1595.23 529.83l-57.56-3-425.07.98v-39.06l424.9 1.5 57.61 2.75z',
        'M1595.11 493l-57.61-2.75-424.9-1.5V450.5l424.9.83 57.49 3.34z',
        'M1594.99 454.67l-57.49-3.34-424.9-.83V412l424.73.67 57.53 4.5z',
        'M1594.86 417.17l-57.53-4.5-424.73-.67v-36.75L1537 375l57.74 5z',
        'M1594.74 380l-57.74-5-424.4.25V335.4l425.07.6 56.95 6.67z',
        'M1594.62 342.67l-56.95-6.67-425.07-.6v-38.52l424.73.79 57.16 8z',
        'M1594.49 305.67l-57.16-8-424.73-.79v-36.79l425.9-.09 55.88 7z',
        'M1594.38 267l-55.88-7-425.9.09v-38.03l423.9-1.56 59.13 10.37z',
    ],
    // sec7b
    [
        '',
        'M653.8 885.1l.2 36.75 36 3.02v5.38l317.33 29.08 41.92-2.58 7.25 5.75 176.09-6.38v-4.86l55.41-2.93v-44l-57.33 2.57v2.27L1056.5 917l-8-5.5-41.5 1.25-316-21.25v-4.08z',
        'M653.29 845.59l.51 39.51 37.2 2.32v4.08l316 21.25 41.5-1.25 8 5.5 174.17-7.83v-2.27l57.33-2.57v-44.08l-56.75 1.78v.97l-174.75 6.5-8-3.5-42.5-.25-315-15.45v-2.78z',
        'M653.36 801.85l-.07 43.74 37.71 1.93v2.78l315 15.45 42.5.25 8 3.5 174.75-6.5v-.97l56.75-1.78v-46.42l-57.27 1.11v1.79l-174.9 5.27-6.83-3.12-42 .12-316.5-15.33v-1.49z',
        'M653.14 759.19l.22 42.66 37.14.33v1.49L1007 819l42-.12 6.83 3.12 174.9-5.27v-1.79l57.27-1.11-.01-45.14-46.74-.02-185.08 3.83-6.67-3.25-42.5-.42-316.37-8.77v-.18z',
        'M652.93 708.4l.21 50.79 37.49.69v.18l316.37 8.77 42.5.42 6.67 3.25 185.08-3.83 46.74.02v-48.17l-56.86.73-174.38 3.75-8-3.25-41.37-1.12L690 712.38v-3.25z',
        'M652.71 664.4l.22 44 37.07.73v3.25l317.38 8.25 41.37 1.12 8 3.25 174.38-3.75 56.86-.73v-46.88l-57.36.49-174.63 3-7.5-1.63-41.87-.5-315.75-6.87v-3.17z',
        'M652.49 620.96l.22 43.44 38.17.56v3.17l315.75 6.87 41.87.5 7.5 1.63 174.63-3 57.36-.49v-46.51l-57.32.37-175.34.67-48.66-1.84-315.5-2.94v-1.87z',
        'M652.27 577.02l.22 43.94 38.68.56v1.87l315.5 2.94 48.66 1.84 175.34-.67 57.32-.37v-47.8l-57.24.05-167.78-.22-55.97-.53-316.83-1.46z',
        'M652.05 532.39l.22 44.63 37.9.15 316.83 1.46 55.97.53 167.78.22 57.24-.05v-46.96l-57.32.11h-174.5l-49.17-.15-317 .21z',
        'M651.84 489.32l.21 43.07 37.95.15 317-.21 49.17.15h174.5l57.32-.11v-47.44l-56.99.1v-1.3h-182.33l-41.67-.14-317 4.58v1.29z',
        'M651.62 445.52l.22 43.8 38.16.14v-1.29l317-4.58 41.67.14H1231v1.3l56.99-.1v-47.45l-57.16.1v-1.29L1055 436l-8 1h-40l-318 6.07v2.6z',
        'M651.41 402.02l.21 43.5 37.38.15v-2.6l318-6.07h40l8-1 175.83.29v1.29l57.16-.1v-45.15l-56.66-.66v-1.3l-175.66-2.54-6.67.58-42.33-.14L689 398.91v2.59z',
        'M651.67 356.94l-.26 45.08 37.59-.52v-2.59l317.67-10.64 42.33.14 6.67-.58 175.66 2.54v1.3l56.66.66-.02-46.05-57.14-.98V344l-174.66-4.06-7.34 1.88-41.83-.14-317.33 11.73V356z',
        'M652.19 315.87l-.52 41.07 38-.94v-2.59L1007 341.68l41.83.14 7.34-1.88 174.66 4.06v1.3l57.14.98V299l-56.97-1v-1.3l-175.33-6.2-7.67 1.87-41-1.13-317.83 18.7v3.89z',
        'M651.97 270.29l.22 45.58 36.98-2.04v-3.89l317.83-18.7 41 1.13 7.67-1.87 175.33 6.2v1.3l56.97 1v-46.5l-56.72-1.75v-1.3l-175.75-7.2-7.5 1.88-41 .12-317.75 20.11v3.89z',
        'M651.75 227.95l.22 42.34 37.28-2.04v-3.89L1007 244.25l41-.12 7.5-1.88 175.75 7.2v1.3l56.72 1.75V206l-55.47-2v-1.3l-177.33-8.2-6.17 2-41.5.25L688.67 222v3.89z',
    ],
    // sec8b
    [
        '',
        'M674 916.33L702.33 936l17-3.67 20 15.34v19.12l36.17 25.71 76.5-21.17V963l167.67-44 48.98-1.67 95.8 14.34-.02-45.6-95.93-10.82-48.5 2.5-168.5 39V924l-78.75 18.25-33.25-22.75V898l-20.75-9.75-18.25 3L674.05 876z',
        'M674.05 876l26.45 15.25 18.25-3L739.5 898v21.5l33.25 22.75L851.5 924v-7.25l168.5-39 48.5-2.5 95.93 10.82-.03-44.57-94.9-7-50 2-167 33.75v6l-79 15.5-33.5-19.92V852.5l-21-8.17-18.67 2.84-26.22-13.5z',
        'M674.11 833.67l26.22 13.5 18.67-2.84 21 8.17v19.33l33.5 19.92 79-15.5v-6l167-33.75 49.26-2 95.64 7-.02-43-96.38-4.75-48.25 1-168 29.25v5.75L774 842l-33.75-15.5v-14.25l-20.75-10.5-18.5 3-26.84-12.25z',
        'M674.16 792.5L701 804.75l18.5-3 20.75 10.5v14.25L774 842l77.75-12.25V824l168-29.25 48.25-1 96.38 4.75-.03-43.5-97.18-4.25-47.84 1.08L852 776v4.17l-78 11.58-34.17-14.25V766l-20.5-8.17-18.33 2.5-26.8-12.5z',
        'M674.2 747.83l26.8 12.5 18.33-2.5 20.5 8.17v11.5L774 791.75l78-11.58V776l167.33-24.17 48.01-1.08 97.01 4.25-.02-42.56-96.2-3.38-47.96 1.44-168 19.17v3.5l-78.67 9.16L739.67 731v-8.5L719 715l-17.67 1.33-27.07-10.16z',
        'M674.26 706.17l27.07 10.16L719 715l20.67 7.5v8.5l33.83 11.33 78.67-9.16v-3.5l168-19.17 47.96-1.44 96.2 3.38-.02-40.94-144.98-3.17-167.33 14v4.17l-78 5.83-34.12-8.7v-6.88l-20.75-5.12-18.13 2.12-26.69-5.75z',
        'M674.31 668l26.69 5.75 18.13-2.12 20.75 5.12v6.88l34.12 8.7 78-5.83v-4.17l167.33-14 144.98 3.17-.03-43.83-144.95-.67-167 10v.09l-78.5 5.08-34.2-5.42v-6.37l-20.5-2-14.75 2.12-30.02-5.48z',
        'M674.36 625.02l30.02 5.48 14.75-2.12 20.5 2v6.37l34.2 5.42 78.5-5.08V637l167-10 144.95.67-.02-42.5h-144.59L852 589v.09l-78.67 2.24-33.33-2.58v-2.46l-20.75-1.04L704.5 587l-30.08-2.25z',
        'M674.42 584.75L704.5 587l14.75-1.75 20.75 1.04v2.46l33.33 2.58 78.67-2.24V589l167.67-3.83h144.59l-.02-41.84-145.24.5-167.17-.83v.09l-78.83.58-33.33-.34v-1.28l-20.67.28-18.33 1.5-26.2-.16z',
        'M674.47 543.67l26.2.16 18.33-1.5 20.67-.28v1.28l33.33.34 78.83-.58V543l167.17.83 145.24-.5-.02-42.33-145.39-.17-167-3.66v-3l-78.2-1.67-34.05 2.75v2.58l-20.66.42-19.09.92-25.32 1.66z',
        'M674.51 500.83l25.32-1.66 19.09-.92 20.66-.42v-2.58l34.05-2.75 78.2 1.67v3l167 3.66 145.39.17-.02-43.33-144.87 1.33-166.83-8.67V446l-79.5-4.17-33.67 6v7.34L719 456l-19-.17-25.43 4.5z',
        'M674.57 460.33l25.43-4.5 19 .17 20.33-.83v-7.34l33.67-6 79.5 4.17v4.33l166.83 8.67 144.87-1.33-.03-41.67-95.54 3.38-48.63-2.13-167.75-13.75V400l-78.75-7.5-33.67 10v2.92l-21.33 6.91-18.33.67-25.54 7.17z',
        'M674.63 420.17l25.54-7.17 18.33-.67 21.33-6.91v-2.92l33.67-10 78.75 7.5v3.5L1020 417.25l48.63 2.13 95.54-3.38-.01-20.75 47.84-4.75-47.5-18.33-96.25 3.83-48.75-.33L852 356.33v-5.16l-78.5-9.04-33.37 12.37v13.38l-21.25 1.25-19.13-.63-25.07 8.75z',
        'M674.68 377.25l25.07-8.75 19.13.63 21.25-1.25V354.5l33.37-12.37 78.5 9.04v5.16l167.5 19.34 48.75.33 96.25-3.83 47.5 18.33V363l-46.83-34.17-96.34 6-49.58-.66L852 309.67v-6.29l-78.62-11.25L739.75 307v15L719 326l-18.5-2.17-25.77 12.34z',
        'M674.73 336.17l25.77-12.34L719 326l20.75-4v-15l33.63-14.87L852 303.38v6.29l167.25 24.5 49.58.66 96.34-6L1212 363v-32.5l-47.08-42.42-96.42 6.05-49.17-1.46-167.58-29.92v-6L773.67 243l-33.42 18.25v12.25L719 283.75l-18.5-1.25-25.72 13.5v.01z',
        'M674.78 296l25.72-13.5 18.5 1.25 21.25-10.25v-12.25L773.67 243l78.08 13.75v6l167.58 29.92 49.17 1.46 96.42-6.05L1212 330.5V291l-47.25-49.5-96.25 10.33-48.75-1.08L852 216.5v-8.33l-78.17-16.34L740 213v17.88l-21.33 8.79-18.92-2.42L674.83 253z',
        'M674.83 253l24.92-15.75 18.92 2.42 21.33-8.79V213l33.83-21.17L852 208.17v8.33l167.75 34.25 48.75 1.08 96.25-10.33L1212 291v-34.25l-49-57-94.33 10.42-49.92-.92-166.5-39.58v-8.92l-79-18.75-33.5 24v19.5l-21.08 10.83-18.34-2.33-25.45 17.67z',
        'M674.88 211.67L700.33 194l18.34 2.33 21.08-10.83V166l33.5-24 79 18.75v8.92l166.5 39.58 49.92.92 94.33-10.42 49 57v-39l-48-63.5-95.12 15.25-49.38-1.25-167.75-45.17v-8.33l-78.75-21-33.5 26.75v19.25l-20.25 16-18.75-4.25-25.56 20.25z',
    ],
    // sec9b
    [
        '',
        'M570.67 816.75v41l54.83 53 289.75 57.5 18.08-8.92 56.92 13.17 14.69-9.83.02-55.34L990 913l-55.9-9.29-17.1 7.04-294-50.5z',
        'M570.67 773v43.75l52.33 43.5 294 50.5 17.1-7.04L990 913l14.96-5.67.02-60-15.31 4.67-54.99-4.88-17.35 6.88-294-44.33z',
        'M570.67 728.67V773l52.66 36.67 294 44.33 17.35-6.88 54.99 4.88 15.31-4.67.02-59-14.67 3.67-56-5.33-17.66 6L624.33 757z',
        'M570.67 685.33v43.34L624.33 757l292.34 35.67 17.66-6 56 5.33 14.67-3.67.02-58.66-14.69 2-56.33-3-17.67 3-297.14-26.34z',
        'M570.67 640.33v45l48.52 20 297.14 26.34 17.67-3 56.33 3 14.69-2 .02-59.34-15.04 1.34-56.33-2.67-17 1.33-292.67-15z',
        'M570.67 594v46.33l53.33 15 292.67 15 17-1.33 56.33 2.67 15.04-1.34.02-60.33h-15.39l-55-1-18.67 1.31-290-7.98z',
        'M570.67 551v43l55.33 8.33 290 7.98 18.67-1.31 55 1h15.39l.02-59H990l-56.33-.33-18 1.31-296.48-.31z',
        'M570.67 509v42l48.52.67 296.48.31 18-1.31L990 551h15.08l.03-60.33h-15.78L934 491l-17.67 1.31-291 7.36z',
        'M570.67 462v47l54.66-9.33 291-7.36L934 491l55.33-.33h15.78l.02-57.92-14.8-1.75-55.33 2.33h-18.33l-291.34 13.42z',
        'M570.67 423.67V462l54.66-15.25 291.34-13.42H935l55.33-2.33 14.8 1.75.02-60.42L990 370l-56 4.33-309 23z',
        'M570.67 376.33v47.34L625 397.33l309-23 56-4.33 15.15 2.33.02-59.66-15.17-2.34-56.67 6.67h-17.66l-289.15 29.94z',
        'M570.67 330.67v45.66l55.85-29.39L915.67 317h17.66l56.67-6.67 15.17 2.34.02-59-15.19-4.34-56.33 8.34-19-4.67-290.34 40.33z',
    ],
];
var pathSections = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
var fetchVisualSection_data = {
    front: {},
    back: {},
};
for (var fetchVisualSection_i = 0, fetchVisualSection_n = fetchVisualSection_paths.length; fetchVisualSection_i < fetchVisualSection_n; fetchVisualSection_i++) {
    var fetchVisualSection_map = [];
    var backMap = [];
    var floorPaths = fetchVisualSection_paths[fetchVisualSection_i];
    for (var j = floorPaths.length - 1; j >= 0; j--) {
        fetchVisualSection_map.push({
            path: floorPaths[j],
            target: j + 1,
            available: 0,
        });
        backMap.push({
            path: backPaths[fetchVisualSection_i][j],
            target: j + 1,
            available: 0,
        });
    }
    var sectionId = pathSections[fetchVisualSection_i];
    fetchVisualSection_data.front[sectionId] = {
        section: sectionId,
        view: 'front',
        nextView: 'back',
        image: "/images/choose-visual/sections/front/0" + sectionId + ".jpg",
        map: fetchVisualSection_map,
    };
    fetchVisualSection_data.back[sectionId] = {
        section: sectionId,
        view: 'back',
        nextView: 'front',
        image: "/images/choose-visual/sections/back/0" + sectionId + ".jpg",
        map: backMap,
    };
}
function fetchVisualSection(section, view) {
    return tslib_es6["b" /* __awaiter */](this, void 0, void 0, function () {
        var serverData, viewData, floors, _i, _a, item, _b, _c, item;
        return tslib_es6["d" /* __generator */](this, function (_d) {
            switch (_d.label) {
                case 0:
                    dispatch(setLoading(true));
                    return [4 /*yield*/, sendVisualRequest({ sectionView: view, section: section })];
                case 1:
                    serverData = _d.sent();
                    if (!(view in fetchVisualSection_data)) {
                        // tslint:disable-next-line:no-parameter-reassignment
                        view = 'front';
                    }
                    viewData = tslib_es6["a" /* __assign */]({}, fetchVisualSection_data[view][section]);
                    if (!viewData) {
                        viewData = {
                            section: section,
                            view: view,
                            nextView: (view === 'front' ? 'back' : 'front'),
                            image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1920' height='1080'/%3E",
                            map: [],
                        };
                    }
                    if (serverData.section && serverData.section.map) {
                        floors = new Map();
                        for (_i = 0, _a = serverData.section.map; _i < _a.length; _i++) {
                            item = _a[_i];
                            floors.set(item.target, item.available);
                        }
                        viewData.map = viewData.map.slice();
                        for (_b = 0, _c = viewData.map; _b < _c.length; _b++) {
                            item = _c[_b];
                            if (floors.has(item.target)) {
                                // tslint:disable-next-line:no-non-null-assertion
                                item.available = floors.get(item.target);
                            }
                            else {
                                item.available = 0;
                            }
                        }
                    }
                    // TODO:
                    dispatch(setFilter(serverData.filter));
                    dispatch(setSection(viewData));
                    dispatch(setLoading(false));
                    return [2 /*return*/];
            }
        });
    });
}
var debouncedFetchVisualSection = debounce(fetchVisualSection, 200);
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/utils/translit.ts

/**
 * Transliteration table.
 */
var table = {
    // tslint:disable:object-literal-key-quotes
    'а': 'a',
    'б': 'b',
    'в': 'v',
    'г': 'g',
    'д': 'd',
    'е': 'e',
    'ё': 'yo',
    'ж': 'zh',
    'з': 'z',
    'и': 'i',
    'й': 'y',
    'к': 'k',
    'л': 'l',
    'м': 'm',
    'н': 'n',
    'о': 'o',
    'п': 'p',
    'р': 'r',
    'с': 's',
    'т': 't',
    'у': 'u',
    'ф': 'f',
    'х': 'h',
    'ц': 'ts',
    'ч': 'ch',
    'ш': 'sh',
    'щ': 'sch',
    'ъ': '',
    'ы': 'y',
    'ь': '',
    'э': 'e',
    'ю': 'yu',
    'я': 'ya',
    'А': 'A',
    'Б': 'B',
    'В': 'V',
    'Г': 'G',
    'Д': 'D',
    'Е': 'E',
    'Ё': 'Yo',
    'Ж': 'Zh',
    'З': 'Z',
    'И': 'I',
    'Й': 'Y',
    'К': 'K',
    'Л': 'L',
    'М': 'M',
    'Н': 'N',
    'О': 'O',
    'П': 'P',
    'Р': 'R',
    'С': 'S',
    'Т': 'T',
    'У': 'U',
    'Ф': 'F',
    'Х': 'H',
    'Ц': 'Ts',
    'Ч': 'Ch',
    'Ш': 'Sh',
    'Щ': 'Sch',
    'Ъ': '',
    'Ы': 'Y',
    'Ь': '',
    'Э': 'E',
    'Ю': 'Yu',
    'Я': 'Ya',
};
/**
 * A regular expression using the keys found in the given
 * translitteration object.
 */
var searchPattern = new RegExp("[" + Object.keys(table).join('') + "]", 'g');
/**
 * Function used by the resulting replace function.
 *
 * @param Current char.
 */
function lookupTable(input) {
    return ((input in table)
        ? table[input]
        : input);
}
/**
 * Search for occurrences of entries in the translitteration table
 * and replace these with their corresponding values.
 *
 * @param Subject to transliterate.
 * @returns Transliterated string.
 */
function translit(subject) {
    return subject.replace(searchPattern, lookupTable);
}
/**
 * Module
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/FilterCheckboxesItem.tsx

// Элемент группы переключателей фильтра


/**
 * Элемент группы переключателей фильтра
 */
function FilterCheckboxesItem(_a) {
    var formName = _a.formName, name = _a.name, label = _a.label, value = _a.value, checked = _a.checked, disabled = _a.disabled;
    var id = "f-" + formName + "-" + name.replace(/[^A-Za-z0-9_-]/g, '') + "-" + valueToName(value);
    return (Object(preact_esm["b" /* h */])("li", { class: "checkbox" },
        Object(preact_esm["b" /* h */])("input", { type: "checkbox", name: name, id: id, value: value, checked: checked, disabled: disabled }),
        Object(preact_esm["b" /* h */])("label", { for: id }, label)));
}
/**
 * Преобразовать значение для использования в имени/ID
 */
function valueToName(value) {
    return translit(value)
        .replace(/[ _.]/g, '-')
        .replace(/--+/g, '-')
        .replace(/[^A-Za-z0-9-]|^-+|-+$/g, '');
}
/**
 * Module
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/FilterCheckboxes.tsx

// Группа переключателей фильтра



/**
 * Группа переключателей фильтра
 */
function FilterCheckboxes(_a) {
    var formName = _a.formName, baseName = _a.baseName, label = _a.label, items = _a.items;
    return (Object(preact_esm["b" /* h */])("li", { class: 'checkboxes field-' + baseName },
        Object(preact_esm["b" /* h */])("fieldset", null,
            Object(preact_esm["b" /* h */])("legend", null, label),
            Object(preact_esm["b" /* h */])("ul", null, items.map(function (item) { return (Object(preact_esm["b" /* h */])(FilterCheckboxesItem, tslib_es6["a" /* __assign */]({ formName: formName, name: baseName + '[]' }, item))); })))));
}
/**
 * Module
 */


// CONCATENATED MODULE: ../node_modules/preact-range-slider/es5-esm/utils.js
function noop() {
    var _rest = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        _rest[_i] = arguments[_i];
    }
}
function clampValue(value, _a) {
    var min = _a.min, max = _a.max;
    if (value <= min) {
        return min;
    }
    if (value >= max) {
        return max;
    }
    return value;
}
function isValueOutOfRange(value, _a) {
    var min = _a.min, max = _a.max;
    return ((value < min)
        || (value > max));
}
function getPrecision(step) {
    var stepString = step.toString();
    var dotIndex = stepString.indexOf('.');
    var precision = 0;
    if (dotIndex !== -1) {
        precision = stepString.length - dotIndex - 1;
    }
    return precision;
}
function getClosestPoint(value, _a) {
    var marks = _a.marks, step = _a.step, min = _a.min;
    var points = Object.keys(marks).map(Number);
    if ((step != null)
        && (step > 0)) {
        var closestStep = Math.round((value - min) / step) * step + min;
        points.push(closestStep);
    }
    var diffs = points.map(function (point) { return Math.abs(value - point); });
    return (points[diffs.indexOf(Math.min.apply(Math, diffs))]
        || min);
}
function alignValue(value, props) {
    var step = props.step;
    var closestPoint = getClosestPoint(value, props);
    return (((step == null)
        || (step <= 0))
        ? closestPoint
        : Number(closestPoint.toFixed(getPrecision(step))));
}
function getHandleCenterPosition(vertical, handle) {
    var coords = handle.getBoundingClientRect();
    return (vertical
        ? coords.top + (coords.height / 2)
        : coords.left + (coords.width / 2));
}
function getMousePosition(vertical, event) {
    return (vertical ? event.clientY : event.pageX);
}
function getTouchPosition(vertical, event) {
    return (vertical ? event.touches[0].clientY : event.touches[0].pageX);
}
function isEventFromHandle(event, handles) {
    return (handles.some(function (handle) { return event.target === handle; }));
}
function isNotCorrectTouchEvent(event) {
    return ((event.touches.length > 1)
        || ((event.type.toLowerCase() === 'touchend')
            && (event.touches.length > 0)));
}
function killEvent(event) {
    event.stopPropagation();
    event.preventDefault();
}

//# sourceMappingURL=utils.js.map
// CONCATENATED MODULE: ../node_modules/classjoin/es5-esm/index.js
function classJoin(withConditions, withoutConditions) {
    var classes = [];
    var keys = Object.keys(withConditions);
    for (var i = 0, n = keys.length; i < n; i++) {
        var key = keys[i];
        if (withConditions[key]) {
            classes.push(key);
        }
    }
    if (withoutConditions) {
        classes = withoutConditions.concat(classes);
    }
    return classes.join(' ');
}

//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ../node_modules/preact-range-slider/es5-esm/components/Marks.js


function Marks(_a) {
    var min = _a.min, max = _a.max, lowerBound = _a.lowerBound, upperBound = _a.upperBound, marks = _a.marks, included = _a.included, vertical = _a.vertical, classesPrefix = _a.classesPrefix;
    var marksKeys = Object.keys(marks);
    var marksCount = marksKeys.length;
    var unit = 100 / (marksCount - 1);
    var markWidth = unit * 0.9;
    var range = max - min;
    var elements = marksKeys.map(Number)
        .sort(function (a, b) { return a - b; })
        .map(function (point) {
        var active = ((!included
            && (point === upperBound))
            || (included
                && (point <= upperBound)
                && (point >= lowerBound)));
        var classes = classJoin((_a = {},
            _a[classesPrefix + 'active'] = active,
            _a), [classesPrefix + 'text']);
        var style = (vertical
            ? {
                marginBottom: '-50%',
                bottom: ((point - min) / range * 100) + '%',
            }
            : {
                width: markWidth + '%',
                marginLeft: (-markWidth / 2) + '%',
                left: ((point - min) / range * 100) + '%',
            });
        var markPoint = marks[point];
        return (Object(preact_esm["b" /* h */])("span", { class: classes, style: style, key: String(point) }, markPoint));
        var _a;
    });
    return (Object(preact_esm["b" /* h */])("div", { class: classesPrefix + 'marks' }, elements));
}

//# sourceMappingURL=Marks.js.map
// CONCATENATED MODULE: ../node_modules/preact-range-slider/es5-esm/components/Steps.js


function Steps(_a) {
    var min = _a.min, max = _a.max, step = _a.step, lowerBound = _a.lowerBound, upperBound = _a.upperBound, marks = _a.marks, dots = _a.dots, included = _a.included, vertical = _a.vertical, classesPrefix = _a.classesPrefix;
    var range = max - min;
    var elements = calcPoints(marks, dots, step, min, max).map(function (point) {
        var offset = (Math.abs(point - min) / range * 100) + '%';
        var style = (vertical
            ? { bottom: offset }
            : { left: offset });
        var active = ((!included
            && (point === upperBound))
            || (included
                && (point <= upperBound)
                && (point >= lowerBound)));
        var classes = classJoin((_a = {},
            _a[classesPrefix + 'active'] = active,
            _a), [classesPrefix + 'dot']);
        return (Object(preact_esm["b" /* h */])("span", { class: classes, style: style, key: String(point) }));
        var _a;
    });
    return (Object(preact_esm["b" /* h */])("div", { class: classesPrefix + 'steps' }, elements));
}
function calcPoints(marks, dots, step, min, max) {
    var points = Object.keys(marks).map(Number);
    if (dots && (step > 0)) {
        for (var i = min; i <= max; i = i + step) {
            if (points.indexOf(i) === -1) {
                points.push(i);
            }
        }
    }
    return points;
}

//# sourceMappingURL=Steps.js.map
// CONCATENATED MODULE: ../node_modules/preact-range-slider/es5-esm/components/AbstractSlider.js






var AbstractSlider_AbstractSlider = (function (_super) {
    tslib_es6["c" /* __extends */](AbstractSlider, _super);
    function AbstractSlider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dragOffset = 0;
        _this.handlesRefs = [];
        _this.saveSlider = function (element) {
            _this.sliderRef = element;
        };
        _this.saveHandle = function (component, index) {
            if (index === void 0) { index = 0; }
            if (component == null) {
                delete _this.handlesRefs[index];
            }
            else {
                _this.handlesRefs[index] = component.base;
            }
        };
        _this.onMouseDown = function (event) {
            if (event.button !== 0) {
                return;
            }
            var vertical = _this.props.vertical;
            var position = getMousePosition(vertical, event);
            if (isEventFromHandle(event, _this.handlesRefs)) {
                var handlePosition = getHandleCenterPosition(vertical, event.target);
                _this.dragOffset = position - handlePosition;
                position = handlePosition;
            }
            else {
                _this.dragOffset = 0;
            }
            _this.onStart(position);
            _this.addDocumentMouseEvents();
            killEvent(event);
        };
        _this.onTouchStart = function (event) {
            if (isNotCorrectTouchEvent(event)) {
                return;
            }
            var vertical = _this.props.vertical;
            var position = getTouchPosition(vertical, event);
            if (isEventFromHandle(event, _this.handlesRefs)) {
                var handlePosition = getHandleCenterPosition(vertical, event.target);
                _this.dragOffset = position - handlePosition;
                position = handlePosition;
            }
            else {
                _this.dragOffset = 0;
            }
            _this.onStart(position);
            _this.addDocumentTouchEvents();
            killEvent(event);
        };
        _this.onMouseMove = function (event) {
            if (!_this.sliderRef) {
                _this.onEnd();
                return;
            }
            var position = getMousePosition(_this.props.vertical, event);
            _this.onMove(position - _this.dragOffset);
            killEvent(event);
        };
        _this.onTouchMove = function (event) {
            if (!_this.sliderRef
                || isNotCorrectTouchEvent(event)) {
                _this.onEnd();
                return;
            }
            var position = getTouchPosition(_this.props.vertical, event);
            _this.onMove(position - _this.dragOffset);
            killEvent(event);
        };
        _this.onEventEnd = function () {
            _this.removeDocumentEvents();
            _this.onEnd();
            _this.props.onAfterChange(_this.getValue());
        };
        return _this;
    }
    AbstractSlider.prototype.componentWillUnmount = function () {
        this.removeDocumentEvents();
    };
    AbstractSlider.prototype.renderBase = function (tracks, handles) {
        var _a = this.props, min = _a.min, max = _a.max, step = _a.step, marks = _a.marks, dots = _a.dots, included = _a.included, vertical = _a.vertical, disabled = _a.disabled, className = _a.className, classesPrefix = _a.classesPrefix, children = _a.children;
        var lowerBound = this.getLowerBound();
        var upperBound = this.getUpperBound();
        var classes = classJoin((_b = {},
            _b[classesPrefix + 'with-marks'] = Object.keys(marks).length,
            _b[classesPrefix + 'vertical'] = vertical,
            _b[classesPrefix + 'disabled'] = disabled,
            _b), [className]);
        return (Object(preact_esm["b" /* h */])("div", { class: classes, ref: this.saveSlider, onTouchStart: disabled ? noop : this.onTouchStart, onMouseDown: disabled ? noop : this.onMouseDown },
            Object(preact_esm["b" /* h */])("div", { class: classesPrefix + 'rail' }),
            tracks,
            Object(preact_esm["b" /* h */])(Steps, { vertical: vertical, marks: marks, dots: dots, step: step, included: included, lowerBound: lowerBound, upperBound: upperBound, max: max, min: min, classesPrefix: classesPrefix }),
            handles,
            Object(preact_esm["b" /* h */])(Marks, { vertical: vertical, marks: marks, included: included, lowerBound: lowerBound, upperBound: upperBound, max: max, min: min, classesPrefix: classesPrefix }),
            children));
        var _b;
    };
    AbstractSlider.prototype.getSliderStart = function () {
        var slider = this.sliderRef;
        if (!slider) {
            return 0;
        }
        var rect = slider.getBoundingClientRect();
        return (this.props.vertical
            ? rect.top
            : rect.left);
    };
    AbstractSlider.prototype.getSliderLength = function () {
        var slider = this.sliderRef;
        if (!slider) {
            return 0;
        }
        return (this.props.vertical
            ? slider.clientHeight
            : slider.clientWidth);
    };
    AbstractSlider.prototype.calcValue = function (offset) {
        var _a = this.props, vertical = _a.vertical, min = _a.min, max = _a.max;
        var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
        var value = (vertical
            ? ((1 - ratio) * (max - min) + min)
            : (ratio * (max - min) + min));
        return value;
    };
    AbstractSlider.prototype.calcValueByPos = function (position) {
        var pixelOffset = position - this.getSliderStart();
        var nextValue = this.clampAlignValue(this.calcValue(pixelOffset));
        return nextValue;
    };
    AbstractSlider.prototype.calcOffset = function (value) {
        var _a = this.props, min = _a.min, max = _a.max;
        var ratio = (value - min) / (max - min);
        return ratio * 100;
    };
    AbstractSlider.prototype.addDocumentMouseEvents = function () {
        document.addEventListener('mousemove', this.onMouseMove);
        document.addEventListener('mouseup', this.onEventEnd);
    };
    AbstractSlider.prototype.addDocumentTouchEvents = function () {
        document.addEventListener('touchmove', this.onTouchMove);
        document.addEventListener('touchend', this.onEventEnd);
    };
    AbstractSlider.prototype.removeDocumentEvents = function () {
        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('mouseup', this.onEventEnd);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onEventEnd);
    };
    AbstractSlider.defaultProps = {
        min: 0,
        max: 100,
        step: 1,
        marks: {},
        dots: false,
        included: true,
        vertical: false,
        disabled: false,
        className: 'range-slider',
        classesPrefix: '',
        onBeforeChange: noop,
        onChange: noop,
        onAfterChange: noop,
        tipFormatter: String,
    };
    return AbstractSlider;
}(preact_esm["a" /* Component */]));

//# sourceMappingURL=AbstractSlider.js.map
// CONCATENATED MODULE: ../node_modules/preact-range-slider/es5-esm/components/Handle.js



var Handle_Handle = (function (_super) {
    tslib_es6["c" /* __extends */](Handle, _super);
    function Handle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.saveElement = function (element) {
            _this.elementRef = element;
        };
        return _this;
    }
    Handle.prototype.render = function (_a) {
        var min = _a.min, max = _a.max, value = _a.value, vertical = _a.vertical, disabled = _a.disabled, dragging = _a.dragging, index = _a.index, offset = _a.offset, classesPrefix = _a.classesPrefix, children = _a.children;
        var style = (vertical
            ? {
                bottom: offset + '%',
            }
            : {
                left: offset + '%',
            });
        if (dragging && this.elementRef) {
            this.elementRef.focus();
        }
        var classes = classJoin((_b = {},
            _b[classesPrefix + 'dragging'] = dragging,
            _b), [
            classesPrefix + 'handle',
            classesPrefix + "handle-" + index,
        ]);
        return (Object(preact_esm["b" /* h */])("div", { class: classes, style: style, role: "slider", tabIndex: disabled ? undefined : 0, "aria-orientation": vertical ? 'vertical' : 'horizontal', "aria-disabled": String(disabled), "aria-valuemin": min, "aria-valuemax": max, "aria-valuenow": value, ref: this.saveElement },
            Object(preact_esm["b" /* h */])("span", { class: classesPrefix + 'tip' }, children)));
        var _b;
    };
    return Handle;
}(preact_esm["a" /* Component */]));

//# sourceMappingURL=Handle.js.map
// CONCATENATED MODULE: ../node_modules/preact-range-slider/es5-esm/components/Track.js


var Track_Track = (function (_super) {
    tslib_es6["c" /* __extends */](Track, _super);
    function Track() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Track.prototype.render = function (_a) {
        var vertical = _a.vertical, included = _a.included, index = _a.index, offset = _a.offset, length = _a.length, classesPrefix = _a.classesPrefix;
        var style = {};
        if (!included) {
            style.visibility = 'hidden';
        }
        if (vertical) {
            style.bottom = offset + '%';
            style.height = length + '%';
        }
        else {
            style.left = offset + '%';
            style.width = length + '%';
        }
        return (Object(preact_esm["b" /* h */])("div", { class: classesPrefix + "track " + classesPrefix + "track-" + index, style: style }));
    };
    return Track;
}(preact_esm["a" /* Component */]));

//# sourceMappingURL=Track.js.map
// CONCATENATED MODULE: ../node_modules/preact-range-slider/es5-esm/components/Slider.js






var Slider_Slider = (function (_super) {
    tslib_es6["c" /* __extends */](Slider, _super);
    function Slider(props) {
        var _this = _super.call(this, props) || this;
        var value = ((props.value != null)
            ? props.value
            : ((props.defaultValue != null)
                ? props.defaultValue
                : props.min));
        _this.state = {
            dragging: false,
            value: _this.clampAlignValue(value),
        };
        return _this;
    }
    Slider.prototype.componentWillReceiveProps = function (nextProps) {
        if (!(('value' in nextProps)
            || ('min' in nextProps)
            || ('max' in nextProps))) {
            return;
        }
        var prevValue = this.state.value;
        var value = ((nextProps.value == null)
            ? prevValue
            : nextProps.value);
        var nextValue = this.clampAlignValue(value, nextProps);
        if (nextValue === prevValue) {
            return;
        }
        this.setState({ value: nextValue });
        if (isValueOutOfRange(value, nextProps)) {
            this.props.onChange(nextValue);
        }
    };
    Slider.prototype.render = function (_a, _b) {
        var min = _a.min, max = _a.max, vertical = _a.vertical, included = _a.included, disabled = _a.disabled, classesPrefix = _a.classesPrefix, tipFormatter = _a.tipFormatter;
        var value = _b.value, dragging = _b.dragging;
        var offset = this.calcOffset(value);
        var handle = (Object(preact_esm["b" /* h */])(Handle_Handle, { vertical: vertical, disabled: disabled, dragging: dragging, min: min, max: max, value: value, index: 1, offset: offset, classesPrefix: classesPrefix, ref: this.saveHandle, key: 'handle-0' }, tipFormatter(value)));
        var track = (Object(preact_esm["b" /* h */])(Track_Track, { vertical: vertical, included: included, index: 1, offset: 0, length: offset, classesPrefix: classesPrefix, key: 'track-0' }));
        return this.renderBase(track, handle);
    };
    Slider.prototype.getValue = function () {
        return this.state.value;
    };
    Slider.prototype.getLowerBound = function () {
        return this.props.min;
    };
    Slider.prototype.getUpperBound = function () {
        return this.state.value;
    };
    Slider.prototype.onChange = function (state) {
        var props = this.props;
        var isNotControlled = !('value' in props);
        if (isNotControlled) {
            this.setState(state);
        }
        props.onChange(state.value);
    };
    Slider.prototype.onStart = function (position) {
        this.setState({ dragging: true });
        var prevValue = this.getValue();
        this.props.onBeforeChange(prevValue);
        var value = this.calcValueByPos(position);
        if (value === prevValue) {
            return;
        }
        this.onChange({ value: value });
    };
    Slider.prototype.onMove = function (position) {
        var value = this.calcValueByPos(position);
        var oldValue = this.state.value;
        if (value === oldValue) {
            return;
        }
        this.onChange({ value: value });
    };
    Slider.prototype.onEnd = function () {
        this.setState({ dragging: false });
    };
    Slider.prototype.clampAlignValue = function (value, nextProps) {
        if (nextProps === void 0) { nextProps = {}; }
        var mergedProps = tslib_es6["a" /* __assign */]({}, this.props, nextProps);
        return alignValue(clampValue(value, mergedProps), mergedProps);
    };
    return Slider;
}(AbstractSlider_AbstractSlider));

//# sourceMappingURL=Slider.js.map
// CONCATENATED MODULE: ../node_modules/preact-range-slider/es5-esm/components/MultiSlider.js






var MultiSlider_MultiSlider = (function (_super) {
    tslib_es6["c" /* __extends */](MultiSlider, _super);
    function MultiSlider(props) {
        var _this = _super.call(this, props) || this;
        var count = props.count, min = props.min, max = props.max;
        var initialValue = Array(count + 1).slice().map(function () { return min; });
        var values = ((props.value != null)
            ? props.value
            : ((props.defaultValue != null)
                ? props.defaultValue
                : initialValue));
        var bounds = values.map(function (value) { return _this.clampAlignValue(value); });
        var recent = ((bounds[0] === max)
            ? 0
            : bounds.length - 1);
        _this.state = {
            handle: null,
            recent: recent,
            bounds: bounds,
        };
        return _this;
    }
    MultiSlider.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (!(('value' in nextProps)
            || ('min' in nextProps)
            || ('max' in nextProps))) {
            return;
        }
        var bounds = this.state.bounds;
        var value = nextProps.value || bounds;
        var nextBounds = value.map(function (singleValue) { return _this.clampAlignValue(singleValue, nextProps); });
        if ((nextBounds.length === bounds.length)
            && nextBounds.every(function (singleValue, index) { return (singleValue === bounds[index]); })) {
            return;
        }
        this.setState({ bounds: nextBounds });
        if (bounds.some(function (singleValue) { return isValueOutOfRange(singleValue, nextProps); })) {
            this.props.onChange(nextBounds);
        }
    };
    MultiSlider.prototype.render = function (_a, _b) {
        var _this = this;
        var min = _a.min, max = _a.max, vertical = _a.vertical, included = _a.included, disabled = _a.disabled, classesPrefix = _a.classesPrefix, tipFormatter = _a.tipFormatter;
        var handle = _b.handle, bounds = _b.bounds;
        var offsets = bounds.map(function (value) { return _this.calcOffset(value); });
        var handles = bounds.map(function (value, index) { return (Object(preact_esm["b" /* h */])(Handle_Handle, { vertical: vertical, disabled: disabled, dragging: handle === index, min: min, max: max, value: value, index: index + 1, offset: offsets[index], classesPrefix: classesPrefix, ref: function (component) { return _this.saveHandle(component, index); }, key: "handle-" + index }, tipFormatter(value))); });
        var tracks = bounds.slice(0, -1).map(function (_value, index) {
            var nextIndex = index + 1;
            return (Object(preact_esm["b" /* h */])(Track_Track, { vertical: vertical, included: included, index: nextIndex, offset: offsets[index], length: offsets[nextIndex] - offsets[index], classesPrefix: classesPrefix, key: "track-" + index }));
        });
        return this.renderBase(tracks, handles);
    };
    MultiSlider.prototype.getValue = function () {
        return this.state.bounds;
    };
    MultiSlider.prototype.getLowerBound = function () {
        return this.state.bounds[0];
    };
    MultiSlider.prototype.getUpperBound = function () {
        var bounds = this.state.bounds;
        return bounds[bounds.length - 1];
    };
    MultiSlider.prototype.onChange = function (state) {
        var props = this.props;
        var isNotControlled = !('value' in props);
        if (isNotControlled) {
            this.setState(state);
        }
        else if (typeof state.handle !== 'undefined') {
            this.setState({ handle: state.handle });
        }
        var data = tslib_es6["a" /* __assign */]({}, this.state, state);
        props.onChange(data.bounds);
    };
    MultiSlider.prototype.onStart = function (position) {
        var props = this.props;
        var state = this.state;
        var bounds = this.getValue();
        props.onBeforeChange(bounds);
        var value = this.calcValueByPos(position);
        var closestBound = this.getClosestBound(value);
        var boundNeedMoving = this.getBoundNeedMoving(value, closestBound);
        this.setState({
            handle: boundNeedMoving,
            recent: boundNeedMoving,
        });
        var prevValue = bounds[boundNeedMoving];
        if (value === prevValue) {
            return;
        }
        var nextBounds = state.bounds.slice();
        nextBounds[boundNeedMoving] = value;
        this.onChange({ bounds: nextBounds });
    };
    MultiSlider.prototype.onMove = function (position) {
        var props = this.props;
        var state = this.state;
        if (state.handle == null) {
            return;
        }
        var value = this.calcValueByPos(position);
        var oldValue = state.bounds[state.handle];
        if (value === oldValue) {
            return;
        }
        var nextBounds = state.bounds.slice();
        nextBounds[state.handle] = value;
        var nextHandle = state.handle;
        if (props.pushable !== false) {
            var originalValue = state.bounds[nextHandle];
            this.pushSurroundingHandles(nextBounds, nextHandle, originalValue);
        }
        else if (props.allowCross) {
            nextBounds.sort(function (a, b) { return a - b; });
            nextHandle = nextBounds.indexOf(value);
        }
        this.onChange({
            handle: nextHandle,
            bounds: nextBounds,
        });
    };
    MultiSlider.prototype.onEnd = function () {
        this.setState({ handle: null });
    };
    MultiSlider.prototype.clampAlignValue = function (value, nextProps) {
        if (nextProps === void 0) { nextProps = {}; }
        var mergedProps = tslib_es6["a" /* __assign */]({}, this.props, nextProps);
        return alignValue(this.clampValueToSurroundingHandles(clampValue(value, mergedProps), mergedProps), mergedProps);
    };
    MultiSlider.prototype.getClosestBound = function (value) {
        var bounds = this.state.bounds;
        var closestBound = 0;
        for (var i = 1, n = bounds.length - 1; i < n; i++) {
            if (value > bounds[i]) {
                closestBound = i;
            }
        }
        if (Math.abs(bounds[closestBound + 1] - value)
            < Math.abs(bounds[closestBound] - value)) {
            closestBound += 1;
        }
        return closestBound;
    };
    MultiSlider.prototype.getBoundNeedMoving = function (value, closestBound) {
        var _a = this.state, bounds = _a.bounds, recent = _a.recent;
        var boundNeedMoving = closestBound;
        var nextBound = closestBound + 1;
        var atTheSamePoint = (bounds[nextBound] === bounds[closestBound]);
        if (atTheSamePoint) {
            if (bounds[recent] === bounds[closestBound]) {
                boundNeedMoving = recent;
            }
            else {
                boundNeedMoving = nextBound;
            }
            if (value !== bounds[nextBound]) {
                boundNeedMoving = ((value < bounds[nextBound])
                    ? closestBound
                    : nextBound);
            }
        }
        return boundNeedMoving;
    };
    MultiSlider.prototype.pushSurroundingHandles = function (bounds, handle, originalValue) {
        var threshold = Number(this.props.pushable);
        var value = bounds[handle];
        var direction = 0;
        if ((bounds[handle + 1] - value) < threshold) {
            direction = +1;
        }
        if ((value - bounds[handle - 1]) < threshold) {
            direction = -1;
        }
        if (direction === 0) {
            return;
        }
        var nextHandle = handle + direction;
        var diffToNext = direction * (bounds[nextHandle] - value);
        if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
            bounds[handle] = originalValue;
        }
    };
    MultiSlider.prototype.pushHandle = function (bounds, handle, direction, amount) {
        var originalValue = bounds[handle];
        var currentValue = bounds[handle];
        while ((direction * (currentValue - originalValue)) < amount) {
            if (!this.pushHandleOnePoint(bounds, handle, direction)) {
                bounds[handle] = originalValue;
                return false;
            }
            currentValue = bounds[handle];
        }
        return true;
    };
    MultiSlider.prototype.pushHandleOnePoint = function (bounds, handle, direction) {
        var points = this.getPoints();
        var pointIndex = points.indexOf(bounds[handle]);
        var nextPointIndex = pointIndex + direction;
        if ((nextPointIndex >= points.length)
            || (nextPointIndex < 0)) {
            return false;
        }
        var nextHandle = handle + direction;
        var nextValue = points[nextPointIndex];
        var threshold = Number(this.props.pushable);
        var diffToNext = direction * (bounds[nextHandle] - nextValue);
        if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
            return false;
        }
        bounds[handle] = nextValue;
        return true;
    };
    MultiSlider.prototype.getPoints = function () {
        var _a = this.props, marks = _a.marks, step = _a.step, min = _a.min, max = _a.max;
        var cache = this.pointsCache;
        if (!cache
            || (cache.marks !== marks)
            || (cache.step !== step)) {
            var pointsObject = tslib_es6["a" /* __assign */]({}, marks);
            if ((step != null)
                && (step > 0)) {
                for (var point = min; point <= max; point += step) {
                    pointsObject[point] = String(point);
                }
            }
            var points = Object.keys(pointsObject).map(Number);
            points.sort(function (a, b) { return a - b; });
            this.pointsCache = { marks: marks, step: step, points: points };
        }
        return this.pointsCache.points;
    };
    MultiSlider.prototype.clampValueToSurroundingHandles = function (value, _a) {
        var allowCross = _a.allowCross;
        var _b = this.state, handle = _b.handle, bounds = _b.bounds;
        if (!allowCross
            && (handle != null)) {
            if ((handle > 0)
                && (value <= bounds[handle - 1])) {
                return bounds[handle - 1];
            }
            if ((handle < (bounds.length - 1))
                && (value >= bounds[handle + 1])) {
                return bounds[handle + 1];
            }
        }
        return value;
    };
    MultiSlider.defaultProps = tslib_es6["a" /* __assign */]({}, AbstractSlider_AbstractSlider.defaultProps, { count: 1, allowCross: true, pushable: false });
    return MultiSlider;
}(AbstractSlider_AbstractSlider));

//# sourceMappingURL=MultiSlider.js.map
// CONCATENATED MODULE: ../node_modules/preact-range-slider/es5-esm/index.js


//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./app/Routes/Choose/App/FilterRange.tsx

// Выбор диапазона в фильтре



/**
 * Выбор диапазона в фильтре
 */
var FilterRange_FilterRange = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](FilterRange, _super);
    /**
     * Выбор диапазона в фильтре
     */
    function FilterRange(props) {
        var _this = _super.call(this, props) || this;
        /**
         * В процессе изменения значения?
         */
        _this.changing = false;
        _this.refInputFrom = function (element) {
            _this.inputFrom = element;
        };
        _this.refInputTo = function (element) {
            _this.inputTo = element;
        };
        _this.onInputFocus = function (event) {
            var target = event.target;
            var parent = target.parentElement;
            if (parent) {
                parent.classList.add('focus');
            }
        };
        _this.onInputBlur = function (event) {
            var target = event.target;
            var parent = target.parentElement;
            if (parent) {
                parent.classList.remove('focus');
            }
        };
        _this.onRangeBeforeChange = function (value) {
            _this.setState({
                from: value[0],
                to: value[1],
            });
            _this.changing = true;
        };
        _this.onRangeChange = function (value) {
            _this.setState({
                from: value[0],
                to: value[1],
            });
        };
        _this.onRangeAfterChange = function (value) {
            var fractionDigits = String(_this.props.step)
                .replace(/^[^.]+\.?/, '').length;
            _this.inputFrom.value = value[0].toFixed(fractionDigits);
            _this.inputTo.value = value[1].toFixed(fractionDigits);
            _this.inputFrom.dispatchEvent(new CustomEvent('change', {
                bubbles: true,
            }));
            _this.inputTo.dispatchEvent(new CustomEvent('change', {
                bubbles: true,
            }));
            _this.changing = false;
        };
        _this.state = {
            from: props.from,
            to: props.to,
        };
        return _this;
    }
    FilterRange.formatValue = function (value) {
        return String(value).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1 ');
    };
    /**
     * Before render, return false to skip render
     */
    FilterRange.prototype.shouldComponentUpdate = function (props, state) {
        return ((this.changing
            && ((this.state.from !== state.from)
                || (this.state.to !== state.to)))
            || (this.props.from !== props.from)
            || (this.props.to !== props.to)
            || (this.props.min !== props.min)
            || (this.props.max !== props.max)
            || (this.props.step !== props.step)
            || (this.props.name !== props.name)
            || (this.props.label !== props.label)
            || (this.props.formName !== props.formName));
    };
    /**
     * Render component
     */
    FilterRange.prototype.render = function (_a, state) {
        var formName = _a.formName, label = _a.label, name = _a.name, min = _a.min, max = _a.max, from = _a.from, to = _a.to, step = _a.step;
        var nameFrom = name + 'From';
        var nameTo = name + 'To';
        var idFrom = "f-" + formName + "-" + nameFrom;
        var idTo = "f-" + formName + "-" + nameTo;
        if (this.changing) {
            from = state.from;
            to = state.to;
        }
        return (Object(preact_esm["b" /* h */])("li", { class: 'range field-' + name },
            Object(preact_esm["b" /* h */])("fieldset", null,
                Object(preact_esm["b" /* h */])("legend", null, label),
                Object(preact_esm["b" /* h */])("span", { class: "from" },
                    Object(preact_esm["b" /* h */])("label", { for: idFrom, "data-value": FilterRange.formatValue(from) }, "\u043E\u0442"),
                    Object(preact_esm["b" /* h */])("input", { type: "text", name: nameFrom, id: idFrom, min: min, max: max, step: step, value: String(from), ref: this.refInputFrom, onFocus: this.onInputFocus, onBlur: this.onInputBlur })),
                Object(preact_esm["b" /* h */])("span", { class: "to" },
                    Object(preact_esm["b" /* h */])("label", { for: idTo, "data-value": FilterRange.formatValue(to) }, "\u0434\u043E"),
                    Object(preact_esm["b" /* h */])("input", { type: "text", name: nameTo, id: idTo, min: min, max: max, step: step, value: String(to), ref: this.refInputTo, onFocus: this.onInputFocus, onBlur: this.onInputBlur })),
                Object(preact_esm["b" /* h */])(MultiSlider_MultiSlider, { min: min, max: max, step: step, value: [from, to], tipFormatter: FilterRange.formatValue, onBeforeChange: this.onRangeBeforeChange, onChange: this.onRangeChange, onAfterChange: this.onRangeAfterChange }))));
    };
    return FilterRange;
}(preact_esm["a" /* Component */]));
/**
 * Module
 */


// EXTERNAL MODULE: ./app/Routes/Choose/App/sectionSchemeSvgPaths.json
var sectionSchemeSvgPaths = __webpack_require__("nuYK");
var sectionSchemeSvgPaths_default = /*#__PURE__*/__webpack_require__.n(sectionSchemeSvgPaths);

// CONCATENATED MODULE: ./app/Routes/Choose/App/FilterSections.tsx

// Группа переключателей секций в виде схемы.




/**
 * Группа переключателей секций в виде схемы.
 */
var FilterSections_FilterSections = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](FilterSections, _super);
    function FilterSections() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Сохранение ссылки на элемент списка чекбоксов.
         */
        _this.refCheckboxesList = function (element) {
            _this.checkboxesList = element;
        };
        /**
         * Начатие на объекты схемы.
         */
        _this.onObjectClick = function (event) {
            var target = event.target;
            var index = Number(target.getAttribute('data-index'));
            var listItem = _this.checkboxesList.children.item(index);
            if (!listItem) {
                return;
            }
            var checkbox = listItem.querySelector('input');
            if (checkbox) {
                checkbox.click();
            }
        };
        return _this;
    }
    /**
     * Сформировать объект на схеме.
     *
     * @param item Информация о пункте списка.
     * @param index Номер пункта в перечне (от 0).
     */
    FilterSections.createObject = function (item, index) {
        var sectionObjectPaths = sectionSchemeSvgPaths_default.a.paths;
        var sectionLabelTransforms = sectionSchemeSvgPaths_default.a.labels;
        return (sectionObjectPaths[index]
            ? [
                (Object(preact_esm["b" /* h */])("path", { d: sectionObjectPaths[index], class: (item.checked ? 'checked' : '')
                        + (item.disabled ? ' disabled' : ''), "data-index": index })),
                (Object(preact_esm["b" /* h */])("text", { transform: sectionLabelTransforms[index] || '' }, item.label)),
            ]
            : '');
    };
    /**
     * Render component.
     */
    FilterSections.prototype.render = function (_a) {
        var formName = _a.formName, baseName = _a.baseName, label = _a.label, items = _a.items;
        return (Object(preact_esm["b" /* h */])("li", { class: 'sections field-' + baseName },
            Object(preact_esm["b" /* h */])("fieldset", null,
                Object(preact_esm["b" /* h */])("legend", null, label),
                Object(preact_esm["b" /* h */])("div", { class: "scheme" },
                    Object(preact_esm["b" /* h */])("svg", { width: "289", height: "95", viewBox: "0 0 289 95" },
                        Object(preact_esm["b" /* h */])("g", { class: "objects", onClick: this.onObjectClick }, items.map(FilterSections.createObject)))),
                Object(preact_esm["b" /* h */])("ul", { ref: this.refCheckboxesList }, items.map(function (item) { return (Object(preact_esm["b" /* h */])(FilterCheckboxesItem, tslib_es6["a" /* __assign */]({ formName: formName, name: baseName + '[]' }, item))); })))));
    };
    return FilterSections;
}(preact_esm["a" /* Component */]));
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/utils/listStateToQueryString.ts

/**
 * Сформировать из текущего состояния фильтра строку запроса.
 *
 * @param state Объект состояния
 */
function listStateToQueryString(filter, nextItemsOffset) {
    var queryParts = [
        'mode=list',
    ];
    if (typeof nextItemsOffset !== 'undefined') {
        queryParts.push('offset=' + nextItemsOffset);
    }
    for (var _i = 0, _a = filter.section; _i < _a.length; _i++) {
        var checkbox = _a[_i];
        if (checkbox.checked) {
            queryParts.push('section[]=' + encodeURIComponent(checkbox.value));
        }
    }
    for (var _b = 0, _c = filter.roomType; _b < _c.length; _b++) {
        var checkbox = _c[_b];
        if (checkbox.checked) {
            queryParts.push('roomType[]=' + encodeURIComponent(checkbox.value));
        }
    }
    if (filter.floor.from !== filter.floor.min) {
        queryParts.push('floorFrom=' + String(filter.floor.from));
    }
    if (filter.floor.to !== filter.floor.max) {
        queryParts.push('floorTo=' + String(filter.floor.to));
    }
    if (filter.squareTotal.from !== filter.squareTotal.min) {
        queryParts.push('squareTotalFrom=' + String(filter.squareTotal.from));
    }
    if (filter.squareTotal.to !== filter.squareTotal.max) {
        queryParts.push('squareTotalTo=' + String(filter.squareTotal.to));
    }
    if (filter.totalCost.from !== filter.totalCost.min) {
        queryParts.push('totalCostFrom=' + String(filter.totalCost.from));
    }
    if (filter.totalCost.to !== filter.totalCost.max) {
        queryParts.push('totalCostTo=' + String(filter.totalCost.to));
    }
    return queryParts.join('&');
}
/**
 * Module
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/utils/updateAddress.ts

// Обновить адрес в адресной строке
/**
 * Строка параметров UTM, для добавления к адресу.
 */
var utmParams = '';
/**
 * Обновить адрес в адресной строке
 *
 * @param query Параметры запроса
 */
function updateAddress(query) {
    var fullQuery = (!utmParams
        ? query
        : (query
            ? query + "&" + utmParams
            : utmParams));
    window.history.replaceState(null, document.title, window.location.pathname + (fullQuery ? '?' + fullQuery : ''));
}
/**
 * Устанавливает строку параметров UTM, которая будет добавляться к адресу.
 *
 * @param parameters Строка параметров UTM.
 */
function setUtmParameters(parameters) {
    utmParams = parameters;
}
/**
 * Module
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/FilterForm.tsx

// Форма фильтра














/**
 * Форма фильтра.
 */
var FilterForm_FilterForm = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](FilterForm, _super);
    function FilterForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Обрабатывает изменения на форме.
         */
        _this.onChange = function (event) {
            var target = event.target;
            var name = target.name, value = target.value;
            switch (name) {
                case 'section[]':
                    dispatch(toggleSection(value));
                    break;
                case 'roomType[]':
                    dispatch(toggleRoomType(value));
                    break;
                case 'floorFrom':
                    dispatch(setFloorFrom(parseInt(value, 10)));
                    break;
                case 'floorTo':
                    dispatch(setFloorTo(parseInt(value, 10)));
                    break;
                case 'squareTotalFrom':
                    dispatch(setSquareTotalFrom(Number(parseFloat(value).toFixed(2))));
                    break;
                case 'squareTotalTo':
                    dispatch(setSquareTotalTo(Number(parseFloat(value).toFixed(2))));
                    break;
                case 'totalCostFrom':
                    dispatch(setTotalCostFrom(parseInt(value, 10)));
                    break;
                case 'totalCostTo':
                    dispatch(setTotalCostTo(parseInt(value, 10)));
                    break;
                default:
                    break;
            }
            // TODO:
            var state = getState();
            if (state.common.visualMode) {
                var query = visualStateToQueryString(state.filter, state.visualData);
                updateAddress(query);
                debouncedFetchVisualOverview(state.visualData.overview.view);
                if (state.visualData.step > 0 /* OVERVIEW */) {
                    debouncedFetchVisualSection(state.visualData.section.section, state.visualData.section.view);
                }
                if (state.visualData.step > 1 /* SECTION */) {
                    debouncedFetchVisualFloor(state.visualData.floor.floor);
                }
            }
            else {
                var query = listStateToQueryString(state.filter);
                updateAddress(query);
                debouncedFetchList(query);
            }
        };
        return _this;
    }
    /**
     * Render component
     */
    FilterForm.prototype.render = function (_props, _a) {
        var section = _a.section, floor = _a.floor, roomType = _a.roomType, squareTotal = _a.squareTotal, totalCost = _a.totalCost;
        return (Object(preact_esm["b" /* h */])("form", { name: "filter", method: "GET", action: "javascript:", onChange: this.onChange },
            Object(preact_esm["b" /* h */])("ul", { class: "fields" },
                Object(preact_esm["b" /* h */])(FilterSections_FilterSections, { formName: "filter", baseName: "section", label: "Секция", items: section }),
                Object(preact_esm["b" /* h */])(FilterRange_FilterRange, tslib_es6["a" /* __assign */]({ formName: "filter", label: "Этаж", name: "floor", step: 1 }, floor)),
                Object(preact_esm["b" /* h */])(FilterCheckboxes, { formName: "filter", baseName: "roomType", label: "Количество комнат", items: roomType }),
                Object(preact_esm["b" /* h */])(FilterRange_FilterRange, tslib_es6["a" /* __assign */]({ formName: "filter", label: "Площадь, м²", name: "squareTotal", step: 0.01 }, squareTotal)),
                Object(preact_esm["b" /* h */])(FilterRange_FilterRange, tslib_es6["a" /* __assign */]({ formName: "filter", label: "Стоимость, руб.", name: "totalCost", step: 1 }, totalCost)))));
    };
    /**
     * Handle Store changes.
     */
    FilterForm.prototype.storeStateChanged = function (_a) {
        var filter = _a.filter;
        var section = filter.section, floor = filter.floor, roomType = filter.roomType, squareTotal = filter.squareTotal, totalCost = filter.totalCost;
        if ((section === this.state.section)
            && (floor === this.state.floor)
            && (roomType === this.state.roomType)
            && (squareTotal === this.state.squareTotal)
            && (totalCost === this.state.totalCost)) {
            return;
        }
        this.setState({ section: section, floor: floor, roomType: roomType, squareTotal: squareTotal, totalCost: totalCost });
        // TODO:
        /*debouncedFetchList(
            listStateToQueryString(
                filter,
            ),
        );*/
    };
    return FilterForm;
}(SubscribedComponent));
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/Filter.tsx

// Фильтр







/**
 * Фильтр
 */
var Filter_Filter = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](Filter, _super);
    function Filter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * При нажатии на «Назад».
         */
        _this.onViewVisualClick = function () {
            dispatch(setVisualMode(true));
        };
        /**
         * При изменении режима экрана.
         */
        _this.onScreenModeChange = function (mode) {
            if (!_this.sticky) {
                return;
            }
            if (mode < 2 /* NOTEBOOK */) {
                _this.sticky.disable();
            }
            else {
                _this.sticky.enable();
            }
        };
        /**
         * Сохраняет ссылку на кормевой элемент.
         */
        _this.refFilterContainer = function (element) {
            _this.filterContainer = element;
        };
        return _this;
    }
    /**
     * Rendered component mounted to the DOM.
     */
    Filter.prototype.componentDidMount = function () {
        this.sticky = new SmartSticky_SmartSticky(this.filterContainer, {
            createPlaceholder: false,
        });
        Object(Screen["a" /* addScreenModeListener */])(this.onScreenModeChange);
    };
    /**
     * Before component will be unmounted and destroyed.
     */
    Filter.prototype.componentWillUnmount = function () {
        Object(Screen["c" /* removeScreenModeListener */])(this.onScreenModeChange);
        if (!this.sticky) {
            return;
        }
        this.sticky.destroy();
        this.sticky = undefined;
    };
    /**
     * Render component
     */
    Filter.prototype.render = function () {
        return (Object(preact_esm["b" /* h */])("div", { class: "filter", ref: this.refFilterContainer },
            Object(preact_esm["b" /* h */])("h1", null, "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0443"),
            Object(preact_esm["b" /* h */])("button", { type: "button", class: "view-visual", onClick: this.onViewVisualClick }, "\u041A\u0432\u0430\u0440\u0442\u0438\u0440\u044B \u043D\u0430\u00A0\u043F\u043B\u0430\u043D\u0435"),
            Object(preact_esm["b" /* h */])(FilterForm_FilterForm, null)));
    };
    /**
     * Handle Store changes.
     */
    Filter.prototype.storeStateChanged = function () {
        if (this.sticky) {
            this.sticky.update();
        }
    };
    return Filter;
}(SubscribedComponent));
/**
 * Module.
 */


// CONCATENATED MODULE: ./utils/events/throttle.ts

/**
 * Выполнять функцию не чаще заданного интервала
 *
 * @param func Исходная функция
 * @param threshold Минимальный интервал между вызовами
 * @returns Функция с ограницением по вызовам
 */
// tslint:disable-next-line:ban-types
function throttle(func, threshold) {
    if (threshold === void 0) { threshold = 100; }
    var timerId;
    var lastExecutionTime;
    return function throttled() {
        var _this = this;
        var rest = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            rest[_i] = arguments[_i];
        }
        var currentTime = Date.now();
        if (lastExecutionTime
            && (currentTime < lastExecutionTime + threshold)) {
            clearTimeout(timerId);
            timerId = setTimeout(function () {
                lastExecutionTime = currentTime;
                func.apply(_this, rest);
            }, threshold);
        }
        else {
            lastExecutionTime = currentTime;
            func.apply(this, rest);
        }
    };
}
/**
 * Module
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/asyncActions/fetchListMore.ts







/**
 * Загружает элементы в список вместо текущих.
 *
 * @param query Строка параметров запроса.
 */
function fetchListMore(query) {
    return tslib_es6["b" /* __awaiter */](this, void 0, void 0, function () {
        var listData;
        return tslib_es6["d" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(setLoading(true));
                    return [4 /*yield*/, sendListRequest(query)];
                case 1:
                    listData = (_a.sent()).listData;
                    dispatch(appendItems(listData.items, listData.itemsLeft, listData.nextItemsOffset));
                    dispatch(setLoading(false));
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Загружает элементы в список вместо текущих.
 * Ограничен по частоте срабатываний.
 *
 * @param query Строка параметров запроса.
 */
var debouncedFetchListMore = debounce(fetchListMore, 200);
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/AbstractListView.ts






/**
 * Абстрактный компонент режима списка.
 */
var AbstractListView_AbstractListView = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](AbstractListView, _super);
    /**
     * Абстрактный компонент режима списка.
     */
    function AbstractListView(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Обработчик прокрутки экрана.
         */
        _this.onWindowScroll = function () { return tslib_es6["b" /* __awaiter */](_this, void 0, void 0, function () {
            return tslib_es6["d" /* __generator */](this, function (_a) {
                if (!this.state.loading
                    && (this.state.itemsLeft > 0)
                    && (window.pageYOffset > (document.documentElement.offsetHeight - window.innerHeight * 2))) {
                    fetchListMore(listStateToQueryString(getState().filter, this.state.nextItemsOffset));
                }
                return [2 /*return*/];
            });
        }); };
        _this.onWindowScroll = throttle(_this.onWindowScroll);
        return _this;
    }
    /**
     * Rendered component mounted to the DOM.
     */
    AbstractListView.prototype.componentDidMount = function () {
        window.addEventListener('scroll', this.onWindowScroll);
    };
    /**
     * Before component will be unmounted and destroyed.
     */
    AbstractListView.prototype.componentWillUnmount = function () {
        window.removeEventListener('scroll', this.onWindowScroll);
    };
    /**
     * Handle Store changes.
     */
    AbstractListView.prototype.storeStateChanged = function (_a) {
        var loading = _a.common.loading, _b = _a.listData, items = _b.items, itemsLeft = _b.itemsLeft, nextItemsOffset = _b.nextItemsOffset;
        if ((items === this.state.items)
            && (itemsLeft === this.state.itemsLeft)
            && (nextItemsOffset === this.state.nextItemsOffset)
            && (loading === this.state.loading)) {
            return;
        }
        this.setState({ items: items, itemsLeft: itemsLeft, nextItemsOffset: nextItemsOffset, loading: loading });
    };
    return AbstractListView;
}(SubscribedComponent));
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/ListItem.tsx

// Строка таблицы планировок



/**
 * Строка таблицы планировок
 */
var ListItem_ListItem = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](ListItem, _super);
    function ListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Отформатировать цену
     *
     * @param value Сумма
     * @returns Строка для вывода
     */
    ListItem.formatMoney = function (value) {
        return value.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1 ');
    };
    /**
     * Render component
     */
    ListItem.prototype.render = function (_a) {
        var id = _a.id, section = _a.section, floor = _a.floor, roomType = _a.roomType, squareTotal = _a.squareTotal, totalCost = _a.totalCost, image = _a.image;
        var roomTypeNum = roomType.replace(/\s.+/, '');
        var roomTypeText = roomType.replace(/^[^(]+/, '') || 'комн.';
        var imageUri = "/images/apartments/plans/" + image.replace(/\.\w+$/, '') + ".png";
        return (Object(preact_esm["b" /* h */])("li", null,
            Object(preact_esm["b" /* h */])("a", { href: "/choose/apartment/" + id + "/" },
                Object(preact_esm["b" /* h */])("div", { class: "image" },
                    Object(preact_esm["b" /* h */])("img", { src: imageUri, alt: "Планировка" })),
                Object(preact_esm["b" /* h */])("ul", { class: "details" },
                    Object(preact_esm["b" /* h */])("li", { class: "room" },
                        ((roomTypeNum === 'Студия')
                            ? roomTypeNum
                            : [
                                roomTypeNum,
                                ' ',
                                Object(preact_esm["b" /* h */])("small", null, roomTypeText),
                            ]),
                        ' ',
                        String(squareTotal).replace('.', ','),
                        ' ',
                        Object(preact_esm["b" /* h */])("small", null, "\u043C\u00B2")),
                    Object(preact_esm["b" /* h */])("li", { class: "floor" },
                        section,
                        " \u0441\u0435\u043A\u0446\u0438\u044F, ",
                        floor,
                        " \u044D\u0442\u0430\u0436"),
                    Object(preact_esm["b" /* h */])("li", { class: classJoin({
                            empty: (totalCost === 0),
                        }, ['cost']) }, (totalCost > 0)
                        ? ListItem.formatMoney(totalCost) + ' ₽'
                        : 'По запросу')),
                Object(preact_esm["b" /* h */])("div", { class: "favorites" },
                    Object(preact_esm["b" /* h */])("input", { type: "checkbox", id: "apartment-" + id + "-favorites", value: String(id) }),
                    Object(preact_esm["b" /* h */])("label", { for: "apartment-" + id + "-favorites" },
                        Object(preact_esm["b" /* h */])("svg", { role: "img", width: "20", height: "20", viewBox: "0 0 20 20", title: "Добавить в избранное" },
                            Object(preact_esm["b" /* h */])("title", null, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0435"),
                            Object(preact_esm["b" /* h */])("path", { d: "M10 15.7l-5.6 2.9 1.1-6.2L1 8l6.2-.9L10 1.5l2.8 5.6L19 8l-4.5 4.4 1.1 6.2z" })))))));
    };
    return ListItem;
}(preact_esm["a" /* Component */]));
/**
 * Module
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/List.tsx

// Таблица планировок




/**
 * Таблица планировок
 */
var List_List = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](List, _super);
    function List() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Render component
     */
    List.prototype.render = function (_props, _a) {
        var items = _a.items;
        return (Object(preact_esm["b" /* h */])("div", { class: "apartments" },
            Object(preact_esm["b" /* h */])("ul", null, items.map(function (item) { return (Object(preact_esm["b" /* h */])(ListItem_ListItem, tslib_es6["a" /* __assign */]({ key: String(item.id) }, item))); }))));
    };
    return List;
}(AbstractListView_AbstractListView));
/**
 * Module
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/TableHeadRow.tsx


/**
 * Строка папки таблицы планировок.
 */
function TableHeadRow(_a) {
    var className = _a.className, role = _a.role, elementRef = _a.elementRef;
    return (Object(preact_esm["b" /* h */])("tr", { class: className, role: role, ref: elementRef },
        Object(preact_esm["b" /* h */])("th", { class: "image" }, "\u041F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0430"),
        Object(preact_esm["b" /* h */])("th", { class: "room-type" }, "\u041A\u043E\u043C\u043D\u0430\u0442\u044B"),
        Object(preact_esm["b" /* h */])("th", { class: "square-total" }, "\u041F\u043B\u043E\u0449\u0430\u0434\u044C, \u043C\u00B2"),
        Object(preact_esm["b" /* h */])("th", { class: "section" }, "\u0421\u0435\u043A\u0446\u0438\u044F"),
        Object(preact_esm["b" /* h */])("th", { class: "floor" }, "\u042D\u0442\u0430\u0436"),
        Object(preact_esm["b" /* h */])("th", { class: "total-cost" }, "\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C"),
        Object(preact_esm["b" /* h */])("th", { class: "other" }, "\u00A0")));
}
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/TableHead.tsx





/**
 * Шапка таблицы планировок.
 */
var TableHead_TableHead = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](TableHead, _super);
    /**
     * Шапка таблицы планировок.
     */
    function TableHead(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Сохраняет ссылку на элемент основной строки шапки.
         */
        _this.refRowMain = function (element) {
            _this.rowMain = element;
        };
        /**
         * Сохраняет ссылку на элемент строки для закрепления.
         */
        _this.refRowFixed = function (element) {
            _this.rowFixed = element;
        };
        /**
         * Изменяет размер ячеек фиксированной строки при изменении размера окна.
         */
        _this.onWindowResize = function () {
            if (!_this.rowMain || !_this.rowFixed) {
                return;
            }
            for (var i = 0, n = _this.rowMain.cells.length; i < n; i++) {
                var mainTr = _this.rowMain.cells[i];
                var fixedTr = _this.rowFixed.cells[i];
                fixedTr.style.width = window.getComputedStyle(mainTr).width;
            }
        };
        _this.onWindowResize = Object(throttleToFrame["a" /* default */])(_this.onWindowResize);
        return _this;
    }
    /**
     * Rendered component mounted to the DOM.
     */
    TableHead.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.onWindowResize);
        this.onWindowResize();
    };
    /**
     * Before component will be unmounted and destroyed.
     */
    TableHead.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onWindowResize);
    };
    /**
     * Before render, return false to skip render.
     */
    TableHead.prototype.shouldComponentUpdate = function () {
        // Никогда не обновлять компонент.
        return false;
    };
    /**
     * Render component.
     */
    TableHead.prototype.render = function () {
        return (Object(preact_esm["b" /* h */])("thead", null,
            Object(preact_esm["b" /* h */])(TableHeadRow, { className: "main", elementRef: this.refRowMain }),
            Object(preact_esm["b" /* h */])(TableHeadRow, { className: "fixed", role: "presentation", elementRef: this.refRowFixed })));
    };
    return TableHead;
}(preact_esm["a" /* Component */]));
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/TableRow.tsx

// Строка таблицы планировок



/**
 * Строка таблицы планировок
 */
var TableRow_TableRow = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](TableRow, _super);
    function TableRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Отформатировать цену
     *
     * @param value Сумма
     * @returns Строка для вывода
     */
    TableRow.formatMoney = function (value) {
        return value.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1 ');
    };
    /**
     * Render component
     */
    TableRow.prototype.render = function (_a) {
        var id = _a.id, section = _a.section, floor = _a.floor, roomType = _a.roomType, squareTotal = _a.squareTotal, totalCost = _a.totalCost, image = _a.image;
        var roomTypeNum = roomType.replace(/\s.+/, '');
        var roomTypeText = roomType.replace(/^[^(]+/, '');
        // TODO: Показывать миниатюры.
        var imageUri = "/images/apartments/plans/" + image.replace(/\.\w+$/, '') + ".png";
        return (Object(preact_esm["b" /* h */])("tr", null,
            Object(preact_esm["b" /* h */])("td", { class: "image" },
                Object(preact_esm["b" /* h */])("img", { src: imageUri, alt: "Планировка" })),
            Object(preact_esm["b" /* h */])("td", { class: "room-type" },
                roomTypeNum,
                ' ',
                roomTypeText
                    ? Object(preact_esm["b" /* h */])("small", null, roomTypeText)
                    : ''),
            Object(preact_esm["b" /* h */])("td", { class: "square-total" }, String(squareTotal).replace('.', ',')),
            Object(preact_esm["b" /* h */])("td", { class: "section" },
                section,
                " \u0441\u0435\u043A\u0446\u0438\u044F"),
            Object(preact_esm["b" /* h */])("td", { class: "floor" }, floor),
            Object(preact_esm["b" /* h */])("td", { class: classJoin({
                    empty: (totalCost === 0),
                }, ['total-cost']) }, (totalCost > 0)
                ? TableRow.formatMoney(totalCost) + ' ₽'
                : 'По запросу'),
            Object(preact_esm["b" /* h */])("td", { class: "other" },
                Object(preact_esm["b" /* h */])("a", { class: "more", href: "/choose/apartment/" + id + "/" }, "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435"),
                Object(preact_esm["b" /* h */])("span", { class: "favorites" },
                    Object(preact_esm["b" /* h */])("input", { type: "checkbox", id: "apartment-" + id + "-favorites", value: String(id) }),
                    Object(preact_esm["b" /* h */])("label", { for: "apartment-" + id + "-favorites" },
                        Object(preact_esm["b" /* h */])("svg", { role: "img", width: "20", height: "20", viewBox: "0 0 20 20", title: "Добавить в избранное" },
                            Object(preact_esm["b" /* h */])("title", null, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0435"),
                            Object(preact_esm["b" /* h */])("path", { d: "M10 15.7l-5.6 2.9 1.1-6.2L1 8l6.2-.9L10 1.5l2.8 5.6L19 8l-4.5 4.4 1.1 6.2z" })))))));
    };
    return TableRow;
}(preact_esm["a" /* Component */]));
/**
 * Module
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/Table.tsx

// Таблица планировок





/**
 * Таблица планировок
 */
var Table_Table = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](Table, _super);
    function Table() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Render component
     */
    Table.prototype.render = function (_props, _a) {
        var items = _a.items;
        return (Object(preact_esm["b" /* h */])("div", { class: "apartments" },
            Object(preact_esm["b" /* h */])("table", null,
                Object(preact_esm["b" /* h */])(TableHead_TableHead, null),
                Object(preact_esm["b" /* h */])("tbody", null, items.map(function (item) { return (Object(preact_esm["b" /* h */])(TableRow_TableRow, tslib_es6["a" /* __assign */]({ key: String(item.id) }, item))); })))));
    };
    return Table;
}(AbstractListView_AbstractListView));
/**
 * Module
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/RootList.tsx











/**
 * Корень вида списком.
 */
var RootList_RootList = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](RootList, _super);
    /**
     * Корень вида списком.
     */
    function RootList(props) {
        var _this = _super.call(this, props) || this;
        /**
         * При изменении режима экрана.
         */
        _this.onScreenModeChange = function (mode) {
            dispatch(setListMode(mode < 1 /* TABLET */));
        };
        return _this;
    }
    /**
     * Rendered component mounted to the DOM.
     */
    RootList.prototype.componentDidMount = function () {
        Object(Screen["a" /* addScreenModeListener */])(this.onScreenModeChange);
        // Актуализируем адресную строку и список.
        var query = listStateToQueryString(getState().filter);
        updateAddress(query);
        debouncedFetchList(query);
    };
    /**
     * Before component will be unmounted and destroyed.
     */
    RootList.prototype.componentWillUnmount = function () {
        Object(Screen["c" /* removeScreenModeListener */])(this.onScreenModeChange);
    };
    /**
     * Render component.
     */
    RootList.prototype.render = function (_props, _a) {
        var listMode = _a.listMode;
        return (listMode
            ? Object(preact_esm["b" /* h */])(List_List, null)
            : Object(preact_esm["b" /* h */])(Table_Table, null));
    };
    /**
     * Handle Store changes.
     */
    RootList.prototype.storeStateChanged = function (_a) {
        var listMode = _a.listData.listMode;
        if (listMode === this.state.listMode) {
            return;
        }
        this.setState({ listMode: listMode });
    };
    return RootList;
}(SubscribedComponent));
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/AbstractVisualStep.ts






/**
 * Абстрактный компонент шага визуального выбиратора.
 */
var AbstractVisualStep_AbstractVisualStep = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](AbstractVisualStep, _super);
    /**
     * Абстрактный компонент шага визуального выбиратора.
     */
    function AbstractVisualStep(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Количество прикосновений к области.
         */
        _this.areaTouchCount = 0;
        /**
         * Область, по которой было прикосновение.
         */
        _this.areaTouchTarget = null;
        /**
         * Сохраняет ссылку на элемент карты.
         */
        _this.refMapContainer = function (element) {
            _this.mapContainer = element;
        };
        /**
         * При отведении курсора с области.
         */
        _this.onAreaMouseLeave = function () {
            dispatch(setTooltipVisibility(false));
        };
        /**
         * При нажатии на область.
         */
        _this.onAreaTouch = function (event) {
            var target = event.target;
            var targetId = target.getAttribute('data-target');
            if (!targetId) {
                return;
            }
            if (_this.areaTouchTarget !== target) {
                _this.areaTouchCount = 0;
            }
            _this.areaTouchCount++;
            _this.areaTouchTarget = target;
        };
        /**
         * Добавляет класс в зависимости от соотношения сторон элемента карты.
         */
        _this.onWindowResize = function () {
            var map = _this.mapContainer;
            if (!map) {
                return;
            }
            var ratio = map.offsetWidth / map.offsetHeight;
            var aspectRatioLessThanImage = (ratio < AbstractVisualStep.IMAGE_ASPECT_RATIO);
            _this.setState({ aspectRatioLessThanImage: aspectRatioLessThanImage });
        };
        _this.setState({
            aspectRatioLessThanImage: false,
        });
        _this.onWindowResize = Object(throttleToFrame["a" /* default */])(_this.onWindowResize);
        return _this;
    }
    /**
     * Rendered component mounted to the DOM.
     */
    AbstractVisualStep.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.onWindowResize);
        this.onWindowResize();
    };
    /**
     * Before component will be unmounted and destroyed.
     */
    AbstractVisualStep.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onWindowResize);
    };
    /**
     * Соотношение сторон изображения на карте.
     */
    AbstractVisualStep.IMAGE_ASPECT_RATIO = 16 / 9;
    /**
     * Класс, назначаемый при меньшем соотношении сторон.
     */
    AbstractVisualStep.CLASS_INVERT_ASPECT = 'invert-aspect';
    return AbstractVisualStep;
}(preact_esm["a" /* Component */]));
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/NumberScroll.tsx




/**
 * Компонент прокрутки номера в заданном диапазоне.
 */
var NumberScroll_NumberScroll = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](NumberScroll, _super);
    function NumberScroll() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * При нажатии на элемент списка.
         */
        _this.onItemsClick = function (event) {
            var target = event.target;
            if (target.tagName !== 'LI') {
                return;
            }
            var value = Number(target.dataset.value);
            if (!isNaN(value)) {
                _this.props.onChange(value);
            }
        };
        /**
         * При нажатии на «Назад»
         */
        _this.onBackClick = function () {
            var nextValue = _this.props.value - 1;
            if (nextValue >= _this.props.min) {
                _this.props.onChange(nextValue);
            }
        };
        /**
         * При нажатии на Вперёд
         */
        _this.onForwardClick = function () {
            var nextValue = _this.props.value + 1;
            if (nextValue <= _this.props.max) {
                _this.props.onChange(nextValue);
            }
        };
        return _this;
    }
    /**
     * Render component.
     */
    NumberScroll.prototype.render = function (_a) {
        var min = _a.min, max = _a.max, value = _a.value;
        var items = this.getValueRange();
        return (Object(preact_esm["b" /* h */])("div", { class: "number-scroll" },
            Object(preact_esm["b" /* h */])("button", { type: "button", class: "back", disabled: value === min, onClick: this.onBackClick }, "\u041D\u0430\u0437\u0430\u0434"),
            Object(preact_esm["b" /* h */])("ul", { onClick: this.onItemsClick }, items.map(function (item) { return (Object(preact_esm["b" /* h */])("li", { class: classJoin({ current: (value === item) }), "data-value": item }, item)); })),
            Object(preact_esm["b" /* h */])("button", { type: "button", class: "forward", disabled: value === max, onClick: this.onForwardClick }, "\u0412\u043F\u0435\u0440\u0451\u0434")));
    };
    /**
     * Получить видимый диапазон цифр для текущего значения.
     */
    NumberScroll.prototype.getValueRange = function () {
        var _a = this.props, min = _a.min, max = _a.max, value = _a.value;
        var steps = this.props.steps || 2;
        var values = [];
        var from = value - steps;
        var to = value + steps;
        if (from < min) {
            to += min - from;
            from = min;
        }
        if (to > max) {
            from += max - to;
            to = max;
        }
        if (from < min) {
            from = min;
        }
        for (var i = from; i <= to; i++) {
            values.push(i);
        }
        return values;
    };
    /**
     * Default properties of the component.
     */
    NumberScroll.defaultProps = {
        steps: 2,
    };
    return NumberScroll;
}(preact_esm["a" /* Component */]));
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/utils/FormatHelpers.ts

// Вспомогательные функции для форматирования вывода.
/**
 * Отформатировать цену
 *
 * @param value Сумма
 * @returns Строка для вывода
 */
function formatMoney(value) {
    return value.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1 ');
}
/**
 * Извлекает количество комнат из типа комнат.
 *
 * @param roomType Тип комнат.
 * @returns Количество комнат.
 */
function extractRoomTypeNum(roomType) {
    return roomType.replace(/\s.+/, '');
}
/**
 * Извлекает текст типа из типа комнат.
 *
 * @param roomType Тип комнат.
 * @returns Текст типа комнаты.
 */
function extractRoomTypeText(roomType) {
    return roomType.replace(/^[^(]+/, '') || 'комн.';
}
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/MobileVisualFloor.tsx










/**
 * Мобильный вариант вида этажа.
 */
var MobileVisualFloor_MobileVisualFloor = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](MobileVisualFloor, _super);
    /**
     * Мобильный вариант вида этажа.
     */
    function MobileVisualFloor(props) {
        var _this = _super.call(this, props) || this;
        /**
         * При нажатии на область.
         */
        _this.onAreaClick = function (event) {
            var target = event.target;
            var targetId = target.getAttribute('data-target');
            if (!targetId) {
                return;
            }
            dispatch(setTooltipVisibility(false));
            window.location.href = "/choose/apartment/" + targetId + "/";
        };
        /**
         * При нажатии на «Назад».
         */
        _this.onBackClick = function (event) {
            dispatch(setStep(0 /* OVERVIEW */));
            event.preventDefault();
        };
        /**
         * Сохранить ссылку на элемент карты областей.
         */
        _this.refMap = function (element) {
            _this.mapElement = element;
        };
        /**
         * При изменении этажа.
         */
        _this.onFloorChange = function (value) {
            fetchVisualFloor(value);
        };
        _this.setState({
            labels: [],
        });
        return _this;
    }
    /**
     * Before render, return false to skip render.
     */
    MobileVisualFloor.prototype.shouldComponentUpdate = function (_a, _b) {
        var building = _a.building, section = _a.section, floor = _a.floor, image = _a.image, map = _a.map, background = _a.background, floorsCount = _a.floorsCount;
        var aspectRatioLessThanImage = _b.aspectRatioLessThanImage, labels = _b.labels;
        if ((map !== this.props.map)
            && (labels === this.state.labels)) {
            this.setState({
                labels: [],
            });
        }
        return ((building !== this.props.building)
            || (section !== this.props.section)
            || (floor !== this.props.floor)
            || (image !== this.props.image)
            || (map !== this.props.map)
            || (background !== this.props.background)
            || (floorsCount !== this.props.floorsCount)
            || (labels !== this.state.labels)
            || (aspectRatioLessThanImage !== this.state.aspectRatioLessThanImage));
    };
    /**
     * Rendered component mounted to the DOM.
     */
    MobileVisualFloor.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        if (this.state.labels.length === 0) {
            this.updateMapLabels();
        }
    };
    /**
     * Render component.
     */
    MobileVisualFloor.prototype.render = function (_a, _b) {
        var _this = this;
        var section = _a.section, floor = _a.floor, image = _a.image, map = _a.map, background = _a.background, floorsCount = _a.floorsCount;
        var aspectRatioLessThanImage = _b.aspectRatioLessThanImage, labels = _b.labels;
        var floorUri = window.location.pathname + window.location.search;
        var sectionUri = floorUri.replace(/&floor=[^&]+/, '');
        var buildingUri = sectionUri.replace(/&section=[^&]+/, '');
        var overviewUri = buildingUri.replace(/&building=[^&]+/, '');
        var emptyMap = (map.length === 0);
        var compasLeft = 500;
        var compasTop = 670;
        return (Object(preact_esm["b" /* h */])("section", { class: "floor" },
            Object(preact_esm["b" /* h */])("header", null,
                Object(preact_esm["b" /* h */])("a", { class: "back", href: overviewUri, onClick: this.onBackClick }, "\u041D\u0430\u0437\u0430\u0434"),
                Object(preact_esm["b" /* h */])("h2", null,
                    "\u0421\u0435\u043A\u0446\u0438\u044F ",
                    section,
                    ", \u042D\u0442\u0430\u0436 ",
                    floor)),
            Object(preact_esm["b" /* h */])("div", { class: classJoin((_c = {},
                    _c[AbstractVisualStep_AbstractVisualStep.CLASS_INVERT_ASPECT] = aspectRatioLessThanImage,
                    _c['empty-map'] = emptyMap,
                    _c), ['map']), ref: this.refMapContainer },
                Object(preact_esm["b" /* h */])("img", { class: "background", src: background, alt: "" }),
                Object(preact_esm["b" /* h */])("img", { src: image, alt: "" }),
                Object(preact_esm["b" /* h */])("svg", { width: "1920", height: "1080", viewBox: "0 0 1920 1080", ref: this.refMap },
                    Object(preact_esm["b" /* h */])("use", { xlinkHref: "/images/choose-visual/compasses.svg#fixed", width: "108", height: "47", stroke: "#FFF", fill: "#FFF", opacity: "0.5", transform: "translate(" + compasLeft + "," + compasTop + ")" }),
                    map.map(function (area) { return (Object(preact_esm["b" /* h */])("path", { d: area.path, "data-target": area.target, "data-room-num": extractRoomTypeNum(area.roomType), "data-room-type": extractRoomTypeText(area.roomType), "data-area": String(area.squareTotal).replace('.', ','), "data-cost": (area.totalCost > 0)
                            ? formatMoney(area.totalCost) + ' ₽'
                            : 'По запросу', onClick: _this.onAreaClick })); }),
                    labels.map(function (label) { return (Object(preact_esm["b" /* h */])("text", { x: label.x, y: label.y },
                        Object(preact_esm["b" /* h */])("tspan", null, label.value),
                        ' ',
                        label.text)); }),
                    emptyMap
                        ? (Object(preact_esm["b" /* h */])("text", { class: "empty", x: "50%", y: "50%", "text-anchor": "middle" },
                            Object(preact_esm["b" /* h */])("tspan", { dy: "-1.2em" }, "\u041D\u0430 \u044D\u0442\u043E\u043C \u044D\u0442\u0430\u0436\u0435"),
                            Object(preact_esm["b" /* h */])("tspan", { x: "50%", dy: "1.2em" }, "\u043D\u0435\u0442 \u043A\u0432\u0430\u0440\u0442\u0438\u0440 \u0432 \u043F\u0440\u043E\u0434\u0430\u0436\u0435")))
                        : '')),
            Object(preact_esm["b" /* h */])("div", { class: "items-list" },
                Object(preact_esm["b" /* h */])("p", { class: "label" }, "\u042D\u0442\u0430\u0436"),
                Object(preact_esm["b" /* h */])(NumberScroll_NumberScroll, { min: 2, max: floorsCount, value: floor, steps: 3, onChange: this.onFloorChange }))));
        var _c;
    };
    /**
     * After render.
     */
    MobileVisualFloor.prototype.componentDidUpdate = function () {
        if (this.state.labels.length === 0) {
            this.updateMapLabels();
        }
    };
    /**
     * Обновляет подписи к областям на карте.
     */
    MobileVisualFloor.prototype.updateMapLabels = function () {
        var labels = [];
        var paths = this.mapElement.getElementsByTagName('path');
        for (var i = 0, n = paths.length; i < n; i++) {
            var path = paths[i];
            var roomNum = path.getAttribute('data-room-num');
            if (!roomNum) {
                continue;
            }
            var studio = (roomNum === 'Студия');
            var roomType = ((studio)
                ? roomNum
                : path.getAttribute('data-room-type') || '');
            var bbox = path.getBBox();
            labels.push({
                x: Math.round(bbox.x + bbox.width / 2),
                y: Math.round(bbox.y + bbox.height / 2),
                value: (studio ? '' : roomNum),
                text: roomType,
            });
        }
        if (labels.length !== 0) {
            this.setState({ labels: labels });
        }
    };
    return MobileVisualFloor;
}(AbstractVisualStep_AbstractVisualStep));
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/MobileVisualItemsList.tsx




/**
 * Список элементов мобильного режима визуального выборщика.
 */
var MobileVisualItemsList_MobileVisualItemsList = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](MobileVisualItemsList, _super);
    function MobileVisualItemsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * При нажатии на элемент списка.
         */
        _this.onItemsClick = function (event) {
            var target = event.target;
            if ((target.tagName !== 'LI')
                || target.classList.contains('disabled')) {
                return;
            }
            var value = target.dataset.value;
            if (value) {
                _this.props.onChange(value);
            }
        };
        return _this;
    }
    /**
     * Render component.
     */
    MobileVisualItemsList.prototype.render = function (_a) {
        var label = _a.label, items = _a.items;
        return (Object(preact_esm["b" /* h */])("div", { class: "items-list" },
            Object(preact_esm["b" /* h */])("p", { class: "label" }, label),
            Object(preact_esm["b" /* h */])("ul", { onClick: this.onItemsClick }, items.map(function (item) { return (Object(preact_esm["b" /* h */])("li", { class: classJoin({ disabled: item.available === 0 }), "data-value": item.target }, item.target)); }))));
    };
    return MobileVisualItemsList;
}(preact_esm["a" /* Component */]));
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/MobileVisualOverview.tsx











/**
 * Мобильный вариант общего экрана.
 */
var MobileVisualOverview_MobileVisualOverview = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](MobileVisualOverview, _super);
    function MobileVisualOverview() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * При нажатии на область.
         */
        _this.onAreaClick = function (event) {
            var target = event.target;
            var targetId = target.getAttribute('data-target');
            if (!targetId) {
                return;
            }
            var available = target.getAttribute('data-available') || '0';
            if (available === '0') {
                return;
            }
            _this.setSection(targetId);
        };
        /**
         * При изменении значения списка элементов.
         */
        _this.onItemListChange = function (value) {
            _this.setSection(value);
        };
        return _this;
    }
    /**
     * Rendered component mounted to the DOM.
     */
    MobileVisualOverview.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        var _a = getState().visualData, step = _a.step, prevStep = _a.prevStep, overview = _a.overview;
        if (step < prevStep) {
            fetchVisualOverview(overview.view);
        }
    };
    /**
     * Render component.
     */
    MobileVisualOverview.prototype.render = function (_a, _b) {
        var _this = this;
        var image = _a.image, map = _a.map;
        var aspectRatioLessThanImage = _b.aspectRatioLessThanImage;
        return (Object(preact_esm["b" /* h */])("section", { class: "overview" },
            Object(preact_esm["b" /* h */])("header", null,
                Object(preact_esm["b" /* h */])("h2", null, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0435\u043A\u0446\u0438\u044E")),
            Object(preact_esm["b" /* h */])("div", { class: classJoin((_c = {},
                    _c[AbstractVisualStep_AbstractVisualStep.CLASS_INVERT_ASPECT] = aspectRatioLessThanImage,
                    _c), ['map']), ref: this.refMapContainer },
                Object(preact_esm["b" /* h */])("img", { src: image, alt: "" }),
                Object(preact_esm["b" /* h */])("svg", { width: "1920", height: "1080", viewBox: "0 0 1920 1080" }, map
                    .filter(function (area) { return (area.available !== 0); })
                    .map(function (area) { return (Object(preact_esm["b" /* h */])("path", { d: area.path, "data-target": area.target, "data-available": area.available, onClick: _this.onAreaClick })); }))),
            Object(preact_esm["b" /* h */])(MobileVisualItemsList_MobileVisualItemsList, { label: "Секция", items: map, onChange: this.onItemListChange })));
        var _c;
    };
    /**
     * Выбирает секцию.
     *
     * @param value Номер секции.
     */
    MobileVisualOverview.prototype.setSection = function (value) {
        dispatch(setBuilding({
            building: '1',
            view: this.props.view,
            nextView: '',
            image: '',
            map: [],
        }));
        dispatch(setSection({
            section: value,
            view: this.props.view,
            nextView: '',
            image: this.props.image,
            map: [],
        }));
        fetchVisualSection(value, this.props.view);
        dispatch(setStep(2 /* FLOOR */));
        fetchVisualFloor(2);
    };
    return MobileVisualOverview;
}(AbstractVisualStep_AbstractVisualStep));
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/VisualFloor.tsx











/**
 * Общий экран.
 */
var VisualFloor_VisualFloor = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](VisualFloor, _super);
    /**
     * Общий экран.
     */
    function VisualFloor(props) {
        var _this = _super.call(this, props) || this;
        /**
         * При нажатии на область.
         */
        _this.onAreaClick = function (event) {
            var target = event.target;
            var targetId = target.getAttribute('data-target');
            if (!targetId) {
                return;
            }
            dispatch(setTooltipVisibility(false));
            window.location.href = "/choose/apartment/" + targetId + "/";
        };
        /**
         * При наведении курсора на область.
         */
        _this.onAreaMouseEnter = function (event) {
            var target = event.target;
            var roomNum = target.getAttribute('data-room-num');
            if (!roomNum) {
                return;
            }
            var roomType = target.getAttribute('data-room-type') || '';
            var area = target.getAttribute('data-area') || '';
            var cost = target.getAttribute('data-cost') || '';
            var title = [
                roomNum + ' ',
                ((roomNum === 'Студия')
                    ? ''
                    : Object(preact_esm["b" /* h */])("small", null, roomType)),
                " " + area + " ",
                Object(preact_esm["b" /* h */])("small", null, "\u043C\u00B2"),
            ];
            dispatch(setTooltip(title, 'Стоимость: ' + cost));
        };
        /**
         * При нажатии на «План комплекса».
         */
        _this.onOverviewClick = function (event) {
            dispatch(setStep(0 /* OVERVIEW */));
            event.preventDefault();
        };
        /**
         * При нажатии на «Секция».
         */
        _this.onSectionClick = function (event) {
            dispatch(setStep(1 /* SECTION */));
            event.preventDefault();
        };
        /**
         * Сохранить ссылку на элемент карты областей.
         */
        _this.refMap = function (element) {
            _this.mapElement = element;
        };
        /**
         * При изменении этажа.
         */
        _this.onFloorChange = function (value) {
            fetchVisualFloor(value);
        };
        _this.setState({
            labels: [],
        });
        return _this;
    }
    /**
     * Before render, return false to skip render.
     */
    VisualFloor.prototype.shouldComponentUpdate = function (_a, _b) {
        var building = _a.building, section = _a.section, floor = _a.floor, image = _a.image, map = _a.map, background = _a.background;
        var aspectRatioLessThanImage = _b.aspectRatioLessThanImage, labels = _b.labels;
        if ((map !== this.props.map)
            && (labels === this.state.labels)) {
            this.setState({
                labels: [],
            });
        }
        return ((building !== this.props.building)
            || (section !== this.props.section)
            || (floor !== this.props.floor)
            || (image !== this.props.image)
            || (map !== this.props.map)
            || (background !== this.props.background)
            || (labels !== this.state.labels)
            || (aspectRatioLessThanImage !== this.state.aspectRatioLessThanImage));
    };
    /**
     * Rendered component mounted to the DOM.
     */
    VisualFloor.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        if (this.state.labels.length === 0) {
            this.updateMapLabels();
        }
    };
    /**
     * Render component.
     */
    VisualFloor.prototype.render = function (_a, _b) {
        var _this = this;
        var section = _a.section, floor = _a.floor, image = _a.image, map = _a.map, background = _a.background, floorsCount = _a.floorsCount;
        var aspectRatioLessThanImage = _b.aspectRatioLessThanImage, labels = _b.labels;
        var floorUri = window.location.pathname + window.location.search;
        var sectionUri = floorUri.replace(/&floor=[^&]+/, '');
        var buildingUri = sectionUri.replace(/&section=[^&]+/, '');
        var overviewUri = buildingUri.replace(/&building=[^&]+/, '');
        var emptyMap = (map.length === 0);
        var compasLeft = 500;
        var compasTop = 670;
        return (Object(preact_esm["b" /* h */])("section", { class: "floor" },
            Object(preact_esm["b" /* h */])("header", null,
                Object(preact_esm["b" /* h */])("div", { class: "overview" },
                    Object(preact_esm["b" /* h */])("a", { href: overviewUri, onClick: this.onOverviewClick }, "\u041F\u043B\u0430\u043D \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u0430")),
                Object(preact_esm["b" /* h */])("h2", null,
                    Object(preact_esm["b" /* h */])("a", { class: "section", href: sectionUri, onClick: this.onSectionClick },
                        "\u0421\u0435\u043A\u0446\u0438\u044F ",
                        section),
                    Object(preact_esm["b" /* h */])("span", { class: "separator" }, ", "),
                    Object(preact_esm["b" /* h */])("span", { class: "floor" },
                        "\u042D\u0442\u0430\u0436 ",
                        floor))),
            Object(preact_esm["b" /* h */])("div", { class: "scheme" }, createSectionsScheme(section)),
            Object(preact_esm["b" /* h */])(NumberScroll_NumberScroll, { min: 2, max: floorsCount, value: floor, onChange: this.onFloorChange }),
            Object(preact_esm["b" /* h */])("div", { class: classJoin((_c = {},
                    _c[AbstractVisualStep_AbstractVisualStep.CLASS_INVERT_ASPECT] = aspectRatioLessThanImage,
                    _c['empty-map'] = emptyMap,
                    _c), ['map']), ref: this.refMapContainer },
                Object(preact_esm["b" /* h */])("img", { class: "background", src: background, alt: "" }),
                Object(preact_esm["b" /* h */])("img", { src: image, alt: "" }),
                Object(preact_esm["b" /* h */])("svg", { width: "1920", height: "1080", viewBox: "0 0 1920 1080", ref: this.refMap },
                    Object(preact_esm["b" /* h */])("use", { xlinkHref: "/images/choose-visual/compasses.svg#fixed", width: "108", height: "47", stroke: "#FFF", fill: "#FFF", opacity: "0.5", transform: "translate(" + compasLeft + "," + compasTop + ")" }),
                    map.map(function (area) { return (Object(preact_esm["b" /* h */])("path", { d: area.path, "data-target": area.target, "data-room-num": extractRoomTypeNum(area.roomType), "data-room-type": extractRoomTypeText(area.roomType), "data-area": String(area.squareTotal).replace('.', ','), "data-cost": (area.totalCost > 0)
                            ? formatMoney(area.totalCost) + ' ₽'
                            : 'По запросу', onClick: _this.onAreaClick, onMouseEnter: _this.onAreaMouseEnter, onMouseLeave: _this.onAreaMouseLeave })); }),
                    labels.map(function (label) { return (Object(preact_esm["b" /* h */])("text", { x: label.x, y: label.y },
                        Object(preact_esm["b" /* h */])("tspan", null, label.value),
                        ' ',
                        label.text)); }),
                    emptyMap
                        ? (Object(preact_esm["b" /* h */])("text", { class: "empty", x: "50%", y: "50%", "text-anchor": "middle" },
                            Object(preact_esm["b" /* h */])("tspan", { dy: "-1.2em" }, "\u041D\u0430 \u044D\u0442\u043E\u043C \u044D\u0442\u0430\u0436\u0435"),
                            Object(preact_esm["b" /* h */])("tspan", { x: "50%", dy: "1.2em" }, "\u043D\u0435\u0442 \u043A\u0432\u0430\u0440\u0442\u0438\u0440 \u0432 \u043F\u0440\u043E\u0434\u0430\u0436\u0435")))
                        : ''))));
        var _c;
    };
    /**
     * After render.
     */
    VisualFloor.prototype.componentDidUpdate = function () {
        if (this.state.labels.length === 0) {
            this.updateMapLabels();
        }
    };
    /**
     * Обновляет подписи к областям на карте.
     */
    VisualFloor.prototype.updateMapLabels = function () {
        var labels = [];
        var paths = this.mapElement.getElementsByTagName('path');
        for (var i = 0, n = paths.length; i < n; i++) {
            var path = paths[i];
            var roomNum = path.getAttribute('data-room-num');
            if (!roomNum) {
                continue;
            }
            var studio = (roomNum === 'Студия');
            var roomType = ((studio)
                ? roomNum
                : path.getAttribute('data-room-type') || '');
            var bbox = path.getBBox();
            labels.push({
                x: Math.round(bbox.x + bbox.width / 2),
                y: Math.round(bbox.y + bbox.height / 2),
                value: (studio ? '' : roomNum),
                text: roomType,
            });
        }
        if (labels.length !== 0) {
            this.setState({ labels: labels });
        }
    };
    return VisualFloor;
}(AbstractVisualStep_AbstractVisualStep));
/**
 * Формирует SVG схему секций.
 *
 * @param section Номер текущей секции.
 */
function createSectionsScheme(section) {
    var paths = sectionSchemeSvgPaths_default.a.paths;
    var pathElements = [];
    var sectionIndex = Number(section) - 1;
    for (var i = 0, n = paths.length; i < n; i++) {
        pathElements.push(Object(preact_esm["b" /* h */])("path", { d: paths[i], class: ((sectionIndex === i) ? 'current' : '') }));
    }
    return (Object(preact_esm["b" /* h */])("svg", { width: "289", height: "95", viewBox: "0 0 289 95" }, pathElements));
}
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/VisualOverview.tsx





// import fetchVisualBuilding from './asyncActions/fetchVisualBuilding';




/**
 * Общий экран.
 */
var VisualOverview_VisualOverview = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](VisualOverview, _super);
    function VisualOverview() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * При нажатии на область.
         */
        _this.onAreaClick = function (event) {
            if (_this.areaTouchTarget && (_this.areaTouchCount < 2)) {
                return;
            }
            _this.areaTouchCount = 0;
            _this.areaTouchTarget = null;
            var target = event.target;
            var targetId = target.getAttribute('data-target');
            if (!targetId) {
                return;
            }
            var available = target.getAttribute('data-available') || '0';
            if (available === '0') {
                return;
            }
            /* if ( targetId === '2' )
            { */
            dispatch(setBuilding({
                building: '1',
                view: _this.props.view,
                nextView: '',
                image: '',
                map: [],
            }));
            dispatch(setStep(1 /* SECTION */));
            fetchVisualSection(targetId, _this.props.view);
            /* }
            else
            {
                dispatch( setStep( StateVisualStep.BUILDING ) );
                fetchVisualBuilding( targetId, this.props.view );
            } */
            dispatch(setTooltipVisibility(false));
        };
        /**
         * При наведении курсора на область.
         */
        _this.onAreaMouseEnter = function (event) {
            var target = event.target;
            var targetId = target.getAttribute('data-target');
            if (!targetId) {
                return;
            }
            var available = target.getAttribute('data-available') || '0';
            dispatch(setTooltip(targetId + ' секция', // ' корпус',
            available + ' квартир в продаже'));
        };
        /**
         * При нажатии на «Другой ракурс».
         */
        _this.onSwitchViewClick = function () {
            fetchVisualOverview(_this.props.nextView);
        };
        return _this;
    }
    /**
     * Rendered component mounted to the DOM.
     */
    VisualOverview.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        var _a = getState().visualData, step = _a.step, prevStep = _a.prevStep, overview = _a.overview;
        if (step < prevStep) {
            fetchVisualOverview(overview.view);
        }
    };
    /**
     * Before render, return false to skip render.
     */
    /*public shouldComponentUpdate( {image, map}: VisualOverviewProps ): boolean
    {
        return (
            ( image !== this.props.image )
            || ( map !== this.props.map )
        );
    }*/
    /**
     * Render component.
     */
    VisualOverview.prototype.render = function (_a, _b) {
        var _this = this;
        var nextView = _a.nextView, image = _a.image, map = _a.map;
        var aspectRatioLessThanImage = _b.aspectRatioLessThanImage;
        return (Object(preact_esm["b" /* h */])("section", { class: "overview" },
            Object(preact_esm["b" /* h */])("header", null,
                Object(preact_esm["b" /* h */])("h2", null, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0435\u043A\u0446\u0438\u044E")),
            nextView
                ? (Object(preact_esm["b" /* h */])("button", { type: "button", class: "switch-view", onClick: this.onSwitchViewClick }, "\u0414\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u043A\u0443\u0440\u0441"))
                : '',
            Object(preact_esm["b" /* h */])("div", { class: classJoin((_c = {},
                    _c[AbstractVisualStep_AbstractVisualStep.CLASS_INVERT_ASPECT] = aspectRatioLessThanImage,
                    _c), ['map']), ref: this.refMapContainer },
                Object(preact_esm["b" /* h */])("img", { src: image, alt: "" }),
                Object(preact_esm["b" /* h */])("svg", { width: "1920", height: "1080", viewBox: "0 0 1920 1080" }, map.map(function (area) { return (Object(preact_esm["b" /* h */])("path", { class: area.available === 0 ? 'disabled' : '', d: area.path, "data-target": area.target, "data-available": area.available, onClick: _this.onAreaClick, onTouchStart: _this.onAreaTouch, onMouseEnter: _this.onAreaMouseEnter, onMouseLeave: _this.onAreaMouseLeave })); })))));
        var _c;
    };
    return VisualOverview;
}(AbstractVisualStep_AbstractVisualStep));
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/VisualSection.tsx







// import {toggleSection} from './Store/creators/filter';


/**
 * Общий экран.
 */
var VisualSection_VisualSection = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](VisualSection, _super);
    function VisualSection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * При нажатии на область.
         */
        _this.onAreaClick = function (event) {
            if (_this.areaTouchTarget && (_this.areaTouchCount < 2)) {
                return;
            }
            _this.areaTouchCount = 0;
            _this.areaTouchTarget = null;
            var target = event.target;
            var targetId = target.getAttribute('data-target');
            if (!targetId) {
                return;
            }
            var available = target.getAttribute('data-available') || '0';
            if (available === '0') {
                return;
            }
            dispatch(setStep(2 /* FLOOR */));
            fetchVisualFloor(Number(targetId));
            dispatch(setTooltipVisibility(false));
        };
        /**
         * При наведении курсора на область.
         */
        _this.onAreaMouseEnter = function (event) {
            var target = event.target;
            var targetId = target.getAttribute('data-target');
            if (!targetId) {
                return;
            }
            var available = target.getAttribute('data-available') || '0';
            dispatch(setTooltip(targetId + ' этаж', available + ' квартир в продаже'));
        };
        /**
         * При нажатии на «Другой ракурс».
         */
        _this.onSwitchViewClick = function () {
            fetchVisualSection(_this.props.section, _this.props.nextView);
        };
        /**
         * При нажатии на «План комплекса».
         */
        _this.onOverviewClick = function (event) {
            dispatch(setStep(0 /* OVERVIEW */));
            event.preventDefault();
        };
        return _this;
    }
    /**
     * Rendered component mounted to the DOM.
     */
    VisualSection.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        var _a = getState().visualData, step = _a.step, prevStep = _a.prevStep, section = _a.section;
        if (step < prevStep) {
            fetchVisualSection(section.section, section.view);
        }
    };
    /**
     * Before render, return false to skip render.
     */
    /*public shouldComponentUpdate( {section, image, map}: VisualSectionProps ): boolean
    {
        return (
            ( section !== this.props.section )
            || ( image !== this.props.image )
            || ( map !== this.props.map )
        );
    }*/
    /**
     * Render component.
     */
    VisualSection.prototype.render = function (_a, _b) {
        var _this = this;
        var nextView = _a.nextView, section = _a.section, image = _a.image, map = _a.map;
        var aspectRatioLessThanImage = _b.aspectRatioLessThanImage;
        var sectionUri = window.location.pathname + window.location.search;
        var buildingUri = sectionUri.replace(/&section=[^&]+/, '');
        var overviewUri = buildingUri.replace(/&building=[^&]+/, '');
        return (Object(preact_esm["b" /* h */])("section", { class: "section" },
            Object(preact_esm["b" /* h */])("header", null,
                Object(preact_esm["b" /* h */])("div", { class: "overview" },
                    Object(preact_esm["b" /* h */])("a", { href: overviewUri, onClick: this.onOverviewClick }, "\u041F\u043B\u0430\u043D \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u0430")),
                Object(preact_esm["b" /* h */])("h2", null,
                    Object(preact_esm["b" /* h */])("span", { class: "section" },
                        "\u0421\u0435\u043A\u0446\u0438\u044F ",
                        section))),
            nextView
                ? (Object(preact_esm["b" /* h */])("button", { type: "button", class: "switch-view", onClick: this.onSwitchViewClick }, "\u0414\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u043A\u0443\u0440\u0441"))
                : '',
            Object(preact_esm["b" /* h */])("div", { class: classJoin((_c = {},
                    _c[AbstractVisualStep_AbstractVisualStep.CLASS_INVERT_ASPECT] = aspectRatioLessThanImage,
                    _c), ['map']), ref: this.refMapContainer },
                Object(preact_esm["b" /* h */])("img", { src: image, alt: "" }),
                Object(preact_esm["b" /* h */])("svg", { width: "1920", height: "1080", viewBox: "0 0 1920 1080" }, map.map(function (area) { return (Object(preact_esm["b" /* h */])("path", { class: area.available === 0 ? 'disabled' : '', d: area.path, "data-target": area.target, "data-available": area.available, onClick: _this.onAreaClick, onTouchStart: _this.onAreaTouch, onMouseEnter: _this.onAreaMouseEnter, onMouseLeave: _this.onAreaMouseLeave })); })))));
        var _c;
    };
    return VisualSection;
}(AbstractVisualStep_AbstractVisualStep));
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/VisualTooltip.tsx




/**
 * Всплывающая подсказка.
 */
var VisualTooltip_VisualTooltip = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](VisualTooltip, _super);
    /**
     * Всплывающая подсказка.
     */
    function VisualTooltip(props) {
        var _this = _super.call(this, props) || this;
        /**
         * При перемещении мыши по документу.
         */
        _this.onMouseMove = function (event) {
            _this.setState({
                cursorX: event.clientX,
                cursorY: event.clientY,
            });
        };
        return _this;
    }
    /**
     * Rendered component mounted to the DOM.
     */
    /*public componentDidMount(): void
    {
        super.componentDidMount();
    }*/
    /**
     * Before component will be unmounted and destroyed.
     */
    /*public componentWillUnmount(): void
    {
        super.componentWillUnmount();
    }*/
    /**
     * Before render, return false to skip render.
     */
    /*public shouldComponentUpdate( props: VisualTooltipProps, state: VisualTooltipState ): boolean
    {
        return true;
    }*/
    /**
     * Render component.
     */
    VisualTooltip.prototype.render = function (_props, _a) {
        var title = _a.title, content = _a.content, visible = _a.visible, cursorX = _a.cursorX, cursorY = _a.cursorY;
        var style = {
            top: (cursorY + 30) + 'px',
            left: (cursorX + 15) + 'px',
        };
        var withContent = Boolean(title || content);
        var className = 'tooltip ' + ((visible && withContent)
            ? ' visible'
            : '');
        return (Object(preact_esm["b" /* h */])("aside", { class: className, style: style },
            Object(preact_esm["b" /* h */])("h2", null, title),
            Object(preact_esm["b" /* h */])("p", null, content)));
    };
    /**
     * Handle Store changes.
     */
    VisualTooltip.prototype.storeStateChanged = function (_a) {
        var _b = _a.visualData.tooltip, title = _b.title, content = _b.content, visible = _b.visible;
        if ((title === this.state.title)
            && (content === this.state.content)
            && (visible === this.state.visible)) {
            return;
        }
        if (visible !== this.state.visible) {
            if (visible) {
                document.addEventListener('mousemove', this.onMouseMove);
            }
            else {
                document.removeEventListener('mousemove', this.onMouseMove);
            }
        }
        this.setState({ title: title, content: content, visible: visible });
    };
    return VisualTooltip;
}(SubscribedComponent));
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/Visual.tsx













/**
 * Визуальный режим.
 */
var Visual_Visual = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](Visual, _super);
    function Visual() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * При нажатии на «Квартиры списком».
         */
        _this.onViewListClick = function () {
            dispatch(setVisualMode(false));
        };
        /**
         * При нажатии на «Показать/Скрыть фильтр».
         */
        _this.onToggleFilterClick = function (event) {
            dispatch(setFilterVisibility(!_this.state.filterVisible));
            event.currentTarget.blur();
        };
        return _this;
    }
    /**
     * Проверяет, внесены ли ручные изменения в параметры фильтра.
     *
     * @param filter Параметры фильтра
     */
    Visual.isFilterChanged = function (filter) {
        var changed = ((filter.squareTotal.from !== filter.squareTotal.min)
            || (filter.squareTotal.to !== filter.squareTotal.max)
            || (filter.totalCost.from !== filter.totalCost.min)
            || (filter.totalCost.to !== filter.totalCost.max));
        if (!changed) {
            for (var _i = 0, _a = filter.roomType; _i < _a.length; _i++) {
                var checkbox = _a[_i];
                if (checkbox.checked) {
                    changed = true;
                    break;
                }
            }
        }
        return changed;
    };
    /**
     * Render component.
     */
    Visual.prototype.render = function (_props, _a) {
        var overview = _a.overview, building = _a.building, section = _a.section, floor = _a.floor, step = _a.step, filterVisible = _a.filterVisible, filterChanged = _a.filterChanged;
        var stepElement;
        switch (step) {
            case 1 /* SECTION */:
                stepElement = (Object(preact_esm["b" /* h */])(VisualSection_VisualSection, tslib_es6["a" /* __assign */]({ building: building.building }, section)));
                break;
            case 2 /* FLOOR */:
                stepElement = (Object(preact_esm["b" /* h */])(VisualFloor_VisualFloor, tslib_es6["a" /* __assign */]({ building: building.building, section: section.section, background: section.image, floorsCount: section.map.length }, floor)));
                break;
            default:
                stepElement = (Object(preact_esm["b" /* h */])(VisualOverview_VisualOverview, tslib_es6["a" /* __assign */]({}, overview)));
                break;
        }
        return (Object(preact_esm["b" /* h */])("div", { class: "visual" },
            Object(preact_esm["b" /* h */])("div", { class: "controls" },
                Object(preact_esm["b" /* h */])("button", { type: "button", class: "view-list", onClick: this.onViewListClick }, "\u041A\u0432\u0430\u0440\u0442\u0438\u0440\u044B \u0441\u043F\u0438\u0441\u043A\u043E\u043C"),
                (step === 2 /* FLOOR */)
                    ? ''
                    : (Object(preact_esm["b" /* h */])("button", { type: "button", class: classJoin({
                            changed: (filterChanged && !filterVisible),
                        }, ['toggle-filter']), onClick: this.onToggleFilterClick }, filterVisible
                        ? (Object(preact_esm["b" /* h */])("svg", { role: "img", title: "Скрыть фильтр", width: "22", height: "22" },
                            Object(preact_esm["b" /* h */])("use", { xlinkHref: "/images/icons.svg#close" })))
                        : (Object(preact_esm["b" /* h */])("svg", { role: "img", title: "Показать фильтр", width: "28", height: "28" },
                            Object(preact_esm["b" /* h */])("use", { xlinkHref: "/images/icons.svg#options" })))))),
            stepElement,
            Object(preact_esm["b" /* h */])(VisualTooltip_VisualTooltip, null)));
    };
    /**
     * Handle Store changes.
     */
    Visual.prototype.storeStateChanged = function (state) {
        var _a = state.visualData, overview = _a.overview, building = _a.building, section = _a.section, floor = _a.floor, step = _a.step, filterVisible = _a.filterVisible, filter = state.filter;
        var filterChanged = Visual.isFilterChanged(filter);
        if ((overview === this.state.overview)
            && (building === this.state.building)
            && (section === this.state.section)
            && (floor === this.state.floor)
            && (step === this.state.step)
            && (filterVisible === this.state.filterVisible)
            && (filterChanged === this.state.filterChanged)) {
            return;
        }
        this.setState({
            overview: overview, building: building, section: section, floor: floor, step: step, filterVisible: filterVisible,
            filterChanged: filterChanged,
        });
        var query = visualStateToQueryString(filter, state.visualData);
        updateAddress(query);
    };
    return Visual;
}(SubscribedComponent));
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/MobileVisual.tsx









/**
 * Визуальный режим на мобильном устройстве.
 */
var MobileVisual_MobileVisual = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](MobileVisual, _super);
    function MobileVisual() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Rendered component mounted to the DOM.
     */
    MobileVisual.prototype.componentDidMount = function () {
        dispatch(setFilterVisibility(false));
    };
    /**
     * Render component.
     */
    MobileVisual.prototype.render = function (_props, _a) {
        var overview = _a.overview, building = _a.building, section = _a.section, floor = _a.floor, step = _a.step, filterVisible = _a.filterVisible, filterChanged = _a.filterChanged;
        var stepElement;
        switch (step) {
            case 2 /* FLOOR */:
                stepElement = (Object(preact_esm["b" /* h */])(MobileVisualFloor_MobileVisualFloor, tslib_es6["a" /* __assign */]({ building: building.building, section: section.section, background: section.image, floorsCount: section.map.length }, floor)));
                break;
            default:
                stepElement = (Object(preact_esm["b" /* h */])(MobileVisualOverview_MobileVisualOverview, tslib_es6["a" /* __assign */]({}, overview)));
                break;
        }
        return (Object(preact_esm["b" /* h */])("div", { class: "visual" },
            Object(preact_esm["b" /* h */])("div", { class: "controls" },
                Object(preact_esm["b" /* h */])("button", { type: "button", class: "view-list", onClick: this.onViewListClick }, "\u041A\u0432\u0430\u0440\u0442\u0438\u0440\u044B \u0441\u043F\u0438\u0441\u043A\u043E\u043C"),
                Object(preact_esm["b" /* h */])("button", { type: "button", class: classJoin({
                        changed: (filterChanged && !filterVisible),
                        opened: filterVisible,
                    }, ['toggle-filter']), onClick: this.onToggleFilterClick }, filterVisible
                    ? ('Применить фильтры')
                    : (Object(preact_esm["b" /* h */])("svg", { role: "img", title: "Показать фильтр", width: "23", height: "20" },
                        Object(preact_esm["b" /* h */])("use", { xlinkHref: "/images/icons.svg#options-small" }))))),
            stepElement));
    };
    return MobileVisual;
}(Visual_Visual));
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/MobileVisualVertical.tsx





/**
 * Вертикальный визуальный режим на мобильном.
 */
var MobileVisualVertical_MobileVisualVertical = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](MobileVisualVertical, _super);
    function MobileVisualVertical() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * При нажатии на «Квартиры списком».
         */
        _this.onViewListClick = function () {
            dispatch(setVisualMode(false));
        };
        return _this;
    }
    /**
     * Rendered component mounted to the DOM.
     */
    MobileVisualVertical.prototype.componentDidMount = function () {
        document.body.classList.add(MobileVisualVertical.CLASS_BODY_VERTICAL);
    };
    /**
     * Before component will be unmounted and destroyed.
     */
    MobileVisualVertical.prototype.componentWillUnmount = function () {
        document.body.classList.remove(MobileVisualVertical.CLASS_BODY_VERTICAL);
    };
    /**
     * Render component.
     */
    MobileVisualVertical.prototype.render = function (_a) {
        var background = _a.background;
        return (Object(preact_esm["b" /* h */])("div", { class: "visual vertical" },
            Object(preact_esm["b" /* h */])("img", { class: "background", src: background, alt: "" }),
            Object(preact_esm["b" /* h */])("p", { class: "message" },
                "\u041F\u0435\u0440\u0435\u0432\u0435\u0440\u043D\u0438\u0442\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u0432\u00A0\u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0434\u043B\u044F\u00A0\u0432\u044B\u0431\u043E\u0440\u0430 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u044B \u043D\u0430 \u043F\u043B\u0430\u043D\u0435, \u0438\u043B\u0438",
                ' ',
                Object(preact_esm["b" /* h */])("button", { type: "button", class: "view-list", onClick: this.onViewListClick }, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0438\u0437\u00A0\u0441\u043F\u0438\u0441\u043A\u0430"))));
    };
    /**
     * Класс, добавляемый на body при визуальном режиме.
     */
    MobileVisualVertical.CLASS_BODY_VERTICAL = 'vertical';
    return MobileVisualVertical;
}(preact_esm["a" /* Component */]));
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/RootVisual.tsx









/**
 * Корень визуального режима.
 */
var RootVisual_RootVisual = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](RootVisual, _super);
    /**
     * Корень визуального режима.
     */
    function RootVisual(props) {
        var _this = _super.call(this, props) || this;
        /**
         * При изменении размеров окна.
         */
        _this.onWindowResize = function () {
            var _a = _this.state, mobileMode = _a.mobileMode, verticalMode = _a.verticalMode;
            var ratio = window.innerWidth / window.innerHeight;
            var vertical = (ratio < 1);
            if (verticalMode !== vertical) {
                _this.setState({ verticalMode: vertical });
            }
            var mobile = (Object(Screen["b" /* getCurrentScreenMode */])() < 2 /* NOTEBOOK */);
            if (mobileMode !== mobile) {
                _this.setState({ mobileMode: mobile });
            }
        };
        _this.state = {
            overviewImage: '',
            mobileMode: false,
            verticalMode: false,
        };
        return _this;
    }
    /**
     * Rendered component mounted to the DOM.
     */
    RootVisual.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.onWindowResize);
        this.onWindowResize();
        if (this.state.overviewImage === '') {
            fetchVisualOverview('front');
        }
    };
    /**
     * Before component will be unmounted and destroyed.
     */
    RootVisual.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onWindowResize);
    };
    /**
     * Render component.
     */
    RootVisual.prototype.render = function (_props, _a) {
        var mobileMode = _a.mobileMode, verticalMode = _a.verticalMode, overviewImage = _a.overviewImage;
        return (mobileMode
            ? (verticalMode
                ? Object(preact_esm["b" /* h */])(MobileVisualVertical_MobileVisualVertical, { background: overviewImage })
                : (Object(preact_esm["b" /* h */])(MobileVisual_MobileVisual, null)))
            : (Object(preact_esm["b" /* h */])(Visual_Visual, null)));
    };
    /**
     * Handle Store changes.
     */
    RootVisual.prototype.storeStateChanged = function (_a) {
        var image = _a.visualData.overview.image;
        if (image === this.state.overviewImage) {
            return;
        }
        this.setState({ overviewImage: image });
    };
    return RootVisual;
}(SubscribedComponent));
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/VisualFilter.tsx






var VisualFilter_VisualFilter = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](VisualFilter, _super);
    function VisualFilter(props) {
        return _super.call(this, props) || this;
    }
    /**
     * Before render, return false to skip render.
     */
    VisualFilter.prototype.shouldComponentUpdate = function (_props, _a) {
        var filterVisible = _a.filterVisible;
        if ((filterVisible === this.state.filterVisible)) {
            return false;
        }
        return true;
    };
    /**
     * Render component.
     */
    VisualFilter.prototype.render = function (_props, _a) {
        var filterVisible = _a.filterVisible;
        return (Object(preact_esm["b" /* h */])("div", { class: classJoin({
                visible: filterVisible,
            }, ['filter']) },
            Object(preact_esm["b" /* h */])("h1", null, "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0443"),
            Object(preact_esm["b" /* h */])(FilterForm_FilterForm, null)));
    };
    /**
     * Handle Store changes.
     */
    VisualFilter.prototype.storeStateChanged = function (_a) {
        var filterVisible = _a.visualData.filterVisible;
        if ((filterVisible === this.state.filterVisible)) {
            return;
        }
        this.setState({ filterVisible: filterVisible });
    };
    return VisualFilter;
}(SubscribedComponent));
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/Root.tsx








/**
 * Application root
 */
var Root_Root = /** @class */ (function (_super) {
    tslib_es6["c" /* __extends */](Root, _super);
    function Root() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Rendered component mounted to the DOM.
     */
    Root.prototype.componentDidMount = function () {
        document.body.classList.add(Root.CLASS_BODY_READY);
    };
    /**
     * Render component.
     */
    Root.prototype.render = function (_props, _a) {
        var visualMode = _a.visualMode;
        return (Object(preact_esm["b" /* h */])("main", null, visualMode
            ? [
                Object(preact_esm["b" /* h */])(VisualFilter_VisualFilter, null),
                Object(preact_esm["b" /* h */])(RootVisual_RootVisual, null),
            ]
            : [
                Object(preact_esm["b" /* h */])(Filter_Filter, null),
                Object(preact_esm["b" /* h */])(RootList_RootList, null),
            ]));
    };
    /**
     * Handle Store changes.
     */
    Root.prototype.storeStateChanged = function (_a) {
        var visualMode = _a.common.visualMode;
        if (visualMode === this.state.visualMode) {
            return;
        }
        if (visualMode !== this.state.visualMode) {
            if (visualMode) {
                document.body.classList.add(Root.CLASS_BODY_VISUAL);
            }
            else {
                document.body.classList.remove(Root.CLASS_BODY_VISUAL);
            }
        }
        this.setState({ visualMode: visualMode });
    };
    /**
     * Класс, добавляемый на body при инициализации компонента.
     */
    Root.CLASS_BODY_READY = 'ready';
    /**
     * Класс, добавляемый на body при визуальном режиме.
     */
    Root.CLASS_BODY_VISUAL = 'visual';
    return Root;
}(SubscribedComponent));
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/asyncActions/fetchVisualBuilding.ts








// tslint:disable:max-line-length
var fetchVisualBuilding_data = {
    front: {
        building: '1',
        view: 'front',
        nextView: '',
        image: '/images/choose-visual/building/01.jpg',
        map: [
            {
                path: 'M748.1 596.3L477 689l-46.4-45.4L395 167l287.1 17.2 1.9.7v4.4l41.9 20.5 9.7.4 2.4.8 1 34.7z',
                target: '1.1',
                available: 1,
            },
            {
                path: 'M926.3 279.1v256.2l-178.2 61-9.1-350.6 131.7 6.3.6 15.1 25.7 11.2z',
                target: '1.2',
                available: 1,
            },
            {
                path: 'M1081 200l-4.2 283.8-150.5 51.5V279.1l-29.3-.8-25.7-11.2-.6-15.1 7.9.4 141.2-74.1v21.5l34.9 14.3z',
                target: '1.3',
                available: 1,
            },
            {
                path: 'M1252.4 197.4l-17.4 4.7.2 9.1-12 4.1-35-22.2-7.2 290.2-41.3-21-62.9 21.5L1081 200l-26.3 14.1-34.9-14.3v-21.5L1146 112l106.7 63.8z',
                target: '1.4',
                available: 1,
            },
            {
                path: 'M1415 272.7l-.7 23.4-38.2 14.9-21.9-14-12.8 267.9-160.4-81.6 7.2-290.2 35 22.2 12-4.1-.2-9.1 17.4-4.7.3-21.6z',
                target: '1.5',
                available: 1,
            },
            {
                path: 'M1555 323l-26 317-51 24-57 3-60.9-92.6-18.7-9.5 12.8-267.9 21.9 14 38.2-14.9.7-23.4 57.1 34.1 17.2.5 6.5 5.5z',
                target: '1.6',
                available: 1,
            },
        ],
    },
};
function fetchVisualBuilding(building, view) {
    return tslib_es6["b" /* __awaiter */](this, void 0, void 0, function () {
        var serverData, viewData, sections, _i, _a, item, _b, _c, item;
        return tslib_es6["d" /* __generator */](this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (building === '2') {
                        dispatch(setBuilding({
                            building: '2',
                            view: 'front',
                            nextView: '',
                            image: '/images/choose-visual/overview/01.jpg',
                            map: [],
                        }));
                        return [2 /*return*/];
                    }
                    dispatch(setLoading(true));
                    return [4 /*yield*/, sendVisualRequest({ buildingView: view, building: building })];
                case 1:
                    serverData = _d.sent();
                    if (!(view in fetchVisualBuilding_data)) {
                        view = 'front';
                    }
                    viewData = tslib_es6["a" /* __assign */]({}, fetchVisualBuilding_data[view]);
                    if (serverData.building && serverData.building.map) {
                        sections = new Map();
                        for (_i = 0, _a = serverData.building.map; _i < _a.length; _i++) {
                            item = _a[_i];
                            sections.set(item.target, item.available);
                        }
                        for (_b = 0, _c = viewData.map; _b < _c.length; _b++) {
                            item = _c[_b];
                            if (sections.has(item.target)) {
                                // tslint:disable-next-line:no-non-null-assertion
                                item.available = sections.get(item.target);
                            }
                            else {
                                item.available = 0;
                            }
                        }
                    }
                    // TODO:
                    dispatch(setFilter(serverData.filter));
                    dispatch(setBuilding(viewData));
                    dispatch(setLoading(false));
                    return [2 /*return*/];
            }
        });
    });
}
var debouncedFetchVisualBuilding = debounce(fetchVisualBuilding, 200);
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/utils/applyQueryString.ts













var CLASS_VISUAL_LOADING = 'visual-loading';
/**
 * Применяет строку запроса к состоянию приложения.
 *
 * @param query Строка запроса.
 */
function applyQueryString(query) {
    return tslib_es6["b" /* __awaiter */](this, void 0, void 0, function () {
        var normalizedQuery, parameters, view, state;
        return tslib_es6["d" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0:
                    document.body.classList.add(CLASS_VISUAL_LOADING);
                    normalizedQuery = ((query[0] === '?')
                        ? query.substr(1)
                        : query);
                    parameters = Object.create(null);
                    normalizedQuery
                        .split('&')
                        .map(function (pair) {
                        var _a = pair.split('='), key = _a[0], value = _a[1];
                        // Простой хак для массивов
                        if (key in parameters) {
                            parameters[key] += '&' + pair;
                        }
                        else {
                            parameters[key] = value;
                        }
                    });
                    if (!('overview' in parameters)) return [3 /*break*/, 7];
                    return [4 /*yield*/, fetchList(visualToListQuery(parameters))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, fetchVisualOverview(parameters.overview)];
                case 2:
                    _a.sent();
                    view = parameters.view || parameters.overview || 'front';
                    return [4 /*yield*/, fetchVisualBuilding('1', view)];
                case 3:
                    _a.sent();
                    if (!('section' in parameters)) return [3 /*break*/, 6];
                    dispatch(setStep(1 /* SECTION */));
                    return [4 /*yield*/, fetchVisualSection(parameters.section, view)];
                case 4:
                    _a.sent();
                    if (!('floor' in parameters)) return [3 /*break*/, 6];
                    dispatch(setStep(2 /* FLOOR */));
                    return [4 /*yield*/, fetchVisualFloor(Number(parameters.floor))];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [3 /*break*/, 9];
                case 7:
                    if ((normalizedQuery !== '')
                        || (parameters.mode === 'list')) {
                        dispatch(setVisualMode(false));
                    }
                    return [4 /*yield*/, fetchList(normalizedQuery)];
                case 8:
                    _a.sent();
                    _a.label = 9;
                case 9:
                    state = getState();
                    if (state.common.visualMode) {
                        updateAddress(visualStateToQueryString(state.filter, state.visualData));
                    }
                    else {
                        updateAddress(listStateToQueryString(state.filter));
                    }
                    document.body.classList.remove(CLASS_VISUAL_LOADING);
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Преобразует перечень параметров для визуального выборщика в строку запроса
 * списка.
 *
 * @param parameters Параметры.
 */
function visualToListQuery(parameters) {
    var parts = [];
    for (var _i = 0, _a = Object.keys(parameters); _i < _a.length; _i++) {
        var key = _a[_i];
        switch (key) {
            case 'overview':
            case 'building':
                break;
            case 'section':
                parts.push('section[]=' + parameters[key]);
                break;
            case 'floor':
                parts.push('floorFrom=' + parameters[key], 'floorTo=' + parameters[key]);
                break;
            default:
                parts.push(key + "=" + parameters[key]);
                break;
        }
    }
    return parts.join('&');
}
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/utils/getUtmParameters.ts

/**
 * Получает массив UTM-параметров из текущей строки запроса.
 */
function getUtmParameters() {
    return window.location.search.substr(1)
        .split('&')
        .filter(function (item) { return ((item.substr(0, 4) === 'utm_')
        || (item.substr(0, 10) === 'calltouch_')); });
}
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/utils/removeUtmParameters.ts

/**
 * Удаляет параметры UTM из строки запроса.
 *
 * @param query Строка запроса (может быть с `?` или без него).
 */
function removeUtmParameters(query) {
    var normalizedQuery;
    var prefix;
    if (query[0] === '?') {
        normalizedQuery = query.substr(1);
        prefix = '?';
    }
    else {
        normalizedQuery = query;
        prefix = '';
    }
    return prefix + normalizedQuery
        .split('&')
        .filter(function (item) { return ((item.substr(0, 4) !== 'utm_')
        && (item.substr(0, 10) !== 'calltouch_')); })
        .join('&');
}
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Choose/App/index.tsx

// Приложение выборщика.


// import 'preact/devtools';






/**
 * Приложение выборщика.
 */
function App_main() {
    return tslib_es6["b" /* __awaiter */](this, void 0, void 0, function () {
        var main, oldLoading;
        return tslib_es6["d" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0:
                    main = document.querySelector('main');
                    if (!main
                        || !main.parentElement) {
                        return [2 /*return*/];
                    }
                    oldLoading = false;
                    subscribe(function () {
                        var state = getState();
                        var loading = state.common.loading;
                        if (loading === oldLoading) {
                            return;
                        }
                        oldLoading = loading;
                        if (loading) {
                            document.body.classList.add('loading');
                        }
                        else {
                            document.body.classList.remove('loading');
                        }
                    });
                    setUtmParameters(getUtmParameters().join('&'));
                    return [4 /*yield*/, applyQueryString(removeUtmParameters(window.location.search))];
                case 1:
                    _a.sent();
                    Object(preact_esm["c" /* render */])(Object(preact_esm["b" /* h */])(Root_Root, null), main.parentElement, main);
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Module
 */


// CONCATENATED MODULE: ./app/Routes/Choose/Index/index.tsx
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Index_main; });


/**
 * Инициализация выборщика.
 */
function Index_main() {
    App_main();
}
/**
 * Module.
 */



/***/ }),

/***/ "U8YX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/small-redux/es5-esm/createStore.js
function createStore(reducer, preloadedState) {
    var state = preloadedState;
    var listeners = [];
    var getState = function () { return state; };
    var subscribe = function (listener) {
        var subscribed = true;
        listeners.push(listener);
        return function () {
            if (!subscribed) {
                return;
            }
            subscribed = false;
            var index = listeners.indexOf(listener);
            listeners.splice(index, 1);
        };
    };
    var dispatch = function (action) {
        state = reducer(state, action);
        for (var _i = 0, listeners_1 = listeners; _i < listeners_1.length; _i++) {
            var listener = listeners_1[_i];
            listener();
        }
    };
    dispatch({});
    return {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
    };
}

//# sourceMappingURL=createStore.js.map
// CONCATENATED MODULE: ../node_modules/small-redux/es5-esm/combineReducers.js
function combineReducers(reducers) {
    var reducerKeys = Object.keys(reducers);
    return function (state, action) {
        if (state === void 0) { state = {}; }
        var stateChanged = false;
        var nextState = {};
        for (var _i = 0, reducerKeys_1 = reducerKeys; _i < reducerKeys_1.length; _i++) {
            var key = reducerKeys_1[_i];
            var previousStateForKey = state[key];
            var nextStateForKey = reducers[key](previousStateForKey, action);
            nextState[key] = nextStateForKey;
            stateChanged = (stateChanged
                || (nextStateForKey !== previousStateForKey));
        }
        return (stateChanged ? nextState : state);
    };
}

//# sourceMappingURL=combineReducers.js.map
// CONCATENATED MODULE: ../node_modules/small-redux/es5-esm/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return createStore; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return combineReducers; });


//# sourceMappingURL=index.js.map

/***/ }),

/***/ "WHr8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return h; });
/* unused harmony export createElement */
/* unused harmony export cloneElement */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return render; });
/* unused harmony export rerender */
/* unused harmony export options */
/** Virtual DOM Node */
function VNode() {}

/** Global options
 *	@public
 *	@namespace options {Object}
 */
var options = {

	/** If `true`, `prop` changes trigger synchronous component updates.
  *	@name syncComponentUpdates
  *	@type Boolean
  *	@default true
  */
	//syncComponentUpdates: true,

	/** Processes all created VNodes.
  *	@param {VNode} vnode	A newly-created VNode to normalize/process
  */
	//vnode(vnode) { }

	/** Hook invoked after a component is mounted. */
	// afterMount(component) { }

	/** Hook invoked after the DOM is updated with a component's latest render. */
	// afterUpdate(component) { }

	/** Hook invoked immediately before a component is unmounted. */
	// beforeUnmount(component) { }
};

var stack = [];

var EMPTY_CHILDREN = [];

/** JSX/hyperscript reviver
*	Benchmarks: https://esbench.com/bench/57ee8f8e330ab09900a1a1a0
 *	@see http://jasonformat.com/wtf-is-jsx
 *	@public
 */
function h(nodeName, attributes) {
	var children = EMPTY_CHILDREN,
	    lastSimple,
	    child,
	    simple,
	    i;
	for (i = arguments.length; i-- > 2;) {
		stack.push(arguments[i]);
	}
	if (attributes && attributes.children != null) {
		if (!stack.length) stack.push(attributes.children);
		delete attributes.children;
	}
	while (stack.length) {
		if ((child = stack.pop()) && child.pop !== undefined) {
			for (i = child.length; i--;) {
				stack.push(child[i]);
			}
		} else {
			if (typeof child === 'boolean') child = null;

			if (simple = typeof nodeName !== 'function') {
				if (child == null) child = '';else if (typeof child === 'number') child = String(child);else if (typeof child !== 'string') simple = false;
			}

			if (simple && lastSimple) {
				children[children.length - 1] += child;
			} else if (children === EMPTY_CHILDREN) {
				children = [child];
			} else {
				children.push(child);
			}

			lastSimple = simple;
		}
	}

	var p = new VNode();
	p.nodeName = nodeName;
	p.children = children;
	p.attributes = attributes == null ? undefined : attributes;
	p.key = attributes == null ? undefined : attributes.key;

	// if a "vnode hook" is defined, pass every created VNode to it
	if (options.vnode !== undefined) options.vnode(p);

	return p;
}

/** Copy own-properties from `props` onto `obj`.
 *	@returns obj
 *	@private
 */
function extend(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }return obj;
}

/** Call a function asynchronously, as soon as possible.
 *	@param {Function} callback
 */
var defer = typeof Promise == 'function' ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;

function cloneElement(vnode, props) {
	return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
}

// DOM properties that should NOT have "px" added when numeric
var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;

/** Managed queue of dirty components to be re-rendered */

var items = [];

function enqueueRender(component) {
	if (!component._dirty && (component._dirty = true) && items.push(component) == 1) {
		(options.debounceRendering || defer)(rerender);
	}
}

function rerender() {
	var p,
	    list = items;
	items = [];
	while (p = list.pop()) {
		if (p._dirty) renderComponent(p);
	}
}

/** Check if two nodes are equivalent.
 *	@param {Element} node
 *	@param {VNode} vnode
 *	@private
 */
function isSameNodeType(node, vnode, hydrating) {
	if (typeof vnode === 'string' || typeof vnode === 'number') {
		return node.splitText !== undefined;
	}
	if (typeof vnode.nodeName === 'string') {
		return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
	}
	return hydrating || node._componentConstructor === vnode.nodeName;
}

/** Check if an Element has a given normalized name.
*	@param {Element} node
*	@param {String} nodeName
 */
function isNamedNode(node, nodeName) {
	return node.normalizedNodeName === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
}

/**
 * Reconstruct Component-style `props` from a VNode.
 * Ensures default/fallback values from `defaultProps`:
 * Own-properties of `defaultProps` not present in `vnode.attributes` are added.
 * @param {VNode} vnode
 * @returns {Object} props
 */
function getNodeProps(vnode) {
	var props = extend({}, vnode.attributes);
	props.children = vnode.children;

	var defaultProps = vnode.nodeName.defaultProps;
	if (defaultProps !== undefined) {
		for (var i in defaultProps) {
			if (props[i] === undefined) {
				props[i] = defaultProps[i];
			}
		}
	}

	return props;
}

/** Create an element with the given nodeName.
 *	@param {String} nodeName
 *	@param {Boolean} [isSvg=false]	If `true`, creates an element within the SVG namespace.
 *	@returns {Element} node
 */
function createNode(nodeName, isSvg) {
	var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
	node.normalizedNodeName = nodeName;
	return node;
}

/** Remove a child node from its parent if attached.
 *	@param {Element} node		The node to remove
 */
function removeNode(node) {
	var parentNode = node.parentNode;
	if (parentNode) parentNode.removeChild(node);
}

/** Set a named attribute on the given Node, with special behavior for some names and event handlers.
 *	If `value` is `null`, the attribute/handler will be removed.
 *	@param {Element} node	An element to mutate
 *	@param {string} name	The name/key to set, such as an event or attribute name
 *	@param {any} old	The last value that was set for this name/node pair
 *	@param {any} value	An attribute value, such as a function to be used as an event handler
 *	@param {Boolean} isSvg	Are we currently diffing inside an svg?
 *	@private
 */
function setAccessor(node, name, old, value, isSvg) {
	if (name === 'className') name = 'class';

	if (name === 'key') {
		// ignore
	} else if (name === 'ref') {
		if (old) old(null);
		if (value) value(node);
	} else if (name === 'class' && !isSvg) {
		node.className = value || '';
	} else if (name === 'style') {
		if (!value || typeof value === 'string' || typeof old === 'string') {
			node.style.cssText = value || '';
		}
		if (value && typeof value === 'object') {
			if (typeof old !== 'string') {
				for (var i in old) {
					if (!(i in value)) node.style[i] = '';
				}
			}
			for (var i in value) {
				node.style[i] = typeof value[i] === 'number' && IS_NON_DIMENSIONAL.test(i) === false ? value[i] + 'px' : value[i];
			}
		}
	} else if (name === 'dangerouslySetInnerHTML') {
		if (value) node.innerHTML = value.__html || '';
	} else if (name[0] == 'o' && name[1] == 'n') {
		var useCapture = name !== (name = name.replace(/Capture$/, ''));
		name = name.toLowerCase().substring(2);
		if (value) {
			if (!old) node.addEventListener(name, eventProxy, useCapture);
		} else {
			node.removeEventListener(name, eventProxy, useCapture);
		}
		(node._listeners || (node._listeners = {}))[name] = value;
	} else if (name !== 'list' && name !== 'type' && !isSvg && name in node) {
		setProperty(node, name, value == null ? '' : value);
		if (value == null || value === false) node.removeAttribute(name);
	} else {
		var ns = isSvg && name !== (name = name.replace(/^xlink\:?/, ''));
		if (value == null || value === false) {
			if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase());else node.removeAttribute(name);
		} else if (typeof value !== 'function') {
			if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value);else node.setAttribute(name, value);
		}
	}
}

/** Attempt to set a DOM property to the given value.
 *	IE & FF throw for certain property-value combinations.
 */
function setProperty(node, name, value) {
	try {
		node[name] = value;
	} catch (e) {}
}

/** Proxy an event to hooked event handlers
 *	@private
 */
function eventProxy(e) {
	return this._listeners[e.type](options.event && options.event(e) || e);
}

/** Queue of components that have been mounted and are awaiting componentDidMount */
var mounts = [];

/** Diff recursion count, used to track the end of the diff cycle. */
var diffLevel = 0;

/** Global flag indicating if the diff is currently within an SVG */
var isSvgMode = false;

/** Global flag indicating if the diff is performing hydration */
var hydrating = false;

/** Invoke queued componentDidMount lifecycle methods */
function flushMounts() {
	var c;
	while (c = mounts.pop()) {
		if (options.afterMount) options.afterMount(c);
		if (c.componentDidMount) c.componentDidMount();
	}
}

/** Apply differences in a given vnode (and it's deep children) to a real DOM Node.
 *	@param {Element} [dom=null]		A DOM node to mutate into the shape of the `vnode`
 *	@param {VNode} vnode			A VNode (with descendants forming a tree) representing the desired DOM structure
 *	@returns {Element} dom			The created/mutated element
 *	@private
 */
function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	// diffLevel having been 0 here indicates initial entry into the diff (not a subdiff)
	if (!diffLevel++) {
		// when first starting the diff, check if we're diffing an SVG or within an SVG
		isSvgMode = parent != null && parent.ownerSVGElement !== undefined;

		// hydration is indicated by the existing element to be diffed not having a prop cache
		hydrating = dom != null && !('__preactattr_' in dom);
	}

	var ret = idiff(dom, vnode, context, mountAll, componentRoot);

	// append the element if its a new parent
	if (parent && ret.parentNode !== parent) parent.appendChild(ret);

	// diffLevel being reduced to 0 means we're exiting the diff
	if (! --diffLevel) {
		hydrating = false;
		// invoke queued componentDidMount lifecycle methods
		if (!componentRoot) flushMounts();
	}

	return ret;
}

/** Internals of `diff()`, separated to allow bypassing diffLevel / mount flushing. */
function idiff(dom, vnode, context, mountAll, componentRoot) {
	var out = dom,
	    prevSvgMode = isSvgMode;

	// empty values (null, undefined, booleans) render as empty Text nodes
	if (vnode == null || typeof vnode === 'boolean') vnode = '';

	// Fast case: Strings & Numbers create/update Text nodes.
	if (typeof vnode === 'string' || typeof vnode === 'number') {

		// update if it's already a Text node:
		if (dom && dom.splitText !== undefined && dom.parentNode && (!dom._component || componentRoot)) {
			/* istanbul ignore if */ /* Browser quirk that can't be covered: https://github.com/developit/preact/commit/fd4f21f5c45dfd75151bd27b4c217d8003aa5eb9 */
			if (dom.nodeValue != vnode) {
				dom.nodeValue = vnode;
			}
		} else {
			// it wasn't a Text node: replace it with one and recycle the old Element
			out = document.createTextNode(vnode);
			if (dom) {
				if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
				recollectNodeTree(dom, true);
			}
		}

		out['__preactattr_'] = true;

		return out;
	}

	// If the VNode represents a Component, perform a component diff:
	var vnodeName = vnode.nodeName;
	if (typeof vnodeName === 'function') {
		return buildComponentFromVNode(dom, vnode, context, mountAll);
	}

	// Tracks entering and exiting SVG namespace when descending through the tree.
	isSvgMode = vnodeName === 'svg' ? true : vnodeName === 'foreignObject' ? false : isSvgMode;

	// If there's no existing element or it's the wrong type, create a new one:
	vnodeName = String(vnodeName);
	if (!dom || !isNamedNode(dom, vnodeName)) {
		out = createNode(vnodeName, isSvgMode);

		if (dom) {
			// move children into the replacement node
			while (dom.firstChild) {
				out.appendChild(dom.firstChild);
			} // if the previous Element was mounted into the DOM, replace it inline
			if (dom.parentNode) dom.parentNode.replaceChild(out, dom);

			// recycle the old element (skips non-Element node types)
			recollectNodeTree(dom, true);
		}
	}

	var fc = out.firstChild,
	    props = out['__preactattr_'],
	    vchildren = vnode.children;

	if (props == null) {
		props = out['__preactattr_'] = {};
		for (var a = out.attributes, i = a.length; i--;) {
			props[a[i].name] = a[i].value;
		}
	}

	// Optimization: fast-path for elements containing a single TextNode:
	if (!hydrating && vchildren && vchildren.length === 1 && typeof vchildren[0] === 'string' && fc != null && fc.splitText !== undefined && fc.nextSibling == null) {
		if (fc.nodeValue != vchildren[0]) {
			fc.nodeValue = vchildren[0];
		}
	}
	// otherwise, if there are existing or new children, diff them:
	else if (vchildren && vchildren.length || fc != null) {
			innerDiffNode(out, vchildren, context, mountAll, hydrating || props.dangerouslySetInnerHTML != null);
		}

	// Apply attributes/props from VNode to the DOM Element:
	diffAttributes(out, vnode.attributes, props);

	// restore previous SVG mode: (in case we're exiting an SVG namespace)
	isSvgMode = prevSvgMode;

	return out;
}

/** Apply child and attribute changes between a VNode and a DOM Node to the DOM.
 *	@param {Element} dom			Element whose children should be compared & mutated
 *	@param {Array} vchildren		Array of VNodes to compare to `dom.childNodes`
 *	@param {Object} context			Implicitly descendant context object (from most recent `getChildContext()`)
 *	@param {Boolean} mountAll
 *	@param {Boolean} isHydrating	If `true`, consumes externally created elements similar to hydration
 */
function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
	var originalChildren = dom.childNodes,
	    children = [],
	    keyed = {},
	    keyedLen = 0,
	    min = 0,
	    len = originalChildren.length,
	    childrenLen = 0,
	    vlen = vchildren ? vchildren.length : 0,
	    j,
	    c,
	    f,
	    vchild,
	    child;

	// Build up a map of keyed children and an Array of unkeyed children:
	if (len !== 0) {
		for (var i = 0; i < len; i++) {
			var _child = originalChildren[i],
			    props = _child['__preactattr_'],
			    key = vlen && props ? _child._component ? _child._component.__key : props.key : null;
			if (key != null) {
				keyedLen++;
				keyed[key] = _child;
			} else if (props || (_child.splitText !== undefined ? isHydrating ? _child.nodeValue.trim() : true : isHydrating)) {
				children[childrenLen++] = _child;
			}
		}
	}

	if (vlen !== 0) {
		for (var i = 0; i < vlen; i++) {
			vchild = vchildren[i];
			child = null;

			// attempt to find a node based on key matching
			var key = vchild.key;
			if (key != null) {
				if (keyedLen && keyed[key] !== undefined) {
					child = keyed[key];
					keyed[key] = undefined;
					keyedLen--;
				}
			}
			// attempt to pluck a node of the same type from the existing children
			else if (!child && min < childrenLen) {
					for (j = min; j < childrenLen; j++) {
						if (children[j] !== undefined && isSameNodeType(c = children[j], vchild, isHydrating)) {
							child = c;
							children[j] = undefined;
							if (j === childrenLen - 1) childrenLen--;
							if (j === min) min++;
							break;
						}
					}
				}

			// morph the matched/found/created DOM child to match vchild (deep)
			child = idiff(child, vchild, context, mountAll);

			f = originalChildren[i];
			if (child && child !== dom && child !== f) {
				if (f == null) {
					dom.appendChild(child);
				} else if (child === f.nextSibling) {
					removeNode(f);
				} else {
					dom.insertBefore(child, f);
				}
			}
		}
	}

	// remove unused keyed children:
	if (keyedLen) {
		for (var i in keyed) {
			if (keyed[i] !== undefined) recollectNodeTree(keyed[i], false);
		}
	}

	// remove orphaned unkeyed children:
	while (min <= childrenLen) {
		if ((child = children[childrenLen--]) !== undefined) recollectNodeTree(child, false);
	}
}

/** Recursively recycle (or just unmount) a node and its descendants.
 *	@param {Node} node						DOM node to start unmount/removal from
 *	@param {Boolean} [unmountOnly=false]	If `true`, only triggers unmount lifecycle, skips removal
 */
function recollectNodeTree(node, unmountOnly) {
	var component = node._component;
	if (component) {
		// if node is owned by a Component, unmount that component (ends up recursing back here)
		unmountComponent(component);
	} else {
		// If the node's VNode had a ref function, invoke it with null here.
		// (this is part of the React spec, and smart for unsetting references)
		if (node['__preactattr_'] != null && node['__preactattr_'].ref) node['__preactattr_'].ref(null);

		if (unmountOnly === false || node['__preactattr_'] == null) {
			removeNode(node);
		}

		removeChildren(node);
	}
}

/** Recollect/unmount all children.
 *	- we use .lastChild here because it causes less reflow than .firstChild
 *	- it's also cheaper than accessing the .childNodes Live NodeList
 */
function removeChildren(node) {
	node = node.lastChild;
	while (node) {
		var next = node.previousSibling;
		recollectNodeTree(node, true);
		node = next;
	}
}

/** Apply differences in attributes from a VNode to the given DOM Element.
 *	@param {Element} dom		Element with attributes to diff `attrs` against
 *	@param {Object} attrs		The desired end-state key-value attribute pairs
 *	@param {Object} old			Current/previous attributes (from previous VNode or element's prop cache)
 */
function diffAttributes(dom, attrs, old) {
	var name;

	// remove attributes no longer present on the vnode by setting them to undefined
	for (name in old) {
		if (!(attrs && attrs[name] != null) && old[name] != null) {
			setAccessor(dom, name, old[name], old[name] = undefined, isSvgMode);
		}
	}

	// add new & update changed attributes
	for (name in attrs) {
		if (name !== 'children' && name !== 'innerHTML' && (!(name in old) || attrs[name] !== (name === 'value' || name === 'checked' ? dom[name] : old[name]))) {
			setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
		}
	}
}

/** Retains a pool of Components for re-use, keyed on component name.
 *	Note: since component names are not unique or even necessarily available, these are primarily a form of sharding.
 *	@private
 */
var components = {};

/** Reclaim a component for later re-use by the recycler. */
function collectComponent(component) {
	var name = component.constructor.name;
	(components[name] || (components[name] = [])).push(component);
}

/** Create a component. Normalizes differences between PFC's and classful Components. */
function createComponent(Ctor, props, context) {
	var list = components[Ctor.name],
	    inst;

	if (Ctor.prototype && Ctor.prototype.render) {
		inst = new Ctor(props, context);
		Component.call(inst, props, context);
	} else {
		inst = new Component(props, context);
		inst.constructor = Ctor;
		inst.render = doRender;
	}

	if (list) {
		for (var i = list.length; i--;) {
			if (list[i].constructor === Ctor) {
				inst.nextBase = list[i].nextBase;
				list.splice(i, 1);
				break;
			}
		}
	}
	return inst;
}

/** The `.render()` method for a PFC backing instance. */
function doRender(props, state, context) {
	return this.constructor(props, context);
}

/** Set a component's `props` (generally derived from JSX attributes).
 *	@param {Object} props
 *	@param {Object} [opts]
 *	@param {boolean} [opts.renderSync=false]	If `true` and {@link options.syncComponentUpdates} is `true`, triggers synchronous rendering.
 *	@param {boolean} [opts.render=true]			If `false`, no render will be triggered.
 */
function setComponentProps(component, props, opts, context, mountAll) {
	if (component._disable) return;
	component._disable = true;

	if (component.__ref = props.ref) delete props.ref;
	if (component.__key = props.key) delete props.key;

	if (!component.base || mountAll) {
		if (component.componentWillMount) component.componentWillMount();
	} else if (component.componentWillReceiveProps) {
		component.componentWillReceiveProps(props, context);
	}

	if (context && context !== component.context) {
		if (!component.prevContext) component.prevContext = component.context;
		component.context = context;
	}

	if (!component.prevProps) component.prevProps = component.props;
	component.props = props;

	component._disable = false;

	if (opts !== 0) {
		if (opts === 1 || options.syncComponentUpdates !== false || !component.base) {
			renderComponent(component, 1, mountAll);
		} else {
			enqueueRender(component);
		}
	}

	if (component.__ref) component.__ref(component);
}

/** Render a Component, triggering necessary lifecycle events and taking High-Order Components into account.
 *	@param {Component} component
 *	@param {Object} [opts]
 *	@param {boolean} [opts.build=false]		If `true`, component will build and store a DOM node if not already associated with one.
 *	@private
 */
function renderComponent(component, opts, mountAll, isChild) {
	if (component._disable) return;

	var props = component.props,
	    state = component.state,
	    context = component.context,
	    previousProps = component.prevProps || props,
	    previousState = component.prevState || state,
	    previousContext = component.prevContext || context,
	    isUpdate = component.base,
	    nextBase = component.nextBase,
	    initialBase = isUpdate || nextBase,
	    initialChildComponent = component._component,
	    skip = false,
	    rendered,
	    inst,
	    cbase;

	// if updating
	if (isUpdate) {
		component.props = previousProps;
		component.state = previousState;
		component.context = previousContext;
		if (opts !== 2 && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === false) {
			skip = true;
		} else if (component.componentWillUpdate) {
			component.componentWillUpdate(props, state, context);
		}
		component.props = props;
		component.state = state;
		component.context = context;
	}

	component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	component._dirty = false;

	if (!skip) {
		rendered = component.render(props, state, context);

		// context to pass to the child, can be updated via (grand-)parent component
		if (component.getChildContext) {
			context = extend(extend({}, context), component.getChildContext());
		}

		var childComponent = rendered && rendered.nodeName,
		    toUnmount,
		    base;

		if (typeof childComponent === 'function') {
			// set up high order component link

			var childProps = getNodeProps(rendered);
			inst = initialChildComponent;

			if (inst && inst.constructor === childComponent && childProps.key == inst.__key) {
				setComponentProps(inst, childProps, 1, context, false);
			} else {
				toUnmount = inst;

				component._component = inst = createComponent(childComponent, childProps, context);
				inst.nextBase = inst.nextBase || nextBase;
				inst._parentComponent = component;
				setComponentProps(inst, childProps, 0, context, false);
				renderComponent(inst, 1, mountAll, true);
			}

			base = inst.base;
		} else {
			cbase = initialBase;

			// destroy high order component link
			toUnmount = initialChildComponent;
			if (toUnmount) {
				cbase = component._component = null;
			}

			if (initialBase || opts === 1) {
				if (cbase) cbase._component = null;
				base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, true);
			}
		}

		if (initialBase && base !== initialBase && inst !== initialChildComponent) {
			var baseParent = initialBase.parentNode;
			if (baseParent && base !== baseParent) {
				baseParent.replaceChild(base, initialBase);

				if (!toUnmount) {
					initialBase._component = null;
					recollectNodeTree(initialBase, false);
				}
			}
		}

		if (toUnmount) {
			unmountComponent(toUnmount);
		}

		component.base = base;
		if (base && !isChild) {
			var componentRef = component,
			    t = component;
			while (t = t._parentComponent) {
				(componentRef = t).base = base;
			}
			base._component = componentRef;
			base._componentConstructor = componentRef.constructor;
		}
	}

	if (!isUpdate || mountAll) {
		mounts.unshift(component);
	} else if (!skip) {
		// Ensure that pending componentDidMount() hooks of child components
		// are called before the componentDidUpdate() hook in the parent.
		// Note: disabled as it causes duplicate hooks, see https://github.com/developit/preact/issues/750
		// flushMounts();

		if (component.componentDidUpdate) {
			component.componentDidUpdate(previousProps, previousState, previousContext);
		}
		if (options.afterUpdate) options.afterUpdate(component);
	}

	if (component._renderCallbacks != null) {
		while (component._renderCallbacks.length) {
			component._renderCallbacks.pop().call(component);
		}
	}

	if (!diffLevel && !isChild) flushMounts();
}

/** Apply the Component referenced by a VNode to the DOM.
 *	@param {Element} dom	The DOM node to mutate
 *	@param {VNode} vnode	A Component-referencing VNode
 *	@returns {Element} dom	The created/mutated element
 *	@private
 */
function buildComponentFromVNode(dom, vnode, context, mountAll) {
	var c = dom && dom._component,
	    originalComponent = c,
	    oldDom = dom,
	    isDirectOwner = c && dom._componentConstructor === vnode.nodeName,
	    isOwner = isDirectOwner,
	    props = getNodeProps(vnode);
	while (c && !isOwner && (c = c._parentComponent)) {
		isOwner = c.constructor === vnode.nodeName;
	}

	if (c && isOwner && (!mountAll || c._component)) {
		setComponentProps(c, props, 3, context, mountAll);
		dom = c.base;
	} else {
		if (originalComponent && !isDirectOwner) {
			unmountComponent(originalComponent);
			dom = oldDom = null;
		}

		c = createComponent(vnode.nodeName, props, context);
		if (dom && !c.nextBase) {
			c.nextBase = dom;
			// passing dom/oldDom as nextBase will recycle it if unused, so bypass recycling on L229:
			oldDom = null;
		}
		setComponentProps(c, props, 1, context, mountAll);
		dom = c.base;

		if (oldDom && dom !== oldDom) {
			oldDom._component = null;
			recollectNodeTree(oldDom, false);
		}
	}

	return dom;
}

/** Remove a component from the DOM and recycle it.
 *	@param {Component} component	The Component instance to unmount
 *	@private
 */
function unmountComponent(component) {
	if (options.beforeUnmount) options.beforeUnmount(component);

	var base = component.base;

	component._disable = true;

	if (component.componentWillUnmount) component.componentWillUnmount();

	component.base = null;

	// recursively tear down & recollect high-order component children:
	var inner = component._component;
	if (inner) {
		unmountComponent(inner);
	} else if (base) {
		if (base['__preactattr_'] && base['__preactattr_'].ref) base['__preactattr_'].ref(null);

		component.nextBase = base;

		removeNode(base);
		collectComponent(component);

		removeChildren(base);
	}

	if (component.__ref) component.__ref(null);
}

/** Base Component class.
 *	Provides `setState()` and `forceUpdate()`, which trigger rendering.
 *	@public
 *
 *	@example
 *	class MyFoo extends Component {
 *		render(props, state) {
 *			return <div />;
 *		}
 *	}
 */
function Component(props, context) {
	this._dirty = true;

	/** @public
  *	@type {object}
  */
	this.context = context;

	/** @public
  *	@type {object}
  */
	this.props = props;

	/** @public
  *	@type {object}
  */
	this.state = this.state || {};
}

extend(Component.prototype, {

	/** Returns a `boolean` indicating if the component should re-render when receiving the given `props` and `state`.
  *	@param {object} nextProps
  *	@param {object} nextState
  *	@param {object} nextContext
  *	@returns {Boolean} should the component re-render
  *	@name shouldComponentUpdate
  *	@function
  */

	/** Update component state by copying properties from `state` to `this.state`.
  *	@param {object} state		A hash of state properties to update with new values
  *	@param {function} callback	A function to be called once component state is updated
  */
	setState: function setState(state, callback) {
		var s = this.state;
		if (!this.prevState) this.prevState = extend({}, s);
		extend(s, typeof state === 'function' ? state(s, this.props) : state);
		if (callback) (this._renderCallbacks = this._renderCallbacks || []).push(callback);
		enqueueRender(this);
	},


	/** Immediately perform a synchronous re-render of the component.
  *	@param {function} callback		A function to be called after component is re-rendered.
  *	@private
  */
	forceUpdate: function forceUpdate(callback) {
		if (callback) (this._renderCallbacks = this._renderCallbacks || []).push(callback);
		renderComponent(this, 2);
	},


	/** Accepts `props` and `state`, and returns a new Virtual DOM tree to build.
  *	Virtual DOM is generally constructed via [JSX](http://jasonformat.com/wtf-is-jsx).
  *	@param {object} props		Props (eg: JSX attributes) received from parent element/component
  *	@param {object} state		The component's current state
  *	@param {object} context		Context object (if a parent component has provided context)
  *	@returns VNode
  */
	render: function render() {}
});

/** Render JSX into a `parent` Element.
 *	@param {VNode} vnode		A (JSX) VNode to render
 *	@param {Element} parent		DOM element to render into
 *	@param {Element} [merge]	Attempt to re-use an existing DOM tree rooted at `merge`
 *	@public
 *
 *	@example
 *	// render a div into <body>:
 *	render(<div id="hello">hello!</div>, document.body);
 *
 *	@example
 *	// render a "Thing" component into #foo:
 *	const Thing = ({ name }) => <span>{ name }</span>;
 *	render(<Thing name="one" />, document.querySelector('#foo'));
 */
function render(vnode, parent, merge) {
  return diff(merge, vnode, {}, false, parent, false);
}

var preact = {
	h: h,
	createElement: h,
	cloneElement: cloneElement,
	Component: Component,
	render: render,
	rerender: rerender,
	options: options
};


/* unused harmony default export */ var _unused_webpack_default_export = (preact);
//# sourceMappingURL=preact.esm.js.map


/***/ }),

/***/ "nuYK":
/***/ (function(module, exports) {

module.exports = {"paths":["M45.4 1.1l1.8 1.5L49.1.5l10.6 9.3-1.9 2.1 1.8 1.7-12.3 14.5L44.9 43l-19.5-3.3 2.9-19.5z","M50.8 61.2l-12.5 15-8-7.3-23.2 8.7L.5 59.4l23.3-8.5 1.6-11.2L44.9 43l-2.3 11z","M50.8 61.2l10.3 9L89.5 75l-3 19.3L53 88.5 38.3 76.2z","M89.5 75l30-11.1.7 1.9 5.4-1.9 6.2 15.9-37.6 14.1-7.7.4z","M151.8 47.1v-6.5h-14v6.5l-12.2 16.8 6.2 15.7h4v2h18v-2h3.4l6.3-15.7z","M199.5 75l-30-11.1-.7 1.9-5.4-1.9-6.2 15.9 37.6 14.1 7.7.4z","M238.2 61.2l-10.3 9-28.4 4.8 3 19.3 33.5-5.8 14.7-12.3z","M238.2 61.2l12.5 15 8-7.3 23.2 8.7 6.6-18.2-23.3-8.5-1.6-11.2-19.5 3.3 2.3 11z","M243.6 1.1l-1.8 1.5-1.9-2.1-10.6 9.3 1.9 2.1-1.8 1.7 12.3 14.5 2.4 14.9 19.5-3.3-2.9-19.5z"],"labels":["translate(37 27)","translate(30 62)","translate(62 85)","translate(106 82)","translate(142 68)","translate(177 83)","translate(220 85)","translate(254 62)","translate(246 27)"]}

/***/ }),

/***/ "z2Rp":
/***/ (function(module, exports, __webpack_require__) {

var invariant = __webpack_require__("2gTp");

var hasOwnProperty = Object.prototype.hasOwnProperty;
var splice = Array.prototype.splice;

var assign = Object.assign || /* istanbul ignore next */ function assign(target, source) {
  getAllKeys(source).forEach(function(key) {
    if (hasOwnProperty.call(source, key)) {
      target[key] = source[key];
    }
  });
  return target;
};

var getAllKeys = typeof Object.getOwnPropertySymbols === 'function' ?
  function(obj) { return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj)) } :
  /* istanbul ignore next */ function(obj) { return Object.keys(obj) };

function copy(object) {
  if (object instanceof Array) {
    return object.slice();
  } else if (object && typeof object === 'object') {
    return assign(new object.constructor(), object);
  } else {
    return object;
  }
}

function newContext() {
  var commands = assign({}, defaultCommands);
  update.extend = function(directive, fn) {
    commands[directive] = fn;
  };

  return update;

  function update(object, spec) {
    if (!(Array.isArray(object) && Array.isArray(spec))) {
      invariant(
        !Array.isArray(spec),
        'update(): You provided an invalid spec to update(). The spec may ' +
        'not contain an array except as the value of $set, $push, $unshift, ' +
        '$splice or any custom command allowing an array value.'
      );
    }

    invariant(
      typeof spec === 'object' && spec !== null,
      'update(): You provided an invalid spec to update(). The spec and ' +
      'every included key path must be plain objects containing one of the ' +
      'following commands: %s.',
      Object.keys(commands).join(', ')
    );

    var nextObject = object;
    var specKeys = getAllKeys(spec);
    var index, key;
    getAllKeys(spec).forEach(function(key) {
      if (hasOwnProperty.call(commands, key)) {
        nextObject = commands[key](spec[key], nextObject, spec, object);
      } else {
        var nextValueForKey = update(object[key], spec[key]);
        if (nextValueForKey !== nextObject[key]) {
          if (nextObject === object) {
            nextObject = copy(object);
          }
          nextObject[key] = nextValueForKey;
        }
      }
    })
    return nextObject;
  }

}

var defaultCommands = {
  $push: function(value, original, spec) {
    invariantPushAndUnshift(original, spec, '$push');
    return original.concat(value);
  },
  $unshift: function(value, original, spec) {
    invariantPushAndUnshift(original, spec, '$unshift');
    return value.concat(original);
  },
  $splice: function(value, nextObject, spec, object) {
    var originalValue = nextObject === object ? copy(object) : nextObject;
    invariantSplices(originalValue, spec);
    value.forEach(function(args) {
      invariantSplice(args);
      splice.apply(originalValue, args);
    });
    return originalValue;
  },
  $set: function(value, original, spec) {
    invariantSet(spec);
    return value;
  },
  $unset: function(value, nextObject, spec, object) {
    invariant(
      Array.isArray(value),
      'update(): expected spec of $unset to be an array; got %s. ' +
      'Did you forget to wrap the key(s) in an array?',
      value
    );
    var originalValue = nextObject;
    value.forEach(function(key) {
      if (Object.hasOwnProperty.call(originalValue, key)) {
        if (nextObject === object) nextObject = copy(object);
        delete nextObject[key];
      }
    });
    return nextObject;
  },
  $merge: function(value, nextObject, spec, object) {
    var nextObject = nextObject;
    invariantMerge(nextObject, value);
    getAllKeys(value).forEach(function(key) {
      if (value[key] !== nextObject[key]) {
        if (nextObject === object) nextObject = copy(object);
        nextObject[key] = value[key];
      }
    });
    return nextObject;
  },
  $apply: function(value, original) {
    invariantApply(value);
    return value(original);
  }
};

module.exports = newContext();
module.exports.newContext = newContext;

// invariants

function invariantPushAndUnshift(value, spec, command) {
  invariant(
    Array.isArray(value),
    'update(): expected target of %s to be an array; got %s.',
    command,
    value
  );
  var specValue = spec[command];
  invariant(
    Array.isArray(specValue),
    'update(): expected spec of %s to be an array; got %s. ' +
    'Did you forget to wrap your parameter in an array?',
    command,
    specValue
  );
}

function invariantSplices(value, spec) {
  invariant(
    Array.isArray(value),
    'Expected $splice target to be an array; got %s',
    value
  );
  invariantSplice(spec['$splice']);
}

function invariantSplice(value) {
  invariant(
    Array.isArray(value),
    'update(): expected spec of $splice to be an array of arrays; got %s. ' +
    'Did you forget to wrap your parameters in an array?',
    value
  );
}

function invariantApply(fn) {
  invariant(
    typeof fn === 'function',
    'update(): expected spec of $apply to be a function; got %s.',
    fn
  );
}

function invariantSet(spec) {
  invariant(
    Object.keys(spec).length === 1,
    'Cannot have more than one key in an object with $set'
  );
}

function invariantMerge(target, specValue) {
  invariant(
    specValue && typeof specValue === 'object',
    'update(): $merge expects a spec of type \'object\'; got %s',
    specValue
  );
  invariant(
    target && typeof target === 'object',
    'update(): $merge expects a target of type \'object\'; got %s',
    target
  );
}


/***/ })

});


// WEBPACK FOOTER //
// chunk-choose-apartment.c58717c55a8d9fb27cd2.js